var _g, _defs, _defs2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationLoginRightNoAnim(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1127,
    height: 620,
    viewBox: "0 0 1127 620",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration-login-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 657",
    d: "M161 1L1310 619",
    stroke: "url(#paint0_linear_608_71031)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 658",
    d: "M67 140L955 618.5",
    stroke: "url(#paint1_linear_608_71031)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 659",
    d: "M1 342L520 617",
    stroke: "url(#paint2_linear_608_71031)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    className: "right-loading-cart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 481819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M859.57 440.773C860.541 441.335 860.541 442.255 859.57 442.868C858.599 443.43 856.964 443.43 855.942 442.868C854.971 442.306 854.971 441.386 855.942 440.773C856.913 440.211 858.548 440.211 859.57 440.773Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M869.022 435.306C869.993 435.868 869.993 436.788 869.022 437.401C868.051 437.963 866.416 437.963 865.394 437.401C864.372 436.839 864.423 435.919 865.394 435.306C866.365 434.744 868 434.744 869.022 435.306Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M878.423 429.892C879.394 430.454 879.394 431.374 878.423 431.987C877.452 432.549 875.817 432.549 874.795 431.987C873.825 431.425 873.825 430.505 874.795 429.892C875.766 429.33 877.401 429.33 878.423 429.892Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M887.876 424.422C888.847 424.984 888.847 425.903 887.876 426.516C886.906 427.079 885.271 427.079 884.249 426.516C883.278 425.954 883.278 425.035 884.249 424.422C885.219 423.859 886.855 423.859 887.876 424.422Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M897.278 419.007C898.249 419.57 898.249 420.489 897.278 421.102C896.307 421.664 894.672 421.664 893.65 421.102C892.679 420.54 892.679 419.621 893.65 419.007C894.621 418.445 896.256 418.445 897.278 419.007Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M906.68 413.539C907.651 414.101 907.651 415.02 906.68 415.634C905.709 416.196 904.074 416.196 903.052 415.634C902.082 415.072 902.082 414.152 903.052 413.539C904.023 412.977 905.658 412.977 906.68 413.539Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M850.168 435.306C851.139 435.868 851.139 436.788 850.168 437.401C849.197 437.963 847.562 437.963 846.54 437.401C845.518 436.839 845.57 435.919 846.54 435.306C847.511 434.744 849.146 434.744 850.168 435.306Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M859.57 429.892C860.541 430.454 860.541 431.374 859.57 431.987C858.599 432.549 856.964 432.549 855.942 431.987C854.971 431.425 854.971 430.505 855.942 429.892C856.913 429.33 858.548 429.33 859.57 429.892Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M869.023 424.422C869.994 424.984 869.994 425.903 869.023 426.516C868.052 427.079 866.417 427.079 865.395 426.516C864.424 425.954 864.424 425.035 865.395 424.422C866.366 423.859 868.001 423.859 869.023 424.422Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M878.425 419.007C879.396 419.57 879.396 420.489 878.425 421.102C877.454 421.664 875.819 421.664 874.797 421.102C873.775 420.54 873.826 419.621 874.797 419.007C875.768 418.445 877.403 418.445 878.425 419.007Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M887.876 413.539C888.847 414.101 888.847 415.02 887.876 415.634C886.906 416.196 885.271 416.196 884.249 415.634C883.278 415.072 883.278 414.152 884.249 413.539C885.219 412.977 886.855 412.977 887.876 413.539Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M897.278 408.125C898.249 408.687 898.249 409.606 897.278 410.22C896.307 410.782 894.672 410.782 893.65 410.22C892.679 409.658 892.679 408.738 893.65 408.125C894.621 407.563 896.256 407.563 897.278 408.125Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M840.715 429.892C841.686 430.454 841.686 431.374 840.715 431.987C839.744 432.549 838.109 432.549 837.087 431.987C836.117 431.425 836.117 430.505 837.087 429.892C838.058 429.33 839.693 429.33 840.715 429.892Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M850.166 424.422C851.137 424.984 851.137 425.903 850.166 426.516C849.196 427.079 847.561 427.079 846.539 426.516C845.568 425.954 845.568 425.035 846.539 424.422C847.509 423.859 849.145 423.859 850.166 424.422Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M859.571 419.007C860.541 419.57 860.541 420.489 859.571 421.102C858.6 421.716 856.965 421.664 855.943 421.102C854.921 420.54 854.972 419.621 855.943 419.007C856.914 418.445 858.549 418.445 859.571 419.007Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M869.023 413.539C869.994 414.101 869.994 415.02 869.023 415.634C868.052 416.196 866.417 416.196 865.395 415.634C864.424 415.072 864.424 414.152 865.395 413.539C866.366 412.977 868.001 412.977 869.023 413.539Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M878.423 408.125C879.394 408.687 879.394 409.606 878.423 410.22C877.452 410.782 875.817 410.782 874.795 410.22C873.825 409.658 873.825 408.738 874.795 408.125C875.766 407.563 877.401 407.563 878.423 408.125Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M887.876 402.66C888.847 403.222 888.847 404.142 887.876 404.755C886.906 405.317 885.271 405.317 884.249 404.755C883.278 404.193 883.278 403.273 884.249 402.66C885.219 402.098 886.855 402.098 887.876 402.66Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M831.313 424.422C832.284 424.984 832.284 425.903 831.313 426.516C830.342 427.079 828.707 427.079 827.685 426.516C826.714 425.954 826.714 425.035 827.685 424.422C828.656 423.859 830.291 423.859 831.313 424.422Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M840.715 419.007C841.686 419.57 841.686 420.489 840.715 421.102C839.744 421.664 838.109 421.664 837.087 421.102C836.117 420.54 836.117 419.621 837.087 419.007C838.058 418.445 839.693 418.445 840.715 419.007Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M850.166 413.539C851.137 414.101 851.137 415.02 850.166 415.634C849.196 416.196 847.561 416.196 846.539 415.634C845.568 415.072 845.568 414.152 846.539 413.539C847.509 412.977 849.145 412.977 850.166 413.539Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M859.57 408.125C860.541 408.687 860.541 409.606 859.57 410.22C858.599 410.782 856.964 410.782 855.942 410.22C854.971 409.658 854.971 408.738 855.942 408.125C856.913 407.563 858.548 407.563 859.57 408.125Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M869.022 402.66C869.993 403.222 869.993 404.142 869.022 404.755C868.051 405.317 866.416 405.317 865.394 404.755C864.372 404.193 864.423 403.273 865.394 402.66C866.365 402.098 868 402.098 869.022 402.66Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M878.425 397.242C879.396 397.804 879.396 398.724 878.425 399.337C877.454 399.95 875.819 399.899 874.797 399.337C873.775 398.775 873.826 397.855 874.797 397.242C875.768 396.68 877.403 396.68 878.425 397.242Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M820.072 421.51C821.483 421.51 822.627 420.847 822.627 420.029C822.627 419.21 821.483 418.547 820.072 418.547C818.661 418.547 817.518 419.21 817.518 420.029C817.518 420.847 818.661 421.51 820.072 421.51Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M831.313 413.539C832.284 414.101 832.284 415.02 831.313 415.634C830.342 416.196 828.707 416.196 827.685 415.634C826.714 415.072 826.714 414.152 827.685 413.539C828.656 412.977 830.291 412.977 831.313 413.539Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M840.715 408.125C841.686 408.687 841.686 409.606 840.715 410.22C839.744 410.782 838.109 410.782 837.087 410.22C836.117 409.658 836.117 408.738 837.087 408.125C838.058 407.563 839.693 407.563 840.715 408.125Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M850.166 402.66C851.137 403.222 851.137 404.142 850.166 404.755C849.196 405.317 847.561 405.317 846.539 404.755C845.568 404.193 845.568 403.273 846.539 402.66C847.509 402.098 849.145 402.098 850.166 402.66Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M859.57 397.242C860.541 397.804 860.541 398.724 859.57 399.337C858.599 399.899 856.964 399.899 855.942 399.337C854.971 398.775 854.971 397.855 855.942 397.242C856.913 396.68 858.548 396.68 859.57 397.242Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M812.356 413.492C813.327 414.054 813.327 414.974 812.356 415.587C811.385 416.149 809.75 416.149 808.728 415.587C807.757 415.025 807.757 414.105 808.728 413.492C809.699 412.93 811.334 412.93 812.356 413.492Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M819.971 410.577C821.382 410.577 822.526 409.913 822.526 409.095C822.526 408.277 821.382 407.613 819.971 407.613C818.56 407.613 817.416 408.277 817.416 409.095C817.416 409.913 818.56 410.577 819.971 410.577Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M829.424 405.11C830.835 405.11 831.979 404.447 831.979 403.628C831.979 402.81 830.835 402.146 829.424 402.146C828.013 402.146 826.869 402.81 826.869 403.628C826.869 404.447 828.013 405.11 829.424 405.11Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M935.446 461.724C936.416 462.286 936.416 463.206 935.446 463.819C934.475 464.381 932.84 464.381 931.818 463.819C930.796 463.257 930.847 462.337 931.818 461.724C932.789 461.162 934.424 461.162 935.446 461.724Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M944.849 456.259C945.82 456.821 945.82 457.741 944.849 458.354C943.878 458.916 942.243 458.916 941.221 458.354C940.25 457.792 940.25 456.872 941.221 456.259C942.192 455.646 943.827 455.697 944.849 456.259Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M954.301 450.84C955.272 451.402 955.272 452.321 954.301 452.934C953.33 453.497 951.695 453.497 950.673 452.934C949.703 452.372 949.703 451.453 950.673 450.84C951.644 450.277 953.279 450.277 954.301 450.84Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M963.704 445.371C964.674 445.933 964.674 446.853 963.704 447.466C962.733 448.028 961.098 448.028 960.076 447.466C959.105 446.904 959.105 445.984 960.076 445.371C961.047 444.809 962.682 444.809 963.704 445.371Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M916.592 461.724C917.563 462.286 917.563 463.206 916.592 463.819C915.621 464.381 913.986 464.381 912.964 463.819C911.994 463.257 911.994 462.337 912.964 461.724C913.935 461.162 915.57 461.162 916.592 461.724Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M925.994 456.259C926.964 456.821 926.964 457.741 925.994 458.354C925.023 458.916 923.388 458.916 922.366 458.354C921.395 457.792 921.395 456.872 922.366 456.259C923.337 455.646 924.972 455.697 925.994 456.259Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M935.448 450.84C936.419 451.402 936.419 452.321 935.448 452.934C934.477 453.497 932.842 453.497 931.82 452.934C930.849 452.372 930.849 451.453 931.82 450.84C932.791 450.277 934.426 450.277 935.448 450.84Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M944.85 445.371C945.821 445.933 945.821 446.853 944.85 447.466C943.879 448.028 942.244 448.028 941.222 447.466C940.2 446.904 940.251 445.984 941.222 445.371C942.193 444.809 943.828 444.809 944.85 445.371Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M952.461 442.46C953.872 442.46 955.016 441.796 955.016 440.978C955.016 440.159 953.872 439.496 952.461 439.496C951.05 439.496 949.906 440.159 949.906 440.978C949.906 441.796 951.05 442.46 952.461 442.46Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M897.636 461.671C898.607 462.233 898.607 463.153 897.636 463.766C896.665 464.328 895.03 464.328 894.008 463.766C892.986 463.204 893.037 462.285 894.008 461.671C894.979 461.058 896.614 461.109 897.636 461.671Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M907.088 456.207C908.059 456.769 908.059 457.688 907.088 458.302C906.118 458.864 904.482 458.864 903.461 458.302C902.49 457.74 902.49 456.82 903.461 456.207C904.431 455.645 906.066 455.645 907.088 456.207Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M916.491 450.789C917.462 451.351 917.462 452.27 916.491 452.884C915.52 453.446 913.885 453.446 912.863 452.884C911.892 452.322 911.892 451.402 912.863 450.789C913.834 450.227 915.469 450.227 916.491 450.789Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M925.943 445.324C926.914 445.886 926.914 446.806 925.943 447.419C924.972 447.981 923.337 447.981 922.315 447.419C921.344 446.857 921.344 445.937 922.315 445.324C923.286 444.762 924.921 444.762 925.943 445.324Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M935.346 439.906C936.317 440.468 936.317 441.388 935.346 442.001C934.375 442.563 932.74 442.563 931.718 442.001C930.748 441.439 930.748 440.519 931.718 439.906C932.689 439.344 934.324 439.344 935.346 439.906Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M944.797 434.439C945.768 435.001 945.768 435.921 944.797 436.534C943.827 437.096 942.191 437.096 941.17 436.534C940.199 435.972 940.199 435.052 941.17 434.439C942.14 433.877 943.775 433.877 944.797 434.439Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M888.234 456.207C889.205 456.769 889.205 457.688 888.234 458.302C887.263 458.864 885.628 458.864 884.606 458.302C883.635 457.74 883.635 456.82 884.606 456.207C885.577 455.645 887.212 455.645 888.234 456.207Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M897.636 450.789C898.607 451.351 898.607 452.27 897.636 452.884C896.665 453.446 895.03 453.446 894.008 452.884C892.986 452.322 893.037 451.402 894.008 450.789C894.979 450.227 896.614 450.227 897.636 450.789Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M907.088 445.324C908.059 445.886 908.059 446.806 907.088 447.419C906.118 448.032 904.482 447.981 903.461 447.419C902.49 446.857 902.49 445.937 903.461 445.324C904.431 444.762 906.066 444.762 907.088 445.324Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M916.491 439.906C917.462 440.468 917.462 441.388 916.491 442.001C915.52 442.563 913.885 442.563 912.863 442.001C911.892 441.439 911.892 440.519 912.863 439.906C913.834 439.293 915.469 439.344 916.491 439.906Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M925.943 434.439C926.914 435.001 926.914 435.921 925.943 436.534C924.972 437.096 923.337 437.096 922.315 436.534C921.344 435.972 921.344 435.052 922.315 434.439C923.286 433.877 924.921 433.877 925.943 434.439Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M935.346 429.021C936.317 429.583 936.317 430.503 935.346 431.116C934.375 431.678 932.74 431.678 931.718 431.116C930.748 430.554 930.748 429.634 931.718 429.021C932.689 428.459 934.324 428.459 935.346 429.021Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M878.781 450.789C879.752 451.351 879.752 452.27 878.781 452.884C877.81 453.446 876.175 453.446 875.153 452.884C874.182 452.322 874.182 451.402 875.153 450.789C876.124 450.227 877.759 450.227 878.781 450.789Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M888.234 445.324C889.205 445.886 889.205 446.806 888.234 447.419C887.263 447.981 885.628 447.981 884.606 447.419C883.635 446.857 883.635 445.937 884.606 445.324C885.577 444.762 887.212 444.762 888.234 445.324Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M897.635 439.906C898.606 440.468 898.606 441.388 897.635 442.001C896.664 442.563 895.029 442.563 894.007 442.001C893.037 441.439 893.037 440.519 894.007 439.906C894.978 439.293 896.613 439.344 897.635 439.906Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M907.088 434.439C908.059 435.001 908.059 435.921 907.088 436.534C906.118 437.096 904.482 437.096 903.461 436.534C902.49 435.972 902.49 435.052 903.461 434.439C904.431 433.877 906.066 433.877 907.088 434.439Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M916.49 429.021C917.461 429.583 917.461 430.503 916.49 431.116C915.52 431.729 913.885 431.678 912.863 431.116C911.841 430.554 911.892 429.634 912.863 429.021C913.833 428.459 915.469 428.459 916.49 429.021Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M925.943 423.556C926.914 424.118 926.914 425.038 925.943 425.651C924.972 426.213 923.337 426.213 922.315 425.651C921.344 425.089 921.344 424.169 922.315 423.556C923.286 422.994 924.921 422.994 925.943 423.556Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M869.379 445.32C870.35 445.882 870.35 446.802 869.379 447.415C868.409 447.977 866.773 447.977 865.752 447.415C864.781 446.853 864.781 445.933 865.752 445.32C866.722 444.707 868.357 444.758 869.379 445.32Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M878.781 439.906C879.752 440.468 879.752 441.388 878.781 442.001C877.81 442.563 876.175 442.563 875.153 442.001C874.182 441.439 874.182 440.519 875.153 439.906C876.124 439.344 877.759 439.344 878.781 439.906Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M888.234 434.439C889.205 435.001 889.205 435.921 888.234 436.534C887.263 437.096 885.628 437.096 884.606 436.534C883.635 435.972 883.635 435.052 884.606 434.439C885.577 433.877 887.212 433.877 888.234 434.439Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M897.636 429.021C898.607 429.583 898.607 430.503 897.636 431.116C896.665 431.729 895.03 431.678 894.008 431.116C892.986 430.554 893.037 429.634 894.008 429.021C894.979 428.459 896.614 428.459 897.636 429.021Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M907.088 423.556C908.059 424.118 908.059 425.038 907.088 425.651C906.118 426.213 904.482 426.213 903.461 425.651C902.49 425.089 902.49 424.169 903.461 423.556C904.431 422.994 906.066 422.994 907.088 423.556Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M916.491 418.138C917.462 418.7 917.462 419.62 916.491 420.233C915.52 420.795 913.885 420.795 912.863 420.233C911.892 419.671 911.892 418.751 912.863 418.138C913.834 417.576 915.469 417.576 916.491 418.138Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M916.133 408.177C917.104 408.739 917.104 409.659 916.133 410.272C915.162 410.834 913.527 410.834 912.505 410.272C911.535 409.71 911.535 408.791 912.505 408.177C913.476 407.615 915.111 407.615 916.133 408.177Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M925.584 402.759C926.555 403.321 926.555 404.241 925.584 404.854C924.614 405.416 922.979 405.416 921.957 404.854C920.986 404.292 920.986 403.373 921.957 402.759C922.927 402.197 924.563 402.197 925.584 402.759Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M934.987 397.289C935.958 397.851 935.958 398.77 934.987 399.384C934.016 399.997 932.381 399.946 931.359 399.384C930.388 398.822 930.388 397.902 931.359 397.289C932.33 396.727 933.965 396.727 934.987 397.289Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M903.102 402.759C904.073 402.197 905.708 402.197 906.73 402.759C907.752 403.321 907.752 404.241 906.73 404.854C905.759 405.416 904.124 405.416 903.102 404.854C902.08 404.292 902.08 403.373 903.102 402.759Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M916.132 397.292C917.103 397.855 917.103 398.774 916.132 399.387C915.161 399.949 913.526 399.949 912.504 399.387C911.482 398.825 911.533 397.906 912.504 397.292C913.475 396.679 915.11 396.73 916.132 397.292Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M893.702 397.289C894.673 396.727 896.308 396.727 897.33 397.289C898.352 397.851 898.352 398.77 897.33 399.384C896.359 399.946 894.724 399.946 893.702 399.384C892.68 398.822 892.68 397.902 893.702 397.289Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M969.526 440.009C970.497 439.447 972.132 439.447 973.154 440.009C974.176 440.571 974.176 441.491 973.154 442.104C972.183 442.666 970.548 442.666 969.526 442.104C968.504 441.542 968.504 440.623 969.526 440.009Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M982.608 434.591C983.578 435.154 983.578 436.073 982.608 436.686C981.637 437.248 980.002 437.248 978.98 436.686C977.958 436.124 978.009 435.205 978.98 434.591C979.951 434.029 981.586 434.029 982.608 434.591Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M992.01 429.125C992.981 429.687 992.981 430.606 992.01 431.219C991.039 431.782 989.404 431.782 988.382 431.219C987.412 430.657 987.412 429.738 988.382 429.125C989.353 428.511 990.988 428.562 992.01 429.125Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M960.127 434.591C961.098 434.029 962.733 434.029 963.755 434.591C964.777 435.154 964.777 436.073 963.755 436.686C962.784 437.248 961.149 437.248 960.127 436.686C959.105 436.124 959.105 435.205 960.127 434.591Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M973.157 429.125C974.128 429.687 974.128 430.606 973.157 431.22C972.186 431.782 970.551 431.782 969.529 431.22C968.558 430.658 968.558 429.738 969.529 429.125C970.5 428.563 972.135 428.563 973.157 429.125Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M982.61 423.711C983.581 424.273 983.581 425.192 982.61 425.806C981.639 426.368 980.004 426.368 978.982 425.806C978.011 425.243 978.011 424.324 978.982 423.711C979.953 423.149 981.588 423.149 982.61 423.711Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M990.222 420.745C991.633 420.745 992.777 420.081 992.777 419.263C992.777 418.445 991.633 417.781 990.222 417.781C988.811 417.781 987.667 418.445 987.667 419.263C987.667 420.081 988.811 420.745 990.222 420.745Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M950.623 429.074C951.594 428.512 953.229 428.512 954.251 429.074C955.273 429.636 955.273 430.556 954.251 431.169C953.28 431.731 951.645 431.731 950.623 431.169C949.601 430.607 949.601 429.687 950.623 429.074Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M963.653 423.609C964.624 424.171 964.624 425.091 963.653 425.704C962.682 426.266 961.047 426.266 960.025 425.704C959.054 425.142 959.054 424.222 960.025 423.609C960.996 423.047 962.631 423.047 963.653 423.609Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M973.053 418.191C974.024 418.753 974.024 419.673 973.053 420.286C972.082 420.848 970.447 420.848 969.425 420.286C968.455 419.724 968.455 418.804 969.425 418.191C970.396 417.629 972.031 417.629 973.053 418.191Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M982.506 412.722C983.477 413.284 983.477 414.204 982.506 414.817C981.535 415.379 979.9 415.379 978.879 414.817C977.908 414.255 977.908 413.335 978.879 412.722C979.849 412.16 981.484 412.16 982.506 412.722Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M991.907 407.308C992.878 407.87 992.878 408.79 991.907 409.403C990.936 409.965 989.301 409.965 988.279 409.403C987.308 408.841 987.308 407.921 988.279 407.308C989.25 406.746 990.885 406.746 991.907 407.308Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M941.17 423.656C942.141 423.094 943.776 423.094 944.798 423.656C945.819 424.218 945.819 425.138 944.798 425.751C943.827 426.313 942.192 426.313 941.17 425.751C940.148 425.189 940.148 424.269 941.17 423.656Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M954.25 418.191C955.221 418.753 955.221 419.673 954.25 420.286C953.28 420.848 951.645 420.848 950.623 420.286C949.652 419.724 949.652 418.804 950.623 418.191C951.593 417.629 953.229 417.629 954.25 418.191Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M963.653 412.722C964.624 413.284 964.624 414.204 963.653 414.817C962.682 415.379 961.047 415.379 960.025 414.817C959.054 414.255 959.054 413.335 960.025 412.722C960.996 412.16 962.631 412.16 963.653 412.722Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M973.053 407.308C974.024 407.87 974.024 408.79 973.053 409.403C972.082 409.965 970.447 409.965 969.425 409.403C968.455 408.841 968.455 407.921 969.425 407.308C970.396 406.746 972.031 406.746 973.053 407.308Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M982.506 401.84C983.477 402.402 983.477 403.321 982.506 403.934C981.535 404.496 979.9 404.496 978.879 403.934C977.908 403.372 977.908 402.453 978.879 401.84C979.849 401.277 981.484 401.277 982.506 401.84Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M931.768 418.191C932.739 417.629 934.374 417.629 935.396 418.191C936.418 418.753 936.418 419.673 935.396 420.286C934.425 420.848 932.79 420.848 931.768 420.286C930.746 419.724 930.746 418.804 931.768 418.191Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M944.797 412.722C945.768 413.284 945.768 414.204 944.797 414.817C943.827 415.379 942.191 415.379 941.17 414.817C940.199 414.255 940.199 413.335 941.17 412.722C942.14 412.16 943.775 412.16 944.797 412.722Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M954.25 407.308C955.221 407.87 955.221 408.79 954.25 409.403C953.28 409.965 951.645 409.965 950.623 409.403C949.652 408.841 949.652 407.921 950.623 407.308C951.593 406.746 953.229 406.746 954.25 407.308Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M963.653 401.84C964.624 402.402 964.624 403.321 963.653 403.934C962.682 404.496 961.047 404.496 960.025 403.934C959.054 403.372 959.054 402.453 960.025 401.84C960.996 401.277 962.631 401.277 963.653 401.84Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M973.053 396.422C974.024 396.984 974.024 397.903 973.053 398.516C972.082 399.079 970.447 399.079 969.425 398.516C968.455 397.954 968.455 397.035 969.425 396.422C970.396 395.859 972.031 395.859 973.053 396.422Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M922.315 412.773C923.286 412.211 924.921 412.211 925.943 412.773C926.965 413.335 926.965 414.255 925.943 414.868C924.972 415.43 923.337 415.43 922.315 414.868C921.293 414.306 921.293 413.386 922.315 412.773Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M935.397 407.308C936.368 407.87 936.368 408.79 935.397 409.403C934.426 409.965 932.791 409.965 931.769 409.403C930.798 408.841 930.798 407.921 931.769 407.308C932.74 406.746 934.375 406.746 935.397 407.308Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M944.797 401.84C945.768 402.402 945.768 403.321 944.797 403.934C943.827 404.496 942.191 404.496 941.17 403.934C940.199 403.372 940.199 402.453 941.17 401.84C942.14 401.277 943.775 401.277 944.797 401.84Z",
    fill: "#A5A5A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M954.25 396.422C955.221 396.984 955.221 397.903 954.25 398.516C953.28 399.079 951.645 399.079 950.623 398.516C949.652 397.954 949.652 397.035 950.623 396.422C951.593 395.859 953.229 395.859 954.25 396.422Z",
    fill: "#A5A5A5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M912.145 350.051L910.038 348.822C908.746 348.075 906.965 348.177 904.997 349.312L907.105 350.541C909.073 349.405 910.854 349.304 912.145 350.051Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M899.995 366.083L902.103 367.312C900.835 366.573 900.042 365.002 900.042 362.769C900.026 358.281 903.192 352.797 907.105 350.541L904.997 349.312C901.084 351.576 897.918 357.052 897.934 361.54C897.934 363.773 898.727 365.344 899.995 366.083Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M907.105 350.543C903.192 352.806 900.026 358.282 900.042 362.771C900.058 367.266 903.239 369.079 907.152 366.815C911.056 364.56 914.222 359.083 914.215 354.588C914.199 350.099 911.018 348.279 907.113 350.535L907.105 350.543Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M907.112 354.219C904.965 355.456 903.231 358.458 903.238 360.924C903.238 363.39 904.988 364.378 907.135 363.141C909.274 361.904 911.009 358.902 911.001 356.444C911.001 353.986 909.251 352.99 907.104 354.227L907.112 354.219Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M907.121 357.34C906.475 357.714 905.954 358.616 905.962 359.355C905.962 360.094 906.491 360.389 907.129 360.016C907.774 359.643 908.288 358.748 908.288 358.009C908.288 357.27 907.759 356.975 907.121 357.34Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M987.666 257.416L971.223 266.976C971.472 266.828 971.822 266.852 972.203 267.077L988.646 257.517C988.265 257.292 987.915 257.276 987.666 257.416Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M973.175 270.329L989.619 260.769C989.868 260.629 990.016 260.318 990.024 259.89C990.024 259.011 989.409 257.945 988.655 257.51L972.211 267.07C972.973 267.505 973.588 268.571 973.58 269.45C973.58 269.885 973.424 270.189 973.175 270.329Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M972.203 267.07C971.441 266.626 970.818 266.984 970.818 267.855C970.818 268.726 971.433 269.792 972.195 270.235C972.957 270.671 973.572 270.321 973.572 269.45C973.572 268.571 972.957 267.505 972.203 267.07Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M926.099 223.199L909.655 232.759C909.904 232.611 910.254 232.635 910.635 232.86L927.079 223.301C926.698 223.075 926.348 223.059 926.099 223.199Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M911.599 236.12L928.043 226.56C928.292 226.42 928.44 226.109 928.447 225.681C928.447 224.802 927.833 223.736 927.078 223.301L910.635 232.861C911.397 233.296 912.011 234.362 912.004 235.241C912.004 235.676 911.848 235.98 911.599 236.12Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M910.636 232.853C909.873 232.409 909.251 232.767 909.251 233.638C909.251 234.51 909.865 235.575 910.628 236.019C911.39 236.454 912.004 236.104 912.004 235.233C912.004 234.354 911.39 233.288 910.636 232.853Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M830.945 408.94L891.5 443.904C894.021 445.359 898.104 445.359 900.625 443.904L976.465 400.111C978.977 398.665 978.347 397.093 978.347 395.227C978.324 396.152 977.694 397.07 976.473 397.778L900.632 441.571C898.112 443.025 894.028 443.025 891.508 441.571L830.953 406.606C829.7 405.883 829.07 404.926 829.07 403.97C829.063 405.339 828.456 407.493 830.953 408.94H830.945Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M829.062 403.939V403.97C829.062 404.927 829.693 405.883 830.945 406.607L891.5 441.571C894.021 443.026 898.104 443.026 900.625 441.571L976.465 397.778C977.686 397.07 978.316 396.153 978.339 395.227C978.386 394.247 977.756 393.259 976.465 392.512L915.909 357.556C913.389 356.101 909.305 356.101 906.785 357.556L830.945 401.341C829.708 402.064 829.078 402.998 829.062 403.939Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M909.11 220.133V360.954C909.11 361.242 909.297 361.53 909.678 361.748C910.433 362.191 911.669 362.191 912.424 361.748C912.805 361.53 913 361.234 913 360.947V220.125C913 220.413 912.805 220.708 912.424 220.926C911.662 221.37 910.433 221.37 909.678 220.926C909.305 220.708 909.11 220.421 909.11 220.133Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M909.687 219.333C908.925 219.776 908.925 220.484 909.679 220.927C910.434 221.37 911.67 221.37 912.425 220.927C913.187 220.484 913.187 219.776 912.433 219.333C911.678 218.889 910.441 218.889 909.687 219.333Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M973.337 376.87L913.031 341.828C912.782 341.681 912.432 341.704 912.051 341.922L972.357 376.964C972.739 376.746 973.089 376.723 973.337 376.87Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M911.071 345.189L971.377 380.231C971.128 380.091 970.973 379.78 970.973 379.344C970.973 378.473 971.587 377.407 972.349 376.964L912.043 341.922C911.281 342.357 910.666 343.423 910.666 344.302C910.666 344.738 910.822 345.041 911.071 345.189Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M972.349 376.972C971.587 377.408 970.973 378.474 970.973 379.353C970.973 380.232 971.595 380.582 972.357 380.138C973.12 379.703 973.734 378.637 973.734 377.758C973.734 376.887 973.112 376.537 972.349 376.972Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M973.337 361.314L913.031 326.272C912.782 326.124 912.432 326.147 912.051 326.365L972.357 361.407C972.739 361.189 973.089 361.166 973.337 361.314Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M911.071 329.632L971.377 364.674C971.128 364.534 970.973 364.223 970.973 363.788C970.973 362.916 971.587 361.851 972.349 361.407L912.043 326.365C911.281 326.801 910.666 327.866 910.666 328.745C910.666 329.181 910.822 329.484 911.071 329.632Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M972.349 361.414C971.587 361.849 970.973 362.915 970.973 363.794C970.973 364.673 971.595 365.023 972.357 364.58C973.12 364.144 973.734 363.078 973.734 362.199C973.734 361.328 973.112 360.978 972.349 361.414Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M973.337 345.757L913.031 310.715C912.782 310.567 912.432 310.591 912.051 310.808L972.357 345.85C972.739 345.633 973.089 345.609 973.337 345.757Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M911.071 314.068L971.377 349.11C971.128 348.97 970.973 348.659 970.973 348.223C970.973 347.352 971.587 346.286 972.349 345.843L912.043 310.801C911.281 311.236 910.666 312.302 910.666 313.181C910.666 313.617 910.822 313.92 911.071 314.068Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M972.349 345.851C971.587 346.287 970.973 347.353 970.973 348.231C970.973 349.11 971.595 349.46 972.357 349.017C973.12 348.582 973.734 347.516 973.734 346.637C973.734 345.766 973.112 345.416 972.349 345.851Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M973.337 267.964L913.031 232.922C912.782 232.774 912.432 232.798 912.051 233.015L972.357 268.057C972.739 267.84 973.089 267.816 973.337 267.964Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M911.071 236.283L971.377 271.325C971.128 271.185 970.973 270.874 970.973 270.438C970.973 269.567 971.587 268.501 972.349 268.058L912.043 233.016C911.281 233.451 910.666 234.517 910.666 235.396C910.666 235.831 910.822 236.135 911.071 236.283Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M972.349 268.066C971.587 268.502 970.973 269.567 970.973 270.446C970.973 271.325 971.595 271.675 972.357 271.232C973.12 270.796 973.734 269.731 973.734 268.852C973.734 267.981 973.112 267.631 972.349 268.066Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M970.141 254.555V395.376C970.141 395.664 970.327 395.952 970.708 396.17C971.463 396.613 972.7 396.613 973.454 396.17C973.835 395.952 974.03 395.656 974.03 395.369V254.547C974.03 254.835 973.835 255.13 973.454 255.348C972.692 255.791 971.463 255.791 970.708 255.348C970.335 255.13 970.141 254.842 970.141 254.555Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M970.716 253.745C969.954 254.188 969.954 254.896 970.708 255.339C971.463 255.783 972.7 255.783 973.454 255.339C974.216 254.896 974.216 254.188 973.462 253.745C972.707 253.301 971.471 253.301 970.716 253.745Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M909.11 420.889L948.796 397.554V350.883L909.11 374.218V420.889Z",
    fill: "#222222",
    stroke: "url(#paint3_linear_608_71031)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M930.438 407.768L927.471 409.513V364.002L930.438 362.257V407.768Z",
    fill: "#222222",
    stroke: "url(#paint4_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M909.61 399.013V395.506L948.296 372.759V376.266L909.61 399.013Z",
    fill: "#222222",
    stroke: "url(#paint5_linear_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M909.111 374.218L948.796 350.882L909.111 327.547L869.425 350.882L909.111 374.218Z",
    fill: "#222222",
    stroke: "url(#paint6_linear_608_71031)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M891.252 338.627L929.952 361.382L926.971 363.136L888.271 340.38L891.252 338.627Z",
    fill: "#222222",
    stroke: "url(#paint7_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M888.271 361.382L926.971 338.627L929.952 340.38L891.252 363.136L888.271 361.382Z",
    fill: "#222222",
    stroke: "url(#paint8_linear_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M869.425 397.554L909.111 420.889V374.218L869.425 350.883V397.554Z",
    fill: "#222222",
    stroke: "url(#paint9_linear_608_71031)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M887.785 362.257L890.752 364.002V409.513L887.785 407.768V362.257Z",
    fill: "#222222",
    stroke: "url(#paint10_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M869.925 372.759L908.611 395.506V399.013L869.925 376.266V372.759Z",
    fill: "#222222",
    stroke: "url(#paint11_linear_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M885.283 363.177V379.077L871.504 371.127V355.212L885.283 363.177Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_137"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-140-inside-1_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.3 368.695L879.517 366.507V362.133L883.3 364.32V368.695ZM879.856 366.315L882.96 368.104V364.527L879.856 362.739V366.315Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 368.695L879.517 366.507V362.133L883.3 364.32V368.695ZM879.856 366.315L882.96 368.104V364.527L879.856 362.739V366.315Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 368.695L882.799 369.56L884.3 370.428V368.695H883.3ZM879.517 366.507H878.517V367.084L879.016 367.373L879.517 366.507ZM879.517 362.133L880.017 361.267L878.517 360.4V362.133H879.517ZM883.3 364.32H884.3V363.743L883.8 363.454L883.3 364.32ZM879.856 366.315H878.856V366.893L879.357 367.182L879.856 366.315ZM882.96 368.104L882.461 368.97L883.96 369.834V368.104H882.96ZM882.96 364.527H883.96V363.949L883.459 363.661L882.96 364.527ZM879.856 362.739L880.356 361.872L878.856 361.008V362.739H879.856ZM883.8 367.829L880.017 365.642L879.016 367.373L882.799 369.56L883.8 367.829ZM880.517 366.507V362.133H878.517V366.507H880.517ZM879.016 362.999L882.799 365.186L883.8 363.454L880.017 361.267L879.016 362.999ZM882.3 364.32V368.695H884.3V364.32H882.3ZM879.357 367.182L882.461 368.97L883.459 367.237L880.356 365.449L879.357 367.182ZM883.96 368.104V364.527H881.96V368.104H883.96ZM883.459 363.661L880.356 361.872L879.357 363.605L882.461 365.393L883.459 363.661ZM878.856 362.739V366.315H880.856V362.739H878.856Z",
    fill: "#222222",
    mask: "url(#path-140-inside-1_608_71031)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M875.735 361.712V362.553L875.021 362.14V361.3L875.735 361.712Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_139"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-143-inside-2_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 362.622L877.447 362.119V361.129L878.304 361.631V362.622Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 362.622L877.447 362.119V361.129L878.304 361.631V362.622Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 362.622L877.799 363.484L879.304 364.367V362.622H878.304ZM877.447 362.119H876.447V362.692L876.941 362.982L877.447 362.119ZM877.447 361.129L877.953 360.266L876.447 359.384V361.129H877.447ZM878.304 361.631H879.304V361.058L878.81 360.769L878.304 361.631ZM878.81 361.759L877.953 361.256L876.941 362.982L877.799 363.484L878.81 361.759ZM878.447 362.119V361.129H876.447V362.119H878.447ZM876.942 361.992L877.799 362.494L878.81 360.769L877.953 360.266L876.942 361.992ZM877.304 361.631V362.622H879.304V361.631H877.304Z",
    fill: "#222222",
    mask: "url(#path-143-inside-2_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_140"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-145-inside-3_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 364.114L878.305 363.611V362.621L879.162 363.124V364.114Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 364.114L878.305 363.611V362.621L879.162 363.124V364.114Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 364.114L878.656 364.977L880.162 365.859V364.114H879.162ZM878.305 363.611H877.305V364.184L877.799 364.474L878.305 363.611ZM878.305 362.621L878.81 361.758L877.305 360.876V362.621H878.305ZM879.162 363.124H880.162V362.551L879.668 362.261L879.162 363.124ZM879.668 363.251L878.81 362.749L877.799 364.474L878.656 364.977L879.668 363.251ZM879.305 363.611V362.621H877.305V363.611H879.305ZM877.799 363.484L878.656 363.986L879.668 362.261L878.81 361.758L877.799 363.484ZM878.162 363.124V364.114H880.162V363.124H878.162Z",
    fill: "#222222",
    mask: "url(#path-145-inside-3_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_141"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-147-inside-4_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 364.618L877.447 364.115V363.125L878.304 363.613V364.618Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 364.618L877.447 364.115V363.125L878.304 363.613V364.618Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 364.618L877.799 365.48L879.304 366.363V364.618H878.304ZM877.447 364.115H876.447V364.688L876.942 364.978L877.447 364.115ZM877.447 363.125L877.942 362.256L876.447 361.405V363.125H877.447ZM878.304 363.613H879.304V363.031L878.799 362.744L878.304 363.613ZM878.81 363.755L877.953 363.253L876.942 364.978L877.799 365.48L878.81 363.755ZM878.447 364.115V363.125H876.447V364.115H878.447ZM876.953 363.994L877.81 364.482L878.799 362.744L877.942 362.256L876.953 363.994ZM877.304 363.613V364.618H879.304V363.613H877.304Z",
    fill: "#222222",
    mask: "url(#path-147-inside-4_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_142"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-149-inside-5_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 366.11L878.305 365.607V364.617L879.162 365.105V366.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 366.11L878.305 365.607V364.617L879.162 365.105V366.11Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 366.11L878.656 366.973L880.162 367.855V366.11H879.162ZM878.305 365.607H877.305V366.18L877.799 366.47L878.305 365.607ZM878.305 364.617L878.799 363.748L877.305 362.898V364.617H878.305ZM879.162 365.105H880.162V364.523L879.656 364.236L879.162 365.105ZM879.668 365.247L878.81 364.745L877.799 366.47L878.656 366.973L879.668 365.247ZM879.305 365.607V364.617H877.305V365.607H879.305ZM877.81 365.486L878.667 365.974L879.656 364.236L878.799 363.748L877.81 365.486ZM878.162 365.105V366.11H880.162V365.105H878.162Z",
    fill: "#222222",
    mask: "url(#path-149-inside-5_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_143"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-151-inside-6_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 366.596L877.447 366.108V365.104L878.304 365.606V366.596Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 366.596L877.447 366.108V365.104L878.304 365.606V366.596Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 366.596L877.81 367.465L879.304 368.316V366.596H878.304ZM877.447 366.108H876.447V366.69L876.953 366.978L877.447 366.108ZM877.447 365.104L877.953 364.241L876.447 363.358V365.104H877.447ZM878.304 365.606H879.304V365.033L878.81 364.743L878.304 365.606ZM878.799 365.727L877.942 365.239L876.953 366.978L877.81 367.465L878.799 365.727ZM878.447 366.108V365.104H876.447V366.108H878.447ZM876.942 365.966L877.799 366.469L878.81 364.743L877.953 364.241L876.942 365.966ZM877.304 365.606V366.596H879.304V365.606H877.304Z",
    fill: "#222222",
    mask: "url(#path-151-inside-6_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_144"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-153-inside-7_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 367.602L877.447 367.1V366.109L878.304 366.597V367.602Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 367.602L877.447 367.1V366.109L878.304 366.597V367.602Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 367.602L877.799 368.465L879.304 369.348V367.602H878.304ZM877.447 367.1H876.447V367.672L876.941 367.962L877.447 367.1ZM877.447 366.109L877.942 365.24L876.447 364.39V366.109H877.447ZM878.304 366.597H879.304V366.016L878.799 365.728L878.304 366.597ZM878.81 366.739L877.953 366.237L876.941 367.962L877.799 368.465L878.81 366.739ZM878.447 367.1V366.109H876.447V367.1H878.447ZM876.953 366.979L877.81 367.466L878.799 365.728L877.942 365.24L876.953 366.979ZM877.304 366.597V367.602H879.304V366.597H877.304Z",
    fill: "#222222",
    mask: "url(#path-153-inside-7_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_145"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-155-inside-8_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 369.079L878.305 368.592V367.602L879.162 368.089V369.079Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 369.079L878.305 368.592V367.602L879.162 368.089V369.079Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 369.079L878.667 369.949L880.162 370.799V369.079H879.162ZM878.305 368.592H877.305V369.173L877.81 369.461L878.305 368.592ZM878.305 367.602L878.799 366.732L877.305 365.882V367.602H878.305ZM879.162 368.089H880.162V367.508L879.656 367.22L879.162 368.089ZM879.656 368.21L878.799 367.723L877.81 369.461L878.667 369.949L879.656 368.21ZM879.305 368.592V367.602H877.305V368.592H879.305ZM877.81 368.471L878.667 368.958L879.656 367.22L878.799 366.732L877.81 368.471ZM878.162 368.089V369.079H880.162V368.089H878.162Z",
    fill: "#222222",
    mask: "url(#path-155-inside-8_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_146"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-157-inside-9_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 369.582L877.447 369.08V368.09L878.304 368.592V369.582Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 369.582L877.447 369.08V368.09L878.304 368.592V369.582Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 369.582L877.799 370.445L879.304 371.328V369.582H878.304ZM877.447 369.08H876.447V369.653L876.942 369.943L877.447 369.08ZM877.447 368.09L877.953 367.227L876.447 366.345V368.09H877.447ZM878.304 368.592H879.304V368.019L878.81 367.73L878.304 368.592ZM878.81 368.72L877.953 368.217L876.942 369.943L877.799 370.445L878.81 368.72ZM878.447 369.08V368.09H876.447V369.08H878.447ZM876.942 368.953L877.799 369.455L878.81 367.73L877.953 367.227L876.942 368.953ZM877.304 368.592V369.582H879.304V368.592H877.304Z",
    fill: "#222222",
    mask: "url(#path-157-inside-9_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_147"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-159-inside-10_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 370.085L878.305 369.582V368.592L879.162 369.08V370.085Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 370.085L878.305 369.582V368.592L879.162 369.08V370.085Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 370.085L878.656 370.947L880.162 371.83V370.085H879.162ZM878.305 369.582H877.305V370.155L877.799 370.445L878.305 369.582ZM878.305 368.592L878.799 367.723L877.305 366.872V368.592H878.305ZM879.162 369.08H880.162V368.498L879.656 368.21L879.162 369.08ZM879.668 369.222L878.81 368.719L877.799 370.445L878.656 370.947L879.668 369.222ZM879.305 369.582V368.592H877.305V369.582H879.305ZM877.81 369.461L878.667 369.949L879.656 368.21L878.799 367.723L877.81 369.461ZM878.162 369.08V370.085H880.162V369.08H878.162Z",
    fill: "#222222",
    mask: "url(#path-159-inside-10_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_148"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-161-inside-11_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.541 370.719L877.684 370.217V369.227L878.541 369.714V370.719Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.541 370.719L877.684 370.217V369.227L878.541 369.714V370.719Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.541 370.719L878.035 371.582L879.541 372.465V370.719H878.541ZM877.684 370.217H876.684V370.79L877.178 371.08L877.684 370.217ZM877.684 369.227L878.178 368.357L876.684 367.507V369.227H877.684ZM878.541 369.714H879.541V369.133L879.035 368.845L878.541 369.714ZM879.046 369.857L878.189 369.354L877.178 371.08L878.035 371.582L879.046 369.857ZM878.684 370.217V369.227H876.684V370.217H878.684ZM877.189 370.096L878.046 370.583L879.035 368.845L878.178 368.357L877.189 370.096ZM877.541 369.714V370.719H879.541V369.714H877.541Z",
    fill: "#222222",
    mask: "url(#path-161-inside-11_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_149"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-163-inside-12_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 372.065L878.305 371.577V370.572L879.162 371.075V372.065Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 372.065L878.305 371.577V370.572L879.162 371.075V372.065Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 372.065L878.667 372.934L880.162 373.784V372.065H879.162ZM878.305 371.577H877.305V372.159L877.81 372.446L878.305 371.577ZM878.305 370.572L878.81 369.71L877.305 368.827V370.572H878.305ZM879.162 371.075H880.162V370.502L879.668 370.212L879.162 371.075ZM879.656 371.196L878.799 370.708L877.81 372.446L878.667 372.934L879.656 371.196ZM879.305 371.577V370.572H877.305V371.577H879.305ZM877.799 371.435L878.656 371.937L879.668 370.212L878.81 369.71L877.799 371.435ZM878.162 371.075V372.065H880.162V371.075H878.162Z",
    fill: "#222222",
    mask: "url(#path-163-inside-12_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_150"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-165-inside-13_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.614 372.745L877.742 372.242V371.252L878.614 371.754V372.745Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.614 372.745L877.742 372.242V371.252L878.614 371.754V372.745Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.614 372.745L878.115 373.611L879.614 374.475V372.745H878.614ZM877.742 372.242H876.742V372.82L877.243 373.109L877.742 372.242ZM877.742 371.252L878.241 370.386L876.742 369.522V371.252H877.742ZM878.614 371.754H879.614V371.177L879.114 370.888L878.614 371.754ZM879.113 371.878L878.241 371.376L877.243 373.109L878.115 373.611L879.113 371.878ZM878.742 372.242V371.252H876.742V372.242H878.742ZM877.243 372.118L878.115 372.621L879.114 370.888L878.241 370.386L877.243 372.118ZM877.614 371.754V372.745H879.614V371.754H877.614Z",
    fill: "#222222",
    mask: "url(#path-165-inside-13_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_151"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-167-inside-14_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880.019 368.592L879.162 368.09V367.1L880.019 367.602V368.592Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M880.019 368.592L879.162 368.09V367.1L880.019 367.602V368.592Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.019 368.592L879.514 369.455L881.019 370.338V368.592H880.019ZM879.162 368.09H878.162V368.663L878.656 368.953L879.162 368.09ZM879.162 367.1L879.668 366.237L878.162 365.354V367.1H879.162ZM880.019 367.602H881.019V367.029L880.525 366.739L880.019 367.602ZM880.525 367.73L879.668 367.227L878.656 368.953L879.514 369.455L880.525 367.73ZM880.162 368.09V367.1H878.162V368.09H880.162ZM878.656 367.962L879.513 368.465L880.525 366.739L879.668 366.237L878.656 367.962ZM879.019 367.602V368.592H881.019V367.602H879.019Z",
    fill: "#222222",
    mask: "url(#path-167-inside-14_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_152"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-169-inside-15_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880.889 368.592L880.018 368.09V367.1L880.889 367.602V368.592Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M880.889 368.592L880.018 368.09V367.1L880.889 367.602V368.592Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.889 368.592L880.39 369.459L881.889 370.323V368.592H880.889ZM880.018 368.09H879.018V368.668L879.518 368.956L880.018 368.09ZM880.018 367.1L880.517 366.233L879.018 365.369V367.1H880.018ZM880.889 367.602H881.889V367.024L881.389 366.736L880.889 367.602ZM881.389 367.726L880.517 367.223L879.518 368.956L880.39 369.459L881.389 367.726ZM881.018 368.09V367.1H879.018V368.09H881.018ZM879.518 367.966L880.39 368.469L881.389 366.736L880.517 366.233L879.518 367.966ZM879.889 367.602V368.592H881.889V367.602H879.889Z",
    fill: "#222222",
    mask: "url(#path-169-inside-15_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_153"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-171-inside-16_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.748 370.085L880.891 369.582V368.592L881.748 369.08V370.085Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M881.748 370.085L880.891 369.582V368.592L881.748 369.08V370.085Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.748 370.085L881.242 370.947L882.748 371.83V370.085H881.748ZM880.891 369.582H879.891V370.155L880.385 370.445L880.891 369.582ZM880.891 368.592L881.385 367.723L879.891 366.872V368.592H880.891ZM881.748 369.08H882.748V368.498L882.242 368.21L881.748 369.08ZM882.254 369.222L881.396 368.719L880.385 370.445L881.242 370.947L882.254 369.222ZM881.891 369.582V368.592H879.891V369.582H881.891ZM880.396 369.461L881.253 369.949L882.242 368.21L881.385 367.723L880.396 369.461ZM880.748 369.08V370.085H882.748V369.08H880.748Z",
    fill: "#222222",
    mask: "url(#path-171-inside-16_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_154"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-173-inside-17_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882.605 369.582L881.748 369.08V368.09L882.605 368.592V369.582Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M882.605 369.582L881.748 369.08V368.09L882.605 368.592V369.582Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.605 369.582L882.099 370.445L883.605 371.328V369.582H882.605ZM881.748 369.08H880.748V369.653L881.242 369.943L881.748 369.08ZM881.748 368.09L882.254 367.227L880.748 366.345V368.09H881.748ZM882.605 368.592H883.605V368.019L883.111 367.73L882.605 368.592ZM883.111 368.72L882.254 368.217L881.242 369.943L882.099 370.445L883.111 368.72ZM882.748 369.08V368.09H880.748V369.08H882.748ZM881.242 368.953L882.099 369.455L883.111 367.73L882.254 367.227L881.242 368.953ZM881.605 368.592V369.582H883.605V368.592H881.605Z",
    fill: "#222222",
    mask: "url(#path-173-inside-17_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_155"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-175-inside-18_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.448 366.745L876.576 366.242V365.252L877.448 365.754V366.745Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M877.448 366.745L876.576 366.242V365.252L877.448 365.754V366.745Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.448 366.745L876.949 367.611L878.448 368.475V366.745H877.448ZM876.576 366.242H875.576V366.82L876.077 367.109L876.576 366.242ZM876.576 365.252L877.076 364.386L875.576 363.521V365.252H876.576ZM877.448 365.754H878.448V365.177L877.947 364.888L877.448 365.754ZM877.947 365.878L877.075 365.376L876.077 367.109L876.949 367.611L877.947 365.878ZM877.576 366.242V365.252H875.576V366.242H877.576ZM876.077 366.118L876.949 366.621L877.947 364.888L877.076 364.386L876.077 366.118ZM876.448 365.754V366.745H878.448V365.754H876.448Z",
    fill: "#222222",
    mask: "url(#path-175-inside-18_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_156"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-177-inside-19_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.576 366.745L875.719 366.242V365.252L876.576 365.754V366.745Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M876.576 366.745L875.719 366.242V365.252L876.576 365.754V366.745Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.576 366.745L876.07 367.607L877.576 368.49V366.745H876.576ZM875.719 366.242H874.719V366.815L875.213 367.105L875.719 366.242ZM875.719 365.252L876.224 364.389L874.719 363.507V365.252H875.719ZM876.576 365.754H877.576V365.182L877.082 364.892L876.576 365.754ZM877.082 365.882L876.224 365.379L875.213 367.105L876.07 367.607L877.082 365.882ZM876.719 366.242V365.252H874.719V366.242H876.719ZM875.213 366.115L876.07 366.617L877.082 364.892L876.224 364.389L875.213 366.115ZM875.576 365.754V366.745H877.576V365.754H875.576Z",
    fill: "#222222",
    mask: "url(#path-177-inside-19_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_157"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-179-inside-20_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.718 365.606L874.861 365.103V364.113L875.718 364.616V365.606Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 365.606L874.861 365.103V364.113L875.718 364.616V365.606Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 365.606L875.213 366.469L876.718 367.351V365.606H875.718ZM874.861 365.103H873.861V365.676L874.356 365.966L874.861 365.103ZM874.861 364.113L875.367 363.251L873.861 362.368V364.113H874.861ZM875.718 364.616H876.718V364.043L876.224 363.753L875.718 364.616ZM876.224 364.743L875.367 364.241L874.356 365.966L875.213 366.469L876.224 364.743ZM875.861 365.103V364.113H873.861V365.103H875.861ZM874.356 364.976L875.213 365.478L876.224 363.753L875.367 363.251L874.356 364.976ZM874.718 364.616V365.606H876.718V364.616H874.718Z",
    fill: "#222222",
    mask: "url(#path-179-inside-20_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_158"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-181-inside-21_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.86 365.68L873.988 365.178V364.188L874.86 364.69V365.68Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M874.86 365.68L873.988 365.178V364.188L874.86 364.69V365.68Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.86 365.68L874.361 366.547L875.86 367.411V365.68H874.86ZM873.988 365.178H872.988V365.756L873.489 366.044L873.988 365.178ZM873.988 364.188L874.488 363.321L872.988 362.457V364.188H873.988ZM874.86 364.69H875.86V364.112L875.359 363.824L874.86 364.69ZM875.36 364.814L874.488 364.311L873.489 366.044L874.361 366.547L875.36 364.814ZM874.988 365.178V364.188H872.988V365.178H874.988ZM873.489 365.054L874.361 365.556L875.359 363.824L874.488 363.321L873.489 365.054ZM873.86 364.69V365.68H875.86V364.69H873.86Z",
    fill: "#222222",
    mask: "url(#path-181-inside-21_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_159"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-183-inside-22_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.718 366.596L874.861 366.108V365.104L875.718 365.606V366.596Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 366.596L874.861 366.108V365.104L875.718 365.606V366.596Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 366.596L875.224 367.465L876.718 368.316V366.596H875.718ZM874.861 366.108H873.861V366.69L874.367 366.978L874.861 366.108ZM874.861 365.104L875.367 364.241L873.861 363.358V365.104H874.861ZM875.718 365.606H876.718V365.033L876.224 364.743L875.718 365.606ZM876.213 365.727L875.356 365.239L874.367 366.978L875.224 367.465L876.213 365.727ZM875.861 366.108V365.104H873.861V366.108H875.861ZM874.356 365.966L875.213 366.469L876.224 364.743L875.367 364.241L874.356 365.966ZM874.718 365.606V366.596H876.718V365.606H874.718Z",
    fill: "#222222",
    mask: "url(#path-183-inside-22_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_160"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-185-inside-23_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 367.1L878.305 366.598V365.607L879.162 366.11V367.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 367.1L878.305 366.598V365.607L879.162 366.11V367.1Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 367.1L878.656 367.963L880.162 368.845V367.1H879.162ZM878.305 366.598H877.305V367.171L877.799 367.46L878.305 366.598ZM878.305 365.607L878.81 364.745L877.305 363.862V365.607H878.305ZM879.162 366.11H880.162V365.537L879.668 365.247L879.162 366.11ZM879.668 366.237L878.81 365.735L877.799 367.46L878.656 367.963L879.668 366.237ZM879.305 366.598V365.607H877.305V366.598H879.305ZM877.799 366.47L878.656 366.973L879.668 365.247L878.81 364.745L877.799 366.47ZM878.162 366.11V367.1H880.162V366.11H878.162Z",
    fill: "#222222",
    mask: "url(#path-185-inside-23_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_161"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-187-inside-24_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.27 365.208L873.486 363.021V358.646L877.27 360.834V365.208ZM873.826 362.814L876.93 364.602V361.026L873.826 359.238V362.814Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 365.208L873.486 363.021V358.646L877.27 360.834V365.208ZM873.826 362.814L876.93 364.602V361.026L873.826 359.238V362.814Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 365.208L876.769 366.074L878.27 366.942V365.208H877.27ZM873.486 363.021H872.486V363.598L872.986 363.887L873.486 363.021ZM873.486 358.646L873.987 357.781L872.486 356.913V358.646H873.486ZM877.27 360.834H878.27V360.257L877.77 359.968L877.27 360.834ZM873.826 362.814H872.826V363.392L873.327 363.681L873.826 362.814ZM876.93 364.602L876.431 365.469L877.93 366.333V364.602H876.93ZM876.93 361.026H877.93V360.448L877.429 360.159L876.93 361.026ZM873.826 359.238L874.326 358.371L872.826 357.507V359.238H873.826ZM877.77 364.343L873.987 362.155L872.986 363.887L876.769 366.074L877.77 364.343ZM874.486 363.021V358.646H872.486V363.021H874.486ZM872.986 359.512L876.769 361.7L877.77 359.968L873.987 357.781L872.986 359.512ZM876.27 360.834V365.208H878.27V360.834H876.27ZM873.327 363.681L876.431 365.469L877.429 363.736L874.326 361.948L873.327 363.681ZM877.93 364.602V361.026H875.93V364.602H877.93ZM877.429 360.159L874.326 358.371L873.327 360.104L876.431 361.892L877.429 360.159ZM872.826 359.238V362.814H874.826V359.238H872.826Z",
    fill: "#222222",
    mask: "url(#path-187-inside-24_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_162"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-189-inside-25_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.88 359.488L872.703 359.399V357.301L874.521 358.35V358.542L872.88 357.596V359.488Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M872.88 359.488L872.703 359.399V357.301L874.521 358.35V358.542L872.88 357.596V359.488Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.88 359.488L872.433 360.383L873.88 361.106V359.488H872.88ZM872.703 359.399H871.703V360.018L872.256 360.294L872.703 359.399ZM872.703 357.301L873.203 356.435L871.703 355.569V357.301H872.703ZM874.521 358.35H875.521V357.773L875.021 357.484L874.521 358.35ZM874.521 358.542L874.021 359.409L875.521 360.273V358.542H874.521ZM872.88 357.596L873.38 356.73L871.88 355.865V357.596H872.88ZM873.328 358.594L873.15 358.505L872.256 360.294L872.433 360.383L873.328 358.594ZM873.703 359.399V357.301H871.703V359.399H873.703ZM872.203 358.167L874.021 359.216L875.021 357.484L873.203 356.435L872.203 358.167ZM873.521 358.35V358.542H875.521V358.35H873.521ZM875.02 357.676L873.38 356.73L872.381 358.463L874.021 359.409L875.02 357.676ZM871.88 357.596V359.488H873.88V357.596H871.88Z",
    fill: "#222222",
    mask: "url(#path-189-inside-25_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_163"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-191-inside-26_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.083 365.961L883.906 365.858V363.966L882.266 363.02V362.828L884.083 363.863V365.961Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 365.961L883.906 365.858V363.966L882.266 363.02V362.828L884.083 363.863V365.961Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 365.961L883.58 366.825L885.083 367.702V365.961H884.083ZM883.906 365.858H882.906V366.432L883.402 366.722L883.906 365.858ZM883.906 363.966H884.906V363.388L884.406 363.1L883.906 363.966ZM882.266 363.02H881.266V363.598L881.766 363.886L882.266 363.02ZM882.266 362.828L882.76 361.959L881.266 361.108V362.828H882.266ZM884.083 363.863H885.083V363.281L884.578 362.993L884.083 363.863ZM884.587 365.098L884.41 364.994L883.402 366.722L883.58 366.825L884.587 365.098ZM884.906 365.858V363.966H882.906V365.858H884.906ZM884.406 363.1L882.765 362.154L881.766 363.886L883.407 364.832L884.406 363.1ZM883.266 363.02V362.828H881.266V363.02H883.266ZM881.771 363.697L883.589 364.732L884.578 362.993L882.76 361.959L881.771 363.697ZM883.083 363.863V365.961H885.083V363.863H883.083Z",
    fill: "#222222",
    mask: "url(#path-191-inside-26_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_164"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-193-inside-27_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.521 371.473L872.703 370.424V368.34L872.88 368.443V370.335L874.521 371.281V371.473Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M874.521 371.473L872.703 370.424V368.34L872.88 368.443V370.335L874.521 371.281V371.473Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.521 371.473L874.021 372.339L875.521 373.205V371.473H874.521ZM872.703 370.424H871.703V371.001L872.203 371.29L872.703 370.424ZM872.703 368.34L873.207 367.476L871.703 366.599V368.34H872.703ZM872.88 368.443H873.88V367.869L873.384 367.58L872.88 368.443ZM872.88 370.335H871.88V370.913L872.381 371.201L872.88 370.335ZM874.521 371.281H875.521V370.703L875.02 370.415L874.521 371.281ZM875.021 370.607L873.203 369.558L872.203 371.29L874.021 372.339L875.021 370.607ZM873.703 370.424V368.34H871.703V370.424H873.703ZM872.199 369.204L872.377 369.307L873.384 367.58L873.207 367.476L872.199 369.204ZM871.88 368.443V370.335H873.88V368.443H871.88ZM872.381 371.201L874.021 372.147L875.02 370.415L873.38 369.469L872.381 371.201ZM873.521 371.281V371.473H875.521V371.281H873.521Z",
    fill: "#222222",
    mask: "url(#path-193-inside-27_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_165"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-195-inside-28_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.083 377.002L882.266 375.952V375.746L883.906 376.691V374.814L884.083 374.903V377.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 377.002L882.266 375.952V375.746L883.906 376.691V374.814L884.083 374.903V377.002Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 377.002L883.583 377.868L885.083 378.734V377.002H884.083ZM882.266 375.952H881.266V376.53L881.766 376.818L882.266 375.952ZM882.266 375.746L882.765 374.879L881.266 374.015V375.746H882.266ZM883.906 376.691L883.407 377.558L884.906 378.422V376.691H883.906ZM883.906 374.814L884.353 373.92L882.906 373.196V374.814H883.906ZM884.083 374.903H885.083V374.285L884.531 374.009L884.083 374.903ZM884.583 376.136L882.766 375.086L881.766 376.818L883.583 377.868L884.583 376.136ZM883.266 375.952V375.746H881.266V375.952H883.266ZM881.766 376.612L883.407 377.558L884.406 375.825L882.765 374.879L881.766 376.612ZM884.906 376.691V374.814H882.906V376.691H884.906ZM883.459 375.709L883.636 375.798L884.531 374.009L884.353 373.92L883.459 375.709ZM883.083 374.903V377.002H885.083V374.903H883.083Z",
    fill: "#222222",
    mask: "url(#path-195-inside-28_608_71031)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M881.765 365.201V366.035L881.051 365.616V364.788L881.765 365.201Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M875.735 368.673V369.514L875.021 369.101V368.261L875.735 368.673Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_168"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-199-inside-29_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.27 372.169L873.486 369.982V365.607L877.27 367.795V372.169ZM873.826 369.79L876.93 371.578V368.002L873.826 366.213V369.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 372.169L873.486 369.982V365.607L877.27 367.795V372.169ZM873.826 369.79L876.93 371.578V368.002L873.826 366.213V369.79Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 372.169L876.769 373.035L878.27 373.903V372.169H877.27ZM873.486 369.982H872.486V370.559L872.986 370.848L873.486 369.982ZM873.486 365.607L873.987 364.742L872.486 363.874V365.607H873.486ZM877.27 367.795H878.27V367.218L877.77 366.929L877.27 367.795ZM873.826 369.79H872.826V370.368L873.327 370.656L873.826 369.79ZM876.93 371.578L876.431 372.445L877.93 373.309V371.578H876.93ZM876.93 368.002H877.93V367.424L877.429 367.135L876.93 368.002ZM873.826 366.213L874.326 365.347L872.826 364.483V366.213H873.826ZM877.77 371.304L873.987 369.116L872.986 370.848L876.769 373.035L877.77 371.304ZM874.486 369.982V365.607H872.486V369.982H874.486ZM872.986 366.473L876.769 368.661L877.77 366.929L873.987 364.742L872.986 366.473ZM876.27 367.795V372.169H878.27V367.795H876.27ZM873.327 370.656L876.431 372.445L877.429 370.712L874.326 368.923L873.327 370.656ZM877.93 371.578V368.002H875.93V371.578H877.93ZM877.429 367.135L874.326 365.347L873.327 367.08L876.431 368.868L877.429 367.135ZM872.826 366.213V369.79H874.826V366.213H872.826Z",
    fill: "#222222",
    mask: "url(#path-199-inside-29_608_71031)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M881.765 372.162V372.996L881.051 372.577V371.749L881.765 372.162Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_170"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-202-inside-30_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.3 375.656L879.517 373.468V369.094L883.3 371.281V375.656ZM879.856 373.276L882.96 375.064V371.488L879.856 369.7V373.276Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 375.656L879.517 373.468V369.094L883.3 371.281V375.656ZM879.856 373.276L882.96 375.064V371.488L879.856 369.7V373.276Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 375.656L882.799 376.521L884.3 377.389V375.656H883.3ZM879.517 373.468H878.517V374.045L879.016 374.334L879.517 373.468ZM879.517 369.094L880.017 368.228L878.517 367.361V369.094H879.517ZM883.3 371.281H884.3V370.704L883.8 370.415L883.3 371.281ZM879.856 373.276H878.856V373.854L879.357 374.143L879.856 373.276ZM882.96 375.064L882.461 375.931L883.96 376.795V375.064H882.96ZM882.96 371.488H883.96V370.91L883.459 370.622L882.96 371.488ZM879.856 369.7L880.356 368.833L878.856 367.969V369.7H879.856ZM883.8 374.79L880.017 372.603L879.016 374.334L882.799 376.521L883.8 374.79ZM880.517 373.468V369.094H878.517V373.468H880.517ZM879.016 369.959L882.799 372.147L883.8 370.415L880.017 368.228L879.016 369.959ZM882.3 371.281V375.656H884.3V371.281H882.3ZM879.357 374.143L882.461 375.931L883.459 374.198L880.356 372.41L879.357 374.143ZM883.96 375.064V371.488H881.96V375.064H883.96ZM883.459 370.622L880.356 368.833L879.357 370.566L882.461 372.354L883.459 370.622ZM878.856 369.7V373.276H880.856V369.7H878.856Z",
    fill: "#222222",
    mask: "url(#path-202-inside-30_608_71031)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M909.11 370.381L948.796 347.046V300.375L909.11 323.71V370.381Z",
    fill: "#EFCFE4",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M930.438 357.26L927.471 359.005V313.495L930.438 311.749V357.26Z",
    fill: "#EFCFE4",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M909.61 348.505V344.998L948.296 322.251V325.758L909.61 348.505Z",
    fill: "#EFCFE4",
    stroke: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M909.111 323.712L948.796 300.376L909.111 277.041L869.425 300.376L909.111 323.712Z",
    fill: "#EFCFE4",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M891.252 288.121L929.952 310.877L926.971 312.63L888.271 289.874L891.252 288.121Z",
    fill: "#EFCFE4",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M888.271 310.877L926.971 288.121L929.952 289.874L891.252 312.63L888.271 310.877Z",
    fill: "#EFCFE4",
    stroke: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M869.425 347.046L909.111 370.381V323.71L869.425 300.375V347.046Z",
    fill: "#EFCFE4",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M887.785 311.749L890.752 313.495V359.005L887.785 357.26V311.749Z",
    fill: "#EFCFE4",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M869.925 322.251L908.611 344.998V348.505L869.925 325.758V322.251Z",
    fill: "#EFCFE4",
    stroke: "#222222"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M885.283 312.601V328.516L871.504 320.552V304.651L885.283 312.601Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_181"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-214-inside-31_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.3 318.122L879.517 315.935V311.561L883.3 313.748V318.122ZM879.856 315.743L882.96 317.531V313.955L879.856 312.166V315.743Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 318.122L879.517 315.935V311.561L883.3 313.748V318.122ZM879.856 315.743L882.96 317.531V313.955L879.856 312.166V315.743Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 318.122L882.799 318.988L884.3 319.856V318.122H883.3ZM879.517 315.935H878.517V316.512L879.016 316.801L879.517 315.935ZM879.517 311.561L880.017 310.695L878.517 309.827V311.561H879.517ZM883.3 313.748H884.3V313.171L883.8 312.882L883.3 313.748ZM879.856 315.743H878.856V316.321L879.357 316.61L879.856 315.743ZM882.96 317.531L882.461 318.398L883.96 319.262V317.531H882.96ZM882.96 313.955H883.96V313.377L883.459 313.088L882.96 313.955ZM879.856 312.166L880.356 311.3L878.856 310.436V312.166H879.856ZM883.8 317.257L880.017 315.069L879.016 316.801L882.799 318.988L883.8 317.257ZM880.517 315.935V311.561H878.517V315.935H880.517ZM879.016 312.426L882.799 314.614L883.8 312.882L880.017 310.695L879.016 312.426ZM882.3 313.748V318.122H884.3V313.748H882.3ZM879.357 316.61L882.461 318.398L883.459 316.665L880.356 314.877L879.357 316.61ZM883.96 317.531V313.955H881.96V317.531H883.96ZM883.459 313.088L880.356 311.3L879.357 313.033L882.461 314.821L883.459 313.088ZM878.856 312.166V315.743H880.856V312.166H878.856Z",
    fill: "#222222",
    mask: "url(#path-214-inside-31_608_71031)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M875.735 311.154V311.979L875.021 311.567V310.741L875.735 311.154Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_183"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-217-inside-32_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 312.063L877.447 311.56V310.57L878.304 311.058V312.063Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 312.063L877.447 311.56V310.57L878.304 311.058V312.063Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 312.063L877.799 312.926L879.304 313.808V312.063H878.304ZM877.447 311.56H876.447V312.133L876.942 312.423L877.447 311.56ZM877.447 310.57L877.942 309.701L876.447 308.851V310.57H877.447ZM878.304 311.058H879.304V310.476L878.799 310.189L878.304 311.058ZM878.81 311.2L877.953 310.698L876.942 312.423L877.799 312.926L878.81 311.2ZM878.447 311.56V310.57H876.447V311.56H878.447ZM876.953 311.439L877.81 311.927L878.799 310.189L877.942 309.701L876.953 311.439ZM877.304 311.058V312.063H879.304V311.058H877.304Z",
    fill: "#222222",
    mask: "url(#path-217-inside-32_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_184"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-219-inside-33_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 313.54L878.305 313.053V312.062L879.162 312.55V313.54Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 313.54L878.305 313.053V312.062L879.162 312.55V313.54Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 313.54L878.668 314.41L880.162 315.26V313.54H879.162ZM878.305 313.053H877.305V313.634L877.81 313.922L878.305 313.053ZM878.305 312.062L878.799 311.193L877.305 310.343V312.062H878.305ZM879.162 312.55H880.162V311.969L879.656 311.681L879.162 312.55ZM879.656 312.671L878.799 312.184L877.81 313.922L878.668 314.41L879.656 312.671ZM879.305 313.053V312.062H877.305V313.053H879.305ZM877.81 312.932L878.667 313.419L879.656 311.681L878.799 311.193L877.81 312.932ZM878.162 312.55V313.54H880.162V312.55H878.162Z",
    fill: "#222222",
    mask: "url(#path-219-inside-33_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_185"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-221-inside-34_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 314.043L877.447 313.541V312.551L878.304 313.053V314.043Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 314.043L877.447 313.541V312.551L878.304 313.053V314.043Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 314.043L877.799 314.906L879.304 315.789V314.043H878.304ZM877.447 313.541H876.447V314.114L876.941 314.404L877.447 313.541ZM877.447 312.551L877.953 311.688L876.447 310.805V312.551H877.447ZM878.304 313.053H879.304V312.48L878.81 312.191L878.304 313.053ZM878.81 313.181L877.953 312.678L876.941 314.404L877.799 314.906L878.81 313.181ZM878.447 313.541V312.551H876.447V313.541H878.447ZM876.941 313.413L877.799 313.916L878.81 312.191L877.953 311.688L876.941 313.413ZM877.304 313.053V314.043H879.304V313.053H877.304Z",
    fill: "#222222",
    mask: "url(#path-221-inside-34_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_186"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-223-inside-35_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 315.536L878.305 315.033V314.043L879.162 314.545V315.536Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 315.536L878.305 315.033V314.043L879.162 314.545V315.536Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 315.536L878.656 316.398L880.162 317.281V315.536H879.162ZM878.305 315.033H877.305V315.606L877.799 315.896L878.305 315.033ZM878.305 314.043L878.81 313.18L877.305 312.298V314.043H878.305ZM879.162 314.545H880.162V313.973L879.668 313.683L879.162 314.545ZM879.668 314.673L878.81 314.17L877.799 315.896L878.656 316.398L879.668 314.673ZM879.305 315.033V314.043H877.305V315.033H879.305ZM877.799 314.906L878.656 315.408L879.668 313.683L878.81 313.18L877.799 314.906ZM878.162 314.545V315.536H880.162V314.545H878.162Z",
    fill: "#222222",
    mask: "url(#path-223-inside-35_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_187"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-225-inside-36_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 316.038L877.447 315.535V314.545L878.304 315.033V316.038Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 316.038L877.447 315.535V314.545L878.304 315.033V316.038Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 316.038L877.799 316.9L879.304 317.783V316.038H878.304ZM877.447 315.535H876.447V316.108L876.942 316.398L877.447 315.535ZM877.447 314.545L877.942 313.676L876.447 312.825V314.545H877.447ZM878.304 315.033H879.304V314.451L878.799 314.163L878.304 315.033ZM878.81 315.175L877.953 314.672L876.942 316.398L877.799 316.9L878.81 315.175ZM878.447 315.535V314.545H876.447V315.535H878.447ZM876.953 315.414L877.81 315.902L878.799 314.163L877.942 313.676L876.953 315.414ZM877.304 315.033V316.038H879.304V315.033H877.304Z",
    fill: "#222222",
    mask: "url(#path-225-inside-36_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_188"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-227-inside-37_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 317.028L877.447 316.525V315.535L878.304 316.038V317.028Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 317.028L877.447 316.525V315.535L878.304 316.038V317.028Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 317.028L877.799 317.891L879.304 318.773V317.028H878.304ZM877.447 316.525H876.447V317.098L876.941 317.388L877.447 316.525ZM877.447 315.535L877.953 314.672L876.447 313.79V315.535H877.447ZM878.304 316.038H879.304V315.465L878.81 315.175L878.304 316.038ZM878.81 316.165L877.953 315.663L876.941 317.388L877.799 317.891L878.81 316.165ZM878.447 316.525V315.535H876.447V316.525H878.447ZM876.942 316.398L877.799 316.9L878.81 315.175L877.953 314.672L876.942 316.398ZM877.304 316.038V317.028H879.304V316.038H877.304Z",
    fill: "#222222",
    mask: "url(#path-227-inside-37_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_189"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-229-inside-38_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 318.52L878.305 318.018V317.027L879.162 317.53V318.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 318.52L878.305 318.018V317.027L879.162 317.53V318.52Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 318.52L878.656 319.383L880.162 320.265V318.52H879.162ZM878.305 318.018H877.305V318.59L877.799 318.88L878.305 318.018ZM878.305 317.027L878.81 316.165L877.305 315.282V317.027H878.305ZM879.162 317.53H880.162V316.957L879.668 316.667L879.162 317.53ZM879.668 317.657L878.81 317.155L877.799 318.88L878.656 319.383L879.668 317.657ZM879.305 318.018V317.027H877.305V318.018H879.305ZM877.799 317.89L878.656 318.393L879.668 316.667L878.81 316.165L877.799 317.89ZM878.162 317.53V318.52H880.162V317.53H878.162Z",
    fill: "#222222",
    mask: "url(#path-229-inside-38_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_190"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-231-inside-39_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.304 319.024L877.447 318.522V317.531L878.304 318.019V319.024Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 319.024L877.447 318.522V317.531L878.304 318.019V319.024Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.304 319.024L877.799 319.887L879.304 320.769V319.024H878.304ZM877.447 318.522H876.447V319.094L876.942 319.384L877.447 318.522ZM877.447 317.531L877.942 316.662L876.447 315.812V317.531H877.447ZM878.304 318.019H879.304V317.437L878.799 317.15L878.304 318.019ZM878.81 318.161L877.953 317.659L876.942 319.384L877.799 319.887L878.81 318.161ZM878.447 318.522V317.531H876.447V318.522H878.447ZM876.953 318.4L877.81 318.888L878.799 317.15L877.942 316.662L876.953 318.4ZM877.304 318.019V319.024H879.304V318.019H877.304Z",
    fill: "#222222",
    mask: "url(#path-231-inside-39_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_191"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-233-inside-40_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 319.512L878.305 319.025V318.02L879.162 318.522V319.512Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 319.512L878.305 319.025V318.02L879.162 318.522V319.512Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 319.512L878.667 320.381L880.162 321.232V319.512H879.162ZM878.305 319.025H877.305V319.606L877.81 319.894L878.305 319.025ZM878.305 318.02L878.81 317.157L877.305 316.274V318.02H878.305ZM879.162 318.522H880.162V317.949L879.668 317.659L879.162 318.522ZM879.656 318.643L878.799 318.155L877.81 319.894L878.667 320.381L879.656 318.643ZM879.305 319.025V318.02H877.305V319.025H879.305ZM877.799 318.882L878.656 319.385L879.668 317.659L878.81 317.157L877.799 318.882ZM878.162 318.522V319.512H880.162V318.522H878.162Z",
    fill: "#222222",
    mask: "url(#path-233-inside-40_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_192"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-235-inside-41_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.541 320.147L877.684 319.659V318.654L878.541 319.157V320.147Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.541 320.147L877.684 319.659V318.654L878.541 319.157V320.147Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.541 320.147L878.046 321.016L879.541 321.867V320.147H878.541ZM877.684 319.659H876.684V320.241L877.189 320.528L877.684 319.659ZM877.684 318.654L878.189 317.792L876.684 316.909V318.654H877.684ZM878.541 319.157H879.541V318.584L879.046 318.294L878.541 319.157ZM879.035 319.278L878.178 318.79L877.189 320.528L878.046 321.016L879.035 319.278ZM878.684 319.659V318.654H876.684V319.659H878.684ZM877.178 319.517L878.035 320.019L879.046 318.294L878.189 317.792L877.178 319.517ZM877.541 319.157V320.147H879.541V319.157H877.541Z",
    fill: "#222222",
    mask: "url(#path-235-inside-41_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_193"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-237-inside-42_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 321.506L878.305 321.004V320.014L879.162 320.501V321.506Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 321.506L878.305 321.004V320.014L879.162 320.501V321.506Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 321.506L878.656 322.369L880.162 323.252V321.506H879.162ZM878.305 321.004H877.305V321.577L877.799 321.867L878.305 321.004ZM878.305 320.014L878.799 319.144L877.305 318.294V320.014H878.305ZM879.162 320.501H880.162V319.92L879.656 319.632L879.162 320.501ZM879.668 320.644L878.81 320.141L877.799 321.867L878.656 322.369L879.668 320.644ZM879.305 321.004V320.014H877.305V321.004H879.305ZM877.81 320.883L878.667 321.371L879.656 319.632L878.799 319.144L877.81 320.883ZM878.162 320.501V321.506H880.162V320.501H878.162Z",
    fill: "#222222",
    mask: "url(#path-237-inside-42_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_194"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-239-inside-43_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M878.614 322.172L877.742 321.685V320.68L878.614 321.182V322.172Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.614 322.172L877.742 321.685V320.68L878.614 321.182V322.172Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M878.614 322.172L878.126 323.045L879.614 323.877V322.172H878.614ZM877.742 321.685H876.742V322.271L877.254 322.557L877.742 321.685ZM877.742 320.68L878.241 319.813L876.742 318.949V320.68H877.742ZM878.614 321.182H879.614V320.604L879.114 320.316L878.614 321.182ZM879.102 321.3L878.23 320.812L877.254 322.557L878.126 323.045L879.102 321.3ZM878.742 321.685V320.68H876.742V321.685H878.742ZM877.243 321.546L878.115 322.049L879.114 320.316L878.241 319.813L877.243 321.546ZM877.614 321.182V322.172H879.614V321.182H877.614Z",
    fill: "#222222",
    mask: "url(#path-239-inside-43_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_195"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-241-inside-44_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880.019 318.02L879.162 317.532V316.527L880.019 317.03V318.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M880.019 318.02L879.162 317.532V316.527L880.019 317.03V318.02Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.019 318.02L879.525 318.889L881.019 319.74V318.02H880.019ZM879.162 317.532H878.162V318.114L878.668 318.401L879.162 317.532ZM879.162 316.527L879.668 315.665L878.162 314.782V316.527H879.162ZM880.019 317.03H881.019V316.457L880.525 316.167L880.019 317.03ZM880.514 317.151L879.657 316.663L878.668 318.401L879.525 318.889L880.514 317.151ZM880.162 317.532V316.527H878.162V317.532H880.162ZM878.656 317.39L879.513 317.893L880.525 316.167L879.668 315.665L878.656 317.39ZM879.019 317.03V318.02H881.019V317.03H879.019Z",
    fill: "#222222",
    mask: "url(#path-241-inside-44_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_196"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-243-inside-45_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880.889 318.02L880.018 317.532V316.527L880.889 317.03V318.02Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M880.889 318.02L880.018 317.532V316.527L880.889 317.03V318.02Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.889 318.02L880.401 318.893L881.889 319.725V318.02H880.889ZM880.018 317.532H879.018V318.119L879.529 318.405L880.018 317.532ZM880.018 316.527L880.517 315.661L879.018 314.797V316.527H880.018ZM880.889 317.03H881.889V316.452L881.389 316.163L880.889 317.03ZM881.378 317.147L880.506 316.66L879.529 318.405L880.401 318.893L881.378 317.147ZM881.018 317.532V316.527H879.018V317.532H881.018ZM879.518 317.394L880.39 317.896L881.389 316.163L880.517 315.661L879.518 317.394ZM879.889 317.03V318.02H881.889V317.03H879.889Z",
    fill: "#222222",
    mask: "url(#path-243-inside-45_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_197"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-245-inside-46_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M881.748 319.512L880.891 319.025V318.02L881.748 318.522V319.512Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M881.748 319.512L880.891 319.025V318.02L881.748 318.522V319.512Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M881.748 319.512L881.253 320.381L882.748 321.232V319.512H881.748ZM880.891 319.025H879.891V319.606L880.396 319.894L880.891 319.025ZM880.891 318.02L881.396 317.157L879.891 316.274V318.02H880.891ZM881.748 318.522H882.748V317.949L882.254 317.659L881.748 318.522ZM882.242 318.643L881.385 318.155L880.396 319.894L881.253 320.381L882.242 318.643ZM881.891 319.025V318.02H879.891V319.025H881.891ZM880.385 318.882L881.242 319.385L882.254 317.659L881.396 317.157L880.385 318.882ZM880.748 318.522V319.512H882.748V318.522H880.748Z",
    fill: "#222222",
    mask: "url(#path-245-inside-46_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_198"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-247-inside-47_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M882.605 319.024L881.748 318.522V317.531L882.605 318.019V319.024Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M882.605 319.024L881.748 318.522V317.531L882.605 318.019V319.024Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.605 319.024L882.099 319.887L883.605 320.769V319.024H882.605ZM881.748 318.522H880.748V319.094L881.242 319.384L881.748 318.522ZM881.748 317.531L882.243 316.662L880.748 315.812V317.531H881.748ZM882.605 318.019H883.605V317.437L883.1 317.15L882.605 318.019ZM883.111 318.161L882.254 317.659L881.242 319.384L882.099 319.887L883.111 318.161ZM882.748 318.522V317.531H880.748V318.522H882.748ZM881.253 318.4L882.111 318.888L883.1 317.15L882.243 316.662L881.253 318.4ZM881.605 318.019V319.024H883.605V318.019H881.605Z",
    fill: "#222222",
    mask: "url(#path-247-inside-47_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_199"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-249-inside-48_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.448 316.172L876.576 315.685V314.68L877.448 315.182V316.172Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M877.448 316.172L876.576 315.685V314.68L877.448 315.182V316.172Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.448 316.172L876.96 317.045L878.448 317.878V316.172H877.448ZM876.576 315.685H875.576V316.271L876.088 316.557L876.576 315.685ZM876.576 314.68L877.076 313.813L875.576 312.949V314.68H876.576ZM877.448 315.182H878.448V314.604L877.947 314.316L877.448 315.182ZM877.936 315.3L877.064 314.812L876.088 316.557L876.96 317.045L877.936 315.3ZM877.576 315.685V314.68H875.576V315.685H877.576ZM876.077 315.546L876.949 316.049L877.947 314.316L877.076 313.813L876.077 315.546ZM876.448 315.182V316.172H878.448V315.182H876.448Z",
    fill: "#222222",
    mask: "url(#path-249-inside-48_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_200"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-251-inside-49_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M876.576 316.172L875.719 315.685V314.68L876.576 315.182V316.172Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M876.576 316.172L875.719 315.685V314.68L876.576 315.182V316.172Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.576 316.172L876.082 317.042L877.576 317.892V316.172H876.576ZM875.719 315.685H874.719V316.266L875.224 316.554L875.719 315.685ZM875.719 314.68L876.224 313.817L874.719 312.934V314.68H875.719ZM876.576 315.182H877.576V314.609L877.082 314.32L876.576 315.182ZM877.071 315.303L876.213 314.815L875.224 316.554L876.082 317.042L877.071 315.303ZM876.719 315.685V314.68H874.719V315.685H876.719ZM875.213 315.542L876.07 316.045L877.082 314.32L876.224 313.817L875.213 315.542ZM875.576 315.182V316.172H877.576V315.182H875.576Z",
    fill: "#222222",
    mask: "url(#path-251-inside-49_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_201"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-253-inside-50_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.718 315.034L874.861 314.546V313.541L875.718 314.044V315.034Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 315.034L874.861 314.546V313.541L875.718 314.044V315.034Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 315.034L875.224 315.903L876.718 316.753V315.034H875.718ZM874.861 314.546H873.861V315.128L874.367 315.415L874.861 314.546ZM874.861 313.541L875.367 312.678L873.861 311.796V313.541H874.861ZM875.718 314.044H876.718V313.471L876.224 313.181L875.718 314.044ZM876.213 314.165L875.356 313.677L874.367 315.415L875.224 315.903L876.213 314.165ZM875.861 314.546V313.541H873.861V314.546H875.861ZM874.356 314.404L875.213 314.906L876.224 313.181L875.367 312.678L874.356 314.404ZM874.718 314.044V315.034H876.718V314.044H874.718Z",
    fill: "#222222",
    mask: "url(#path-253-inside-50_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_202"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-255-inside-51_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.86 315.106L873.988 314.618V313.613L874.86 314.116V315.106Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M874.86 315.106L873.988 314.618V313.613L874.86 314.116V315.106Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.86 315.106L874.372 315.979L875.86 316.811V315.106H874.86ZM873.988 314.618H872.988V315.205L873.5 315.491L873.988 314.618ZM873.988 313.613L874.488 312.747L872.988 311.883V313.613H873.988ZM874.86 314.116H875.86V313.538L875.359 313.249L874.86 314.116ZM875.348 314.233L874.476 313.746L873.5 315.491L874.372 315.979L875.348 314.233ZM874.988 314.618V313.613H872.988V314.618H874.988ZM873.489 314.48L874.361 314.982L875.359 313.249L874.488 312.747L873.489 314.48ZM873.86 314.116V315.106H875.86V314.116H873.86Z",
    fill: "#222222",
    mask: "url(#path-255-inside-51_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_203"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-257-inside-52_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M875.718 316.038L874.861 315.535V314.545L875.718 315.033V316.038Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 316.038L874.861 315.535V314.545L875.718 315.033V316.038Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.718 316.038L875.213 316.9L876.718 317.783V316.038H875.718ZM874.861 315.535H873.861V316.108L874.356 316.398L874.861 315.535ZM874.861 314.545L875.356 313.676L873.861 312.825V314.545H874.861ZM875.718 315.033H876.718V314.451L876.213 314.163L875.718 315.033ZM876.224 315.175L875.367 314.672L874.356 316.398L875.213 316.9L876.224 315.175ZM875.861 315.535V314.545H873.861V315.535H875.861ZM874.367 315.414L875.224 315.902L876.213 314.163L875.356 313.676L874.367 315.414ZM874.718 315.033V316.038H876.718V315.033H874.718Z",
    fill: "#222222",
    mask: "url(#path-257-inside-52_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_204"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-259-inside-53_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.162 316.526L878.305 316.038V315.033L879.162 315.536V316.526Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 316.526L878.305 316.038V315.033L879.162 315.536V316.526Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.162 316.526L878.667 317.395L880.162 318.245V316.526H879.162ZM878.305 316.038H877.305V316.62L877.81 316.907L878.305 316.038ZM878.305 315.033L878.81 314.17L877.305 313.288V315.033H878.305ZM879.162 315.536H880.162V314.963L879.668 314.673L879.162 315.536ZM879.656 315.657L878.799 315.169L877.81 316.907L878.667 317.395L879.656 315.657ZM879.305 316.038V315.033H877.305V316.038H879.305ZM877.799 315.896L878.656 316.398L879.668 314.673L878.81 314.17L877.799 315.896ZM878.162 315.536V316.526H880.162V315.536H878.162Z",
    fill: "#222222",
    mask: "url(#path-259-inside-53_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_205"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-261-inside-54_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.27 314.65L873.486 312.462V308.088L877.27 310.275V314.65ZM873.826 312.27L876.93 314.059V310.482L873.826 308.694V312.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 314.65L873.486 312.462V308.088L877.27 310.275V314.65ZM873.826 312.27L876.93 314.059V310.482L873.826 308.694V312.27Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 314.65L876.769 315.515L878.27 316.383V314.65H877.27ZM873.486 312.462H872.486V313.039L872.986 313.328L873.486 312.462ZM873.486 308.088L873.987 307.222L872.486 306.355V308.088H873.486ZM877.27 310.275H878.27V309.698L877.77 309.409L877.27 310.275ZM873.826 312.27H872.826V312.848L873.327 313.137L873.826 312.27ZM876.93 314.059L876.431 314.925L877.93 315.789V314.059H876.93ZM876.93 310.482H877.93V309.904L877.429 309.616L876.93 310.482ZM873.826 308.694L874.326 307.827L872.826 306.963V308.694H873.826ZM877.77 313.784L873.987 311.597L872.986 313.328L876.769 315.515L877.77 313.784ZM874.486 312.462V308.088H872.486V312.462H874.486ZM872.986 308.954L876.769 311.141L877.77 309.409L873.987 307.222L872.986 308.954ZM876.27 310.275V314.65H878.27V310.275H876.27ZM873.327 313.137L876.431 314.925L877.429 313.192L874.326 311.404L873.327 313.137ZM877.93 314.059V310.482H875.93V314.059H877.93ZM877.429 309.616L874.326 307.827L873.327 309.56L876.431 311.349L877.429 309.616ZM872.826 308.694V312.27H874.826V308.694H872.826Z",
    fill: "#222222",
    mask: "url(#path-261-inside-54_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_206"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-263-inside-55_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.88 308.929L872.703 308.826V306.742L874.521 307.777V307.984L872.88 307.038V308.929Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M872.88 308.929L872.703 308.826V306.742L874.521 307.777V307.984L872.88 307.038V308.929Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.88 308.929L872.377 309.793L873.88 310.67V308.929H872.88ZM872.703 308.826H871.703V309.401L872.2 309.69L872.703 308.826ZM872.703 306.742L873.198 305.873L871.703 305.022V306.742H872.703ZM874.521 307.777H875.521V307.195L875.016 306.908L874.521 307.777ZM874.521 307.984L874.021 308.85L875.521 309.715V307.984H874.521ZM872.88 307.038L873.38 306.171L871.88 305.307V307.038H872.88ZM873.384 308.066L873.207 307.962L872.2 309.69L872.377 309.793L873.384 308.066ZM873.703 308.826V306.742H871.703V308.826H873.703ZM872.208 307.611L874.026 308.646L875.016 306.908L873.198 305.873L872.208 307.611ZM873.521 307.777V307.984H875.521V307.777H873.521ZM875.02 307.117L873.38 306.171L872.381 307.904L874.021 308.85L875.02 307.117ZM871.88 307.038V308.929H873.88V307.038H871.88Z",
    fill: "#222222",
    mask: "url(#path-263-inside-55_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_207"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-265-inside-56_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.083 315.387L883.906 315.284V313.392L882.266 312.461V312.254L884.083 313.303V315.387Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 315.387L883.906 315.284V313.392L882.266 312.461V312.254L884.083 313.303V315.387Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 315.387L883.58 316.251L885.083 317.127V315.387H884.083ZM883.906 315.284H882.906V315.858L883.402 316.148L883.906 315.284ZM883.906 313.392H884.906V312.81L884.4 312.522L883.906 313.392ZM882.266 312.461H881.266V313.043L881.772 313.331L882.266 312.461ZM882.266 312.254L882.766 311.388L881.266 310.522V312.254H882.266ZM884.083 313.303H885.083V312.726L884.583 312.437L884.083 313.303ZM884.587 314.523L884.41 314.42L883.402 316.148L883.58 316.251L884.587 314.523ZM884.906 315.284V313.392H882.906V315.284H884.906ZM884.4 312.522L882.759 311.591L881.772 313.331L883.412 314.262L884.4 312.522ZM883.266 312.461V312.254H881.266V312.461H883.266ZM881.766 313.12L883.583 314.169L884.583 312.437L882.766 311.388L881.766 313.12ZM883.083 313.303V315.387H885.083V313.303H883.083Z",
    fill: "#222222",
    mask: "url(#path-265-inside-56_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_208"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-267-inside-57_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.521 320.914L872.703 319.865V317.781L872.88 317.87V319.762L874.521 320.707V320.914Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M874.521 320.914L872.703 319.865V317.781L872.88 317.87V319.762L874.521 320.707V320.914Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.521 320.914L874.021 321.78L875.521 322.646V320.914H874.521ZM872.703 319.865H871.703V320.442L872.203 320.731L872.703 319.865ZM872.703 317.781L873.15 316.887L871.703 316.163V317.781H872.703ZM872.88 317.87H873.88V317.252L873.328 316.975L872.88 317.87ZM872.88 319.762H871.88V320.339L872.381 320.628L872.88 319.762ZM874.521 320.707H875.521V320.13L875.02 319.841L874.521 320.707ZM875.021 320.048L873.203 318.999L872.203 320.731L874.021 321.78L875.021 320.048ZM873.703 319.865V317.781H871.703V319.865H873.703ZM872.256 318.676L872.433 318.764L873.328 316.975L873.15 316.887L872.256 318.676ZM871.88 317.87V319.762H873.88V317.87H871.88ZM872.381 320.628L874.021 321.574L875.02 319.841L873.38 318.895L872.381 320.628ZM873.521 320.707V320.914H875.521V320.707H873.521Z",
    fill: "#222222",
    mask: "url(#path-267-inside-57_608_71031)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_209"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-269-inside-58_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.083 326.428L882.266 325.378V325.186L883.906 326.132V324.24L884.083 324.344V326.428Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 326.428L882.266 325.378V325.186L883.906 326.132V324.24L884.083 324.344V326.428Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.083 326.428L883.583 327.294L885.083 328.159V326.428H884.083ZM882.266 325.378H881.266V325.956L881.766 326.244L882.266 325.378ZM882.266 325.186L882.765 324.32L881.266 323.455V325.186H882.266ZM883.906 326.132L883.407 326.998L884.906 327.863V326.132H883.906ZM883.906 324.24L884.41 323.376L882.906 322.499V324.24H883.906ZM884.083 324.344H885.083V323.769L884.587 323.48L884.083 324.344ZM884.583 325.561L882.766 324.512L881.766 326.244L883.583 327.294L884.583 325.561ZM883.266 325.378V325.186H881.266V325.378H883.266ZM881.766 326.052L883.407 326.998L884.406 325.266L882.765 324.32L881.766 326.052ZM884.906 326.132V324.24H882.906V326.132H884.906ZM883.402 325.104L883.58 325.207L884.587 323.48L884.41 323.376L883.402 325.104ZM883.083 324.344V326.428H885.083V324.344H883.083Z",
    fill: "#222222",
    mask: "url(#path-269-inside-58_608_71031)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M881.765 314.626V315.467L881.051 315.054V314.214L881.765 314.626Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M875.735 318.115V318.949L875.021 318.53V317.702L875.735 318.115Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_212"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-273-inside-59_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M877.27 321.609L873.486 319.422V315.047L877.27 317.234V321.609ZM873.826 319.215L876.93 321.003V317.426L873.826 315.638V319.215Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 321.609L873.486 319.422V315.047L877.27 317.234V321.609ZM873.826 319.215L876.93 321.003V317.426L873.826 315.638V319.215Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.27 321.609L876.769 322.475L878.27 323.342V321.609H877.27ZM873.486 319.422H872.486V319.999L872.986 320.287L873.486 319.422ZM873.486 315.047L873.987 314.181L872.486 313.314V315.047H873.486ZM877.27 317.234H878.27V316.657L877.77 316.368L877.27 317.234ZM873.826 319.215H872.826V319.793L873.327 320.081L873.826 319.215ZM876.93 321.003L876.431 321.869L877.93 322.733V321.003H876.93ZM876.93 317.426H877.93V316.848L877.429 316.56L876.93 317.426ZM873.826 315.638L874.326 314.772L872.826 313.908V315.638H873.826ZM877.77 320.743L873.987 318.556L872.986 320.287L876.769 322.475L877.77 320.743ZM874.486 319.422V315.047H872.486V319.422H874.486ZM872.986 315.913L876.769 318.1L877.77 316.368L873.987 314.181L872.986 315.913ZM876.27 317.234V321.609H878.27V317.234H876.27ZM873.327 320.081L876.431 321.869L877.429 320.136L874.326 318.348L873.327 320.081ZM877.93 321.003V317.426H875.93V321.003H877.93ZM877.429 316.56L874.326 314.772L873.327 316.505L876.431 318.293L877.429 316.56ZM872.826 315.638V319.215H874.826V315.638H872.826Z",
    fill: "#222222",
    mask: "url(#path-273-inside-59_608_71031)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M881.765 321.587V322.428L881.051 322.015V321.175L881.765 321.587Z",
    fill: "#222222",
    stroke: "#222222"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_214"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-276-inside-60_608_71031",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.3 325.083L879.517 322.896V318.521L883.3 320.709V325.083ZM879.856 322.689L882.96 324.477V320.901L879.856 319.113V322.689Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 325.083L879.517 322.896V318.521L883.3 320.709V325.083ZM879.856 322.689L882.96 324.477V320.901L879.856 319.113V322.689Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M883.3 325.083L882.799 325.949L884.3 326.817V325.083H883.3ZM879.517 322.896H878.517V323.473L879.016 323.762L879.517 322.896ZM879.517 318.521L880.017 317.656L878.517 316.788V318.521H879.517ZM883.3 320.709H884.3V320.132L883.8 319.843L883.3 320.709ZM879.856 322.689H878.856V323.267L879.357 323.556L879.856 322.689ZM882.96 324.477L882.461 325.344L883.96 326.208V324.477H882.96ZM882.96 320.901H883.96V320.323L883.459 320.034L882.96 320.901ZM879.856 319.113L880.356 318.246L878.856 317.382V319.113H879.856ZM883.8 324.218L880.017 322.03L879.016 323.762L882.799 325.949L883.8 324.218ZM880.517 322.896V318.521H878.517V322.896H880.517ZM879.016 319.387L882.799 321.574L883.8 319.843L880.017 317.656L879.016 319.387ZM882.3 320.709V325.083H884.3V320.709H882.3ZM879.357 323.556L882.461 325.344L883.459 323.611L880.356 321.823L879.357 323.556ZM883.96 324.477V320.901H881.96V324.477H883.96ZM883.459 320.034L880.356 318.246L879.357 319.979L882.461 321.767L883.459 320.034ZM878.856 319.113V322.689H880.856V319.113H878.856Z",
    fill: "#222222",
    mask: "url(#path-276-inside-60_608_71031)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M979.468 393.641L977.36 392.412C976.069 391.665 974.287 391.766 972.319 392.902L974.427 394.131C976.395 392.995 978.177 392.894 979.468 393.641Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M967.317 409.673L969.425 410.902C968.157 410.163 967.364 408.592 967.364 406.359C967.348 401.871 970.514 396.387 974.427 394.131L972.319 392.902C968.406 395.166 965.24 400.642 965.256 405.13C965.256 407.363 966.049 408.934 967.317 409.673Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M974.427 394.131C970.515 396.394 967.349 401.87 967.364 406.358C967.38 410.854 970.561 412.667 974.474 410.403C978.379 408.147 981.544 402.671 981.537 398.175C981.521 393.687 978.34 391.867 974.435 394.123L974.427 394.131Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M974.434 397.811C972.287 399.048 970.553 402.05 970.561 404.516C970.561 406.982 972.311 407.97 974.458 406.733C976.597 405.496 978.331 402.494 978.323 400.036C978.323 397.578 976.573 396.582 974.426 397.819L974.434 397.811Z",
    fill: "#E7EEF2",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M974.442 400.93C973.797 401.303 973.276 402.206 973.283 402.945C973.283 403.684 973.812 403.979 974.45 403.614C975.096 403.24 975.609 402.346 975.609 401.607C975.609 400.868 975.08 400.572 974.442 400.938V400.93Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "right-truck-wrap"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M505.169 555.006L789.324 385.805C791.806 384.338 791.495 381.746 788.632 380.059L716.543 337.41C713.656 335.698 709.313 335.527 706.831 336.994L422.676 506.195C420.194 507.662 420.505 510.254 423.368 511.941L495.457 554.59C498.344 556.302 502.687 556.473 505.169 555.006Z",
    fill: "#9C93AA",
    fillOpacity: 0.19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 481817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M595.244 491.411C594.938 491.236 594.587 491.148 594.215 491.148C593.689 491.148 593.098 491.323 592.507 491.673C589.9 493.182 587.798 497.227 587.798 500.704C587.798 502.431 588.323 503.743 589.265 504.268C590.01 504.683 590.973 504.596 592.003 504.006C594.609 502.497 596.711 498.452 596.711 494.975C596.711 493.248 596.186 491.936 595.244 491.411Z",
    fill: "url(#paint12_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M511.934 497.423C511.934 497.423 511.781 497.357 511.715 497.357C511.54 497.357 511.343 497.445 511.233 497.51L505.342 500.9C504.466 501.403 503.743 502.824 503.743 504.005C503.743 504.529 503.896 504.923 504.137 505.054C504.378 505.185 504.685 505.054 504.838 504.967L510.73 501.578C511.606 501.075 512.328 499.653 512.328 498.473C512.328 497.948 512.175 497.554 511.934 497.423Z",
    fill: "url(#paint13_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M514.496 532.89C517.081 526.265 521.395 520.711 526.06 518.021C528.009 516.906 529.893 516.337 531.645 516.316L526.564 513.342C525.863 513.604 525.14 513.954 524.417 514.37C517.978 518.087 512.262 526.833 510.204 536.17C510.182 536.279 510.116 536.367 510.028 536.432C510.028 536.432 510.028 536.432 510.007 536.454C510.007 536.454 509.985 536.476 509.963 536.498L501.29 541.68C502.013 544.916 503.633 547.256 505.867 548.262C505.977 548.306 506.043 548.393 506.086 548.459L514.343 553.203C512.941 551.039 512.175 548.043 512.175 544.501C512.175 540.959 512.985 536.804 514.518 532.89H514.496Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M477.287 521.323C477.287 521.016 477.308 520.732 477.308 520.426L463.796 512.62L460.839 530.025L460.138 534.136C460.007 534.967 459.459 535.689 458.693 536.038C458.342 536.213 457.97 536.279 457.598 536.279C457.138 536.279 456.7 536.17 456.306 535.929L431.382 521.541C429.433 520.426 428.185 518.414 428.032 516.184L427.221 503.83C427.199 503.371 427.156 502.387 427.09 501.184C427.024 501.053 427.024 500.9 427.09 500.769C426.958 497.357 426.761 492.416 426.718 491.191L412.964 483.254C412.964 483.363 412.964 483.494 412.964 483.604V511.417C412.964 512.773 413.358 513.866 414.037 514.369C414.037 514.369 414.059 514.413 414.081 514.413L477.637 551.126C477.44 550.536 477.308 549.88 477.308 549.136V521.323H477.287ZM425.25 515.309C425.25 516.031 424.987 516.6 424.506 516.862C424.33 516.971 424.111 517.015 423.892 517.015C423.63 517.015 423.367 516.928 423.082 516.774L416.096 512.751C415.176 512.226 414.453 510.871 414.453 509.668V490.951C414.453 490.229 414.716 489.661 415.198 489.398C415.614 489.158 416.118 489.18 416.621 489.464L423.608 493.487C424.527 494.012 425.25 495.368 425.25 496.57V515.288V515.309ZM475.096 543.954C475.096 544.675 474.834 545.244 474.352 545.506C474.177 545.616 473.958 545.659 473.739 545.659C473.476 545.659 473.191 545.572 472.928 545.419L465.942 541.396C465.022 540.871 464.299 539.515 464.299 538.312V519.595C464.299 518.874 464.562 518.305 465.044 518.043C465.46 517.802 465.964 517.824 466.468 518.108L473.454 522.132C474.374 522.656 475.096 524.012 475.096 525.215V543.932V543.954Z",
    fill: "url(#paint14_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M495.027 490.295L490.45 487.671C490.296 487.583 490.034 487.474 489.836 487.561L489.749 487.605C489.53 487.758 489.398 488.13 489.398 488.589V500.2C489.398 501.031 489.771 501.971 490.296 502.605C490.493 502.846 490.712 503.064 490.953 503.196L495.531 505.841C495.684 505.929 495.947 506.038 496.166 505.951H496.21C496.429 505.776 496.56 505.404 496.56 504.923V493.312C496.56 492.175 495.859 490.798 495.005 490.317L495.027 490.295Z",
    fill: "url(#paint15_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M497.217 538.422L504.203 534.398V529.697L497.217 533.721V538.422Z",
    fill: "url(#paint16_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M418.001 468.517L476.608 502.365L488.259 459.114L429.652 425.266L418.001 468.517Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M491.85 485.486C492.179 485.486 492.507 485.551 492.858 485.726L497.435 488.35C498.596 489.006 499.494 490.712 499.494 492.242V496.725L509.196 491.149C510.926 490.165 512.328 487.454 512.328 485.136V452.599C512.328 451.484 511.999 450.631 511.408 450.303C510.838 449.975 510.159 450.216 509.7 450.478L499.056 456.601C497.72 457.366 496.493 459.356 496.012 461.543C494.895 466.769 492.047 477.614 489.704 486.426L491.434 485.486C491.566 485.42 491.719 485.42 491.85 485.464V485.486Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M491.326 461.563C492.136 457.715 494.523 454.063 497.239 452.489L536.901 429.202C537.142 429.07 537.383 428.961 537.624 428.874L473.936 392.095C473.936 392.095 473.914 392.073 473.893 392.051C473.871 392.051 473.827 392.051 473.805 392.051C473.301 391.898 472.71 392.008 472.053 392.379L432.39 415.667C429.916 417.088 427.726 420.477 426.959 424.085L414.782 469.741C414.059 472.409 413.6 475.142 413.293 477.875L477.703 515.069C478.01 512.424 478.492 509.778 479.171 507.198L491.347 461.563H491.326ZM490.669 452.489C490.8 452.248 491.128 452.161 491.369 452.292L491.961 452.642C492.202 452.773 492.289 453.101 492.158 453.342C492.07 453.495 491.895 453.604 491.72 453.604C491.632 453.604 491.545 453.582 491.457 453.538L490.866 453.189C490.625 453.057 490.537 452.729 490.669 452.489ZM487.121 450.434C487.252 450.193 487.581 450.106 487.821 450.237L489.004 450.915C489.245 451.046 489.333 451.374 489.201 451.614C489.114 451.767 488.938 451.877 488.763 451.877C488.676 451.877 488.588 451.855 488.5 451.811L487.318 451.133C487.077 451.002 486.989 450.674 487.121 450.434ZM483.573 448.378C483.704 448.138 484.033 448.05 484.273 448.181L485.456 448.859C485.697 448.99 485.785 449.318 485.653 449.559C485.566 449.712 485.39 449.821 485.215 449.821C485.128 449.821 485.04 449.821 484.952 449.756L483.77 449.078C483.529 448.947 483.441 448.619 483.573 448.378ZM480.025 446.323C480.156 446.082 480.485 445.995 480.726 446.126L481.908 446.804C482.149 446.935 482.237 447.263 482.105 447.503C482.018 447.657 481.842 447.766 481.667 447.766C481.58 447.766 481.492 447.766 481.404 447.7L480.222 447.022C479.981 446.891 479.893 446.563 480.025 446.323ZM476.477 444.267C476.608 444.027 476.937 443.939 477.178 444.07L478.36 444.748C478.601 444.88 478.689 445.208 478.557 445.448C478.47 445.601 478.295 445.71 478.119 445.71C478.032 445.71 477.944 445.689 477.857 445.645L476.674 444.967C476.433 444.836 476.345 444.508 476.477 444.267ZM472.929 442.212C473.06 441.971 473.389 441.884 473.63 442.015L474.812 442.693C475.053 442.824 475.141 443.152 475.009 443.393C474.922 443.546 474.747 443.655 474.571 443.655C474.484 443.655 474.396 443.633 474.309 443.589L473.126 442.912C472.885 442.78 472.797 442.452 472.929 442.212ZM469.381 440.157C469.512 439.916 469.841 439.828 470.082 439.96L471.264 440.638C471.505 440.769 471.593 441.097 471.462 441.337C471.374 441.49 471.199 441.6 471.024 441.6C470.936 441.6 470.848 441.578 470.761 441.534L469.578 440.856C469.337 440.725 469.25 440.397 469.381 440.157ZM465.833 438.101C465.964 437.861 466.293 437.773 466.534 437.904L467.716 438.582C467.957 438.713 468.045 439.041 467.914 439.282C467.826 439.435 467.651 439.544 467.476 439.544C467.388 439.544 467.3 439.544 467.213 439.479L466.03 438.801C465.789 438.67 465.702 438.342 465.833 438.101ZM462.285 436.046C462.416 435.805 462.745 435.718 462.986 435.849L464.169 436.527C464.409 436.658 464.497 436.986 464.366 437.226C464.278 437.38 464.103 437.489 463.928 437.489C463.84 437.489 463.752 437.467 463.665 437.423L462.482 436.745C462.241 436.614 462.154 436.286 462.285 436.046ZM458.737 433.99C458.869 433.75 459.197 433.662 459.438 433.793L460.621 434.471C460.862 434.603 460.949 434.931 460.818 435.171C460.73 435.324 460.555 435.433 460.38 435.433C460.292 435.433 460.204 435.412 460.117 435.368L458.934 434.69C458.693 434.559 458.606 434.231 458.737 433.99ZM455.189 431.935C455.321 431.694 455.649 431.607 455.89 431.738L457.073 432.416C457.314 432.547 457.401 432.875 457.27 433.116C457.182 433.269 457.007 433.378 456.832 433.378C456.744 433.378 456.657 433.378 456.569 433.312L455.386 432.635C455.145 432.503 455.058 432.175 455.189 431.935ZM451.641 429.879C451.773 429.639 452.101 429.551 452.342 429.683L453.525 430.361C453.766 430.492 453.853 430.82 453.722 431.06C453.634 431.213 453.459 431.323 453.284 431.323C453.196 431.323 453.109 431.301 453.021 431.257L451.838 430.579C451.597 430.448 451.51 430.12 451.641 429.879ZM448.093 427.824C448.225 427.584 448.553 427.496 448.794 427.627L449.977 428.305C450.218 428.436 450.305 428.764 450.174 429.005C450.086 429.158 449.911 429.267 449.736 429.267C449.648 429.267 449.561 429.245 449.473 429.202L448.29 428.524C448.05 428.393 447.962 428.065 448.093 427.824ZM444.545 425.769C444.677 425.528 445.005 425.441 445.246 425.572L446.429 426.25C446.67 426.381 446.757 426.709 446.626 426.949C446.538 427.103 446.363 427.212 446.188 427.212C446.1 427.212 446.013 427.19 445.925 427.146L444.743 426.468C444.502 426.337 444.414 426.009 444.545 425.769ZM440.997 423.713C441.129 423.473 441.457 423.385 441.698 423.516L442.881 424.194C443.122 424.326 443.209 424.654 443.078 424.894C442.99 425.047 442.815 425.156 442.64 425.156C442.552 425.156 442.465 425.135 442.377 425.091L441.195 424.413C440.954 424.282 440.866 423.954 440.997 423.713ZM437.45 421.658C437.581 421.417 437.909 421.33 438.15 421.461L439.333 422.139C439.574 422.27 439.662 422.598 439.53 422.839C439.443 422.992 439.267 423.101 439.092 423.101C439.005 423.101 438.917 423.101 438.829 423.035L437.647 422.358C437.406 422.226 437.318 421.898 437.45 421.658ZM433.902 419.602C434.033 419.362 434.362 419.274 434.602 419.406L435.785 420.084C436.026 420.215 436.114 420.543 435.982 420.783C435.895 420.936 435.719 421.046 435.544 421.046C435.457 421.046 435.369 421.024 435.281 420.98L434.099 420.302C433.858 420.171 433.77 419.843 433.902 419.602ZM430.945 417.897C431.076 417.656 431.405 417.569 431.646 417.7L432.237 418.05C432.478 418.181 432.566 418.509 432.434 418.75C432.347 418.903 432.171 419.012 431.996 419.012C431.909 419.012 431.821 418.99 431.733 418.946L431.142 418.597C430.901 418.465 430.814 418.137 430.945 417.897ZM477.572 503.174C477.572 503.174 477.572 503.174 477.572 503.196C477.572 503.218 477.572 503.262 477.55 503.284C477.528 503.327 477.484 503.349 477.462 503.371C477.44 503.393 477.419 503.415 477.397 503.437C477.309 503.502 477.221 503.524 477.112 503.524C477.068 503.524 477.024 503.524 476.981 503.524C476.959 503.524 476.937 503.502 476.893 503.48C476.893 503.48 476.871 503.48 476.849 503.48L417.323 469.107C417.323 469.107 417.323 469.107 417.301 469.085C417.279 469.085 417.257 469.041 417.213 469.02C417.191 468.998 417.169 468.976 417.148 468.954C417.148 468.932 417.126 468.888 417.104 468.867C417.104 468.845 417.082 468.801 417.082 468.779C417.082 468.757 417.082 468.713 417.082 468.692C417.082 468.648 417.082 468.626 417.082 468.582C417.082 468.582 417.082 468.56 417.082 468.539L428.996 424.26C428.996 424.26 428.996 424.216 429.018 424.194C429.018 424.172 429.018 424.151 429.04 424.129C429.04 424.129 429.04 424.129 429.062 424.107C429.062 424.085 429.105 424.063 429.127 424.041C429.149 424.019 429.171 423.998 429.215 423.976C429.215 423.976 429.259 423.954 429.281 423.932C429.324 423.932 429.346 423.91 429.39 423.888C429.412 423.888 429.434 423.888 429.478 423.888C429.521 423.888 429.543 423.888 429.587 423.888C429.587 423.888 429.609 423.888 429.631 423.888C429.653 423.888 429.675 423.888 429.697 423.91C429.697 423.91 429.74 423.91 429.762 423.91L489.289 458.283C489.289 458.283 489.289 458.283 489.311 458.305C489.333 458.305 489.354 458.349 489.398 458.371C489.42 458.393 489.442 458.415 489.464 458.436C489.464 458.458 489.486 458.502 489.508 458.524C489.508 458.546 489.53 458.59 489.53 458.611C489.53 458.633 489.53 458.677 489.53 458.699C489.53 458.743 489.53 458.764 489.53 458.808C489.53 458.808 489.53 458.83 489.53 458.852L477.616 503.131L477.572 503.174Z",
    fill: "url(#paint17_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M488.391 491.411C487.077 496.265 486.135 499.72 486.113 499.807C485.85 501.316 486.113 502.584 486.858 503.087C487.449 503.502 488.15 503.24 488.653 502.956L489.135 502.672C488.675 501.928 488.391 501.01 488.391 500.157V491.389V491.411Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M496.932 489.245L492.355 486.621C492.136 486.512 491.961 486.447 491.807 486.49L491.106 486.862L495.53 489.42C496.691 490.076 497.589 491.782 497.589 493.312V504.923C497.589 504.923 497.589 505.076 497.567 505.164L497.896 504.967C498.29 504.683 498.465 504.464 498.465 503.874V492.263C498.465 491.126 497.764 489.748 496.91 489.267L496.932 489.245Z",
    fill: "#DFD9E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M516.358 520.448V442.43L497.742 453.363C495.268 454.784 493.078 458.173 492.311 461.781L480.134 507.437C478.93 511.964 478.316 516.621 478.316 521.3V549.114C478.316 550.601 478.776 551.716 479.565 552.175C480.2 552.547 481.01 552.459 481.908 551.956L497.458 542.773L500.436 541.002L509.284 535.71C510.554 530.09 513.139 524.711 516.38 520.426L516.358 520.448ZM495.027 506.694L490.449 504.048C490.209 503.917 489.968 503.72 489.749 503.48L489.135 503.829C488.588 504.157 488.04 504.31 487.537 504.31C487.077 504.31 486.639 504.179 486.266 503.917C485.193 503.173 484.777 501.555 485.106 499.566C485.193 499.238 492.968 470.855 495.027 461.322C495.574 458.829 496.954 456.643 498.553 455.702L509.197 449.58C510.182 449.011 511.146 448.946 511.912 449.405C512.81 449.93 513.336 451.089 513.336 452.576V485.112C513.336 487.802 511.737 490.841 509.7 492L499.494 497.86V503.807C499.494 504.748 499.144 505.207 498.706 505.557C498.662 505.622 498.618 505.666 498.553 505.71L498.465 505.754C498.465 505.754 498.465 505.754 498.443 505.775C498.443 505.775 498.443 505.775 498.421 505.775L496.757 506.716C496.757 506.716 496.757 506.716 496.713 506.738C496.713 506.738 496.669 506.738 496.647 506.759H496.604C496.604 506.759 496.582 506.781 496.56 506.781C496.363 506.869 496.166 506.912 495.968 506.912C495.662 506.912 495.333 506.825 495.005 506.628L495.027 506.694ZM505.233 534.682C505.233 534.857 505.145 535.032 504.97 535.12L496.954 539.733C496.954 539.733 496.779 539.799 496.691 539.799C496.604 539.799 496.516 539.777 496.428 539.733C496.275 539.646 496.166 539.471 496.166 539.296V533.414C496.166 533.239 496.253 533.064 496.428 532.977L504.444 528.363C504.597 528.276 504.794 528.276 504.948 528.363C505.101 528.45 505.211 528.625 505.211 528.8V534.682H505.233ZM504.378 506.125C504.116 506.125 503.875 506.06 503.656 505.928C503.086 505.601 502.758 504.901 502.758 503.982C502.758 502.43 503.678 500.681 504.86 500.003L510.752 496.614C511.365 496.264 511.978 496.22 512.482 496.526C513.051 496.854 513.38 497.554 513.38 498.472C513.38 500.025 512.46 501.774 511.277 502.452L505.386 505.841C505.057 506.038 504.707 506.125 504.4 506.125H504.378Z",
    fill: "#B1C8DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M591.981 479.21C594.018 478.029 596.011 477.482 597.85 477.526L595.792 476.367L567.408 492.723C567.299 493.204 567.211 493.685 567.146 494.166L570.562 496.112C570.562 496.112 570.737 496.265 570.781 496.375C573.76 498.277 575.49 502.344 575.49 507.636C575.49 508.882 575.402 510.15 575.205 511.44L580.242 514.37C578.862 512.206 578.096 509.232 578.096 505.689C578.096 495.5 584.338 483.627 592.003 479.21H591.981Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M569.993 497.073C569.008 496.505 567.913 496.221 566.73 496.221C565.131 496.221 563.357 496.745 561.561 497.773C554.181 502.037 548.158 513.517 548.158 523.378C548.158 528.473 549.779 532.321 552.626 533.961C554.947 535.295 557.926 535.033 561.058 533.24C568.438 528.976 574.461 517.496 574.461 507.635C574.461 502.54 572.84 498.692 569.993 497.052V497.073ZM561.561 528.014C560.226 528.779 558.933 529.173 557.707 529.173C556.787 529.173 555.911 528.954 555.123 528.495C552.976 527.249 551.75 524.428 551.75 520.754C551.75 513.954 555.911 506.017 561.058 503.065C563.401 501.709 565.679 501.556 567.475 502.584C569.621 503.83 570.847 506.651 570.847 510.324C570.847 517.125 566.686 525.062 561.54 528.014H561.561Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M531.995 524.558C531.382 524.208 530.681 524.033 529.936 524.033C528.907 524.033 527.768 524.383 526.607 525.039C521.767 527.838 517.825 535.382 517.825 541.854C517.825 545.156 518.876 547.67 520.694 548.72C522.183 549.573 524.089 549.398 526.104 548.239C530.944 545.44 534.886 537.896 534.886 531.424C534.886 528.122 533.835 525.608 532.017 524.558H531.995ZM526.323 526.132C526.848 525.826 527.264 526.132 527.264 526.832C527.264 527.532 526.848 528.319 526.323 528.625C525.797 528.931 525.381 528.625 525.381 527.925C525.381 527.226 525.797 526.438 526.323 526.132ZM520.738 532.43C521.11 531.73 521.702 531.402 522.052 531.664C522.424 531.949 522.424 532.736 522.052 533.414C521.68 534.113 521.088 534.441 520.738 534.179C520.366 533.895 520.366 533.108 520.738 532.43ZM519.358 541.898C518.833 542.204 518.417 541.898 518.417 541.198C518.417 540.498 518.833 539.711 519.358 539.405C519.884 539.099 520.3 539.405 520.3 540.105C520.3 540.804 519.884 541.592 519.358 541.898ZM522.052 546.533C521.68 547.233 521.088 547.561 520.738 547.299C520.366 547.014 520.366 546.227 520.738 545.549C521.11 544.85 521.702 544.522 522.052 544.784C522.424 545.068 522.424 545.855 522.052 546.533ZM526.301 547.146C525.775 547.452 525.359 547.146 525.359 546.446C525.359 545.746 525.775 544.959 526.301 544.653C526.826 544.347 527.243 544.653 527.243 545.353C527.243 546.052 526.826 546.839 526.301 547.146ZM526.564 543.691C525.797 544.128 525.031 544.347 524.33 544.347C523.782 544.347 523.257 544.216 522.797 543.953C521.548 543.232 520.826 541.613 520.826 539.492C520.826 535.688 523.169 531.227 526.06 529.565C527.418 528.778 528.754 528.691 529.827 529.303C531.075 530.024 531.798 531.643 531.798 533.764C531.798 537.568 529.455 542.029 526.564 543.691ZM531.886 540.848C531.513 541.548 530.922 541.876 530.571 541.613C530.199 541.329 530.199 540.542 530.571 539.864C530.944 539.164 531.535 538.836 531.886 539.099C532.258 539.383 532.258 540.17 531.886 540.848ZM531.886 527.75C531.513 528.45 530.922 528.778 530.571 528.516C530.199 528.231 530.199 527.444 530.571 526.766C530.944 526.067 531.535 525.739 531.886 526.001C532.258 526.285 532.258 527.073 531.886 527.75ZM533.265 531.38C533.791 531.074 534.207 531.38 534.207 532.08C534.207 532.78 533.791 533.567 533.265 533.873C532.74 534.179 532.324 533.873 532.324 533.173C532.324 532.473 532.74 531.686 533.265 531.38Z",
    fill: "url(#paint18_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M596.821 475.777L601.486 478.423C601.486 478.423 601.661 478.576 601.705 478.686C602.165 478.97 602.581 479.32 602.997 479.713V477.549L598.376 474.881L596.843 475.777H596.821Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M566.97 503.437C566.356 503.087 565.656 502.912 564.911 502.912C563.882 502.912 562.743 503.24 561.582 503.918C556.742 506.717 552.8 514.261 552.8 520.733C552.8 524.035 553.851 526.549 555.669 527.599C557.136 528.452 559.063 528.277 561.078 527.118C565.918 524.319 569.861 516.775 569.861 510.303C569.861 507.001 568.809 504.486 566.992 503.437H566.97ZM561.297 505.011C561.823 504.705 562.239 505.011 562.239 505.711C562.239 506.411 561.823 507.198 561.297 507.504C560.772 507.81 560.356 507.504 560.356 506.804C560.356 506.105 560.772 505.317 561.297 505.011ZM555.713 511.309C556.085 510.609 556.676 510.281 557.027 510.543C557.377 510.806 557.399 511.615 557.027 512.293C556.654 512.97 556.063 513.32 555.713 513.058C555.34 512.774 555.34 511.986 555.713 511.309ZM554.333 520.777C553.807 521.083 553.391 520.777 553.391 520.077C553.391 519.377 553.807 518.59 554.333 518.284C554.858 517.978 555.275 518.284 555.275 518.984C555.275 519.683 554.858 520.47 554.333 520.777ZM557.027 525.412C556.654 526.112 556.063 526.44 555.713 526.178C555.34 525.893 555.34 525.106 555.713 524.428C556.085 523.729 556.676 523.401 557.027 523.663C557.399 523.947 557.399 524.734 557.027 525.412ZM561.275 526.024C560.75 526.331 560.334 526.024 560.334 525.325C560.334 524.625 560.75 523.838 561.275 523.532C561.801 523.226 562.217 523.532 562.217 524.231C562.217 524.931 561.801 525.718 561.275 526.024ZM561.538 522.57C560.772 523.007 560.005 523.226 559.304 523.226C558.757 523.226 558.231 523.094 557.771 522.832C556.523 522.11 555.8 520.492 555.8 518.371C555.8 514.567 558.144 510.106 561.035 508.444C562.392 507.657 563.728 507.57 564.801 508.182C566.05 508.903 566.773 510.521 566.773 512.642C566.773 516.447 564.429 520.908 561.538 522.57ZM566.86 519.727C566.488 520.427 565.896 520.755 565.546 520.492C565.174 520.208 565.174 519.421 565.546 518.743C565.918 518.043 566.51 517.715 566.86 517.978C567.232 518.262 567.232 519.049 566.86 519.727ZM566.86 506.629C566.488 507.329 565.896 507.657 565.546 507.395C565.174 507.11 565.174 506.323 565.546 505.645C565.918 504.946 566.51 504.618 566.86 504.88C567.232 505.164 567.232 505.951 566.86 506.629ZM568.24 510.259C568.766 509.953 569.182 510.259 569.182 510.959C569.182 511.659 568.766 512.446 568.24 512.752C567.714 513.058 567.298 512.752 567.298 512.052C567.298 511.352 567.714 510.565 568.24 510.259Z",
    fill: "url(#paint19_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M691.388 426.054L687.271 423.648L599.383 474.312L603.5 476.673L691.388 426.054Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M535.872 518.808L534.142 517.803C533.397 517.518 532.587 517.365 531.733 517.365C530.134 517.365 528.382 517.89 526.586 518.918C522.118 521.498 517.957 526.855 515.46 533.284C513.971 537.088 513.183 540.98 513.183 544.523C513.183 549.618 514.803 553.466 517.65 555.106C519.972 556.44 522.95 556.177 526.082 554.384C533.463 550.12 539.485 538.641 539.485 528.779C539.485 525.237 538.719 522.307 537.252 520.252C536.835 519.683 536.397 519.202 535.894 518.808H535.872ZM526.586 549.115C525.25 549.88 523.958 550.274 522.731 550.274C521.812 550.274 520.936 550.055 520.147 549.596C518.001 548.349 516.774 545.529 516.774 541.855C516.774 535.055 520.936 527.117 526.082 524.166C528.426 522.832 530.703 522.657 532.521 523.685C534.667 524.931 535.894 527.752 535.894 531.425C535.894 538.225 531.733 546.163 526.586 549.115Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M561.058 496.898C563.095 495.739 565.088 495.171 566.928 495.214L566.555 494.996H566.512C566.358 494.974 566.249 494.886 566.161 494.777L565.022 494.121L549.582 503.021C549.582 503.021 549.582 503.021 549.56 503.021C549.495 503.064 549.407 503.086 549.319 503.086C549.232 503.086 549.166 503.064 549.078 503.021C549.078 503.021 549.078 503.021 549.057 503.021L541.545 498.691V513.538C541.545 515.287 540.909 516.971 539.771 518.283C539.705 518.37 539.552 518.545 539.398 518.742C538.96 519.267 538.61 519.704 538.325 520.01C539.486 521.803 540.209 524.143 540.428 526.898L549.319 532.059C547.94 529.894 547.173 526.92 547.173 523.378C547.173 513.188 553.415 501.315 561.08 496.898H561.058Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M566.249 493.4L566.029 493.532L566.205 493.641C566.205 493.641 566.227 493.488 566.249 493.4Z",
    fill: "url(#paint20_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M564.32 509.079C564.014 508.904 563.663 508.816 563.291 508.816C562.765 508.816 562.174 508.991 561.583 509.341C558.977 510.85 556.874 514.895 556.874 518.372C556.874 520.099 557.4 521.411 558.341 521.936C559.086 522.351 560.05 522.264 561.079 521.674C563.685 520.187 565.788 516.12 565.788 512.643C565.788 510.916 565.262 509.604 564.32 509.079Z",
    fill: "url(#paint21_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M529.324 530.202C529.017 530.027 528.667 529.939 528.294 529.939C527.769 529.939 527.177 530.114 526.564 530.464C523.958 531.973 521.855 536.018 521.855 539.495C521.855 541.222 522.381 542.534 523.323 543.059C524.067 543.474 525.031 543.387 526.06 542.797C528.667 541.31 530.769 537.243 530.769 533.766C530.769 532.039 530.243 530.727 529.302 530.202H529.324Z",
    fill: "url(#paint22_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M418.263 447.636V452.643L419.227 449.057C419.227 449.057 419.161 448.904 419.161 448.817V446.608C419.161 445.471 418.46 444.094 417.606 443.613L413.029 440.967C412.832 440.857 412.634 440.814 412.481 440.836L411.78 441.207L416.204 443.766C417.365 444.422 418.263 446.127 418.263 447.658V447.636Z",
    fill: "#DFD9E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M532.849 513.081C531.338 512.512 529.652 512.468 527.878 512.928L534.492 516.82C535.697 517.279 536.77 518.066 537.689 519.181C537.755 519.094 537.843 519.006 537.93 518.919C536.901 515.967 535.149 513.955 532.871 513.103L532.849 513.081Z",
    fill: "#9C93AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M472.972 523.051L465.985 519.027C465.985 519.027 465.722 518.896 465.591 518.962C465.482 519.027 465.372 519.224 465.372 519.64V538.357C465.372 539.188 465.898 540.215 466.489 540.565L473.475 544.589C473.475 544.589 473.738 544.742 473.87 544.654C473.979 544.589 474.089 544.392 474.089 543.976V525.259C474.089 524.428 473.563 523.401 472.95 523.073L472.972 523.051ZM471.614 541.527C471.351 541.681 471.044 541.768 470.716 541.768C470.322 541.768 469.906 541.637 469.489 541.396C467.956 540.522 466.774 538.248 466.774 536.236C466.774 535.099 467.168 534.202 467.891 533.809C468.504 533.459 469.27 533.503 470.015 533.94C471.548 534.815 472.731 537.089 472.731 539.1C472.731 540.237 472.337 541.134 471.614 541.527ZM472.249 532.825C471.899 533.022 471.526 533.131 471.11 533.131C470.584 533.131 470.037 532.978 469.489 532.65C467.409 531.447 465.788 528.364 465.788 525.631C465.788 524.1 466.314 522.941 467.234 522.395C468.022 521.936 469.008 522.001 469.993 522.57C472.074 523.772 473.694 526.855 473.694 529.589C473.694 531.119 473.169 532.278 472.249 532.825Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M477.572 516.184C477.572 516.184 477.55 516.184 477.528 516.184L413.162 479.012C413.074 480.039 413.008 481.089 412.986 482.117L477.353 519.289C477.397 518.261 477.462 517.212 477.55 516.184H477.572Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M538.981 517.606C539.966 516.469 540.514 515.025 540.514 513.517V432.547C540.514 431.344 540.164 430.448 539.594 430.01L539.2 429.792C538.696 429.617 538.083 429.704 537.404 430.076L517.387 441.84V519.18C519.38 516.797 521.614 514.829 523.913 513.495C524.789 512.992 525.643 512.598 526.497 512.292C528.907 511.439 531.184 511.374 533.221 512.139C535.652 513.057 537.514 515.091 538.674 518.021C538.806 517.868 538.915 517.715 538.981 517.649V517.606Z",
    fill: "#D0E1EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M755.361 281.673L679.782 238.094L473.717 356.87L549.297 400.427L755.361 281.673Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M541.521 497.512L548.793 501.71V491.63L541.521 487.432V497.512Z",
    fill: "url(#paint23_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M548.793 401.301L473.213 357.744V367.015L548.793 410.572V401.301Z",
    fill: "url(#paint24_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M459.788 530.244L428.799 512.336L429.04 515.856L459.285 533.262L459.788 530.244Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M474.22 391.156C474.22 391.156 474.352 391.178 474.417 391.222L539.682 428.897C539.682 428.897 539.857 428.941 539.945 429.006C540.01 429.05 540.054 429.116 540.12 429.159L540.229 429.225C540.229 429.225 540.361 429.334 540.405 429.4C541.105 430.078 541.522 431.171 541.522 432.57V486.273L548.793 490.471V411.776L473.213 368.219V391.003C473.52 391.003 473.804 391.003 474.089 391.112C474.133 391.112 474.177 391.156 474.22 391.2V391.156Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M417.256 456.47V447.658C417.256 446.52 416.555 445.143 415.701 444.662L411.124 442.038C410.971 441.95 410.708 441.841 410.511 441.929L410.445 441.972C410.226 442.125 410.095 442.497 410.095 442.956V454.567C410.095 455.704 410.796 457.082 411.65 457.563L416.249 460.318L417.278 456.491L417.256 456.47Z",
    fill: "url(#paint25_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M419.623 494.799C419.316 494.624 418.922 494.449 418.506 494.449C418.287 494.449 418.068 494.493 417.87 494.624C417.279 494.974 416.929 495.827 416.929 496.964C416.929 499.325 418.352 502.08 420.126 503.108C420.608 503.371 421.287 503.633 421.878 503.283C422.47 502.933 422.82 502.08 422.82 500.943C422.82 498.582 421.396 495.827 419.623 494.799Z",
    fill: "url(#paint26_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M431.886 520.667L456.809 535.055C457.269 535.317 457.795 535.339 458.277 535.121C458.649 534.946 458.912 534.662 459.065 534.29L429.236 517.125C429.609 518.612 430.55 519.88 431.908 520.667H431.886Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M419.622 506.17C419.425 506.06 419.162 505.951 418.899 505.951C418.768 505.951 418.636 505.973 418.527 506.061C418.155 506.279 417.936 506.848 417.936 507.613C417.936 509.231 418.943 511.199 420.148 511.877C420.454 512.052 420.892 512.227 421.264 512.008C421.637 511.789 421.856 511.221 421.856 510.456C421.856 508.837 420.848 506.87 419.644 506.192L419.622 506.17Z",
    fill: "url(#paint27_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M469.468 523.444C469.162 523.269 468.767 523.094 468.351 523.094C468.132 523.094 467.913 523.137 467.716 523.269C467.125 523.619 466.774 524.471 466.774 525.608C466.774 527.97 468.198 530.725 469.972 531.753C470.432 532.015 471.133 532.277 471.724 531.928C472.315 531.578 472.666 530.725 472.666 529.588C472.666 527.226 471.242 524.471 469.468 523.444Z",
    fill: "url(#paint28_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M469.469 534.814C469.271 534.705 469.009 534.596 468.746 534.596C468.614 534.596 468.483 534.618 468.374 534.683C468.001 534.902 467.782 535.47 467.782 536.236C467.782 537.854 468.79 539.822 469.994 540.5C470.301 540.674 470.739 540.849 471.111 540.631C471.483 540.412 471.702 539.844 471.702 539.078C471.702 537.46 470.695 535.492 469.49 534.814H469.469Z",
    fill: "url(#paint29_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M423.126 494.406L416.14 490.382C416.14 490.382 415.964 490.295 415.855 490.295C415.811 490.295 415.789 490.295 415.745 490.317C415.636 490.382 415.526 490.579 415.526 490.995V509.712C415.526 510.543 416.052 511.571 416.643 511.899L423.63 515.922C423.63 515.922 423.892 516.075 424.024 515.987C424.133 515.922 424.243 515.725 424.243 515.31V496.592C424.243 495.761 423.717 494.734 423.126 494.406ZM421.768 512.882C421.505 513.036 421.199 513.123 420.87 513.123C420.476 513.123 420.06 512.992 419.622 512.751C418.089 511.877 416.906 509.603 416.906 507.591C416.906 506.454 417.3 505.557 418.023 505.164C418.636 504.814 419.381 504.858 420.147 505.295C421.68 506.17 422.863 508.444 422.863 510.455C422.863 511.592 422.469 512.489 421.746 512.882H421.768ZM422.403 504.18C422.053 504.377 421.659 504.486 421.264 504.486C420.739 504.486 420.191 504.333 419.644 504.005C417.563 502.802 415.942 499.719 415.942 496.986C415.942 495.455 416.468 494.296 417.388 493.75C418.176 493.291 419.162 493.356 420.147 493.925C422.228 495.127 423.849 498.21 423.849 500.944C423.849 502.474 423.323 503.633 422.403 504.18Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M462.876 512.096L427.747 491.805C427.769 492.723 427.835 494.21 427.9 495.85L462.263 515.704L462.876 512.096Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M460.576 525.654L428.447 507.111L428.71 511.113L459.963 529.174L460.576 525.654Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M461.343 521.083L428.119 501.906C428.163 502.759 428.185 503.415 428.207 503.765L428.338 505.886L460.729 524.581L461.321 521.083H461.343Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M462.088 516.776L427.944 497.053C427.988 498.299 428.032 499.589 428.098 500.682L461.54 519.99L462.088 516.754V516.776Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M612.963 431.454C613.094 431.564 613.182 431.717 613.16 431.892C613.16 432.067 613.05 432.22 612.897 432.307L549.801 468.67V480.434L632.564 432.723L603.37 410.682C603.239 410.572 603.151 410.419 603.173 410.244C603.173 410.069 603.283 409.916 603.436 409.829L755.866 321.949V310.186L583.769 409.392L612.963 431.432V431.454Z",
    fill: "url(#paint30_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M691.739 427.016L604.004 477.548V480.937C604.595 481.768 605.055 482.73 605.449 483.802L691.739 434.078V427.016Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M742.987 400.535C738.147 403.334 734.205 410.878 734.205 417.35C734.205 420.652 735.256 423.166 737.074 424.216C738.541 425.069 740.469 424.894 742.484 423.735C747.324 420.936 751.266 413.392 751.266 406.92C751.266 403.618 750.215 401.104 748.397 400.054C747.784 399.704 747.083 399.529 746.338 399.529C745.309 399.529 744.17 399.857 743.009 400.535H742.987ZM742.724 401.628C743.25 401.322 743.666 401.628 743.666 402.328C743.666 403.028 743.25 403.815 742.724 404.121C742.199 404.427 741.783 404.121 741.783 403.421C741.783 402.722 742.199 401.935 742.724 401.628ZM737.14 407.926C737.512 407.226 738.103 406.898 738.454 407.161C738.826 407.445 738.826 408.232 738.454 408.91C738.081 409.61 737.49 409.938 737.14 409.675C736.767 409.391 736.767 408.604 737.14 407.926ZM735.76 417.394C735.234 417.7 734.818 417.394 734.818 416.694C734.818 415.994 735.234 415.207 735.76 414.901C736.286 414.595 736.702 414.901 736.702 415.601C736.702 416.301 736.286 417.088 735.76 417.394ZM738.454 422.029C738.081 422.729 737.49 423.057 737.14 422.795C736.767 422.51 736.767 421.723 737.14 421.045C737.512 420.346 738.103 420.018 738.454 420.28C738.826 420.564 738.826 421.352 738.454 422.029ZM742.703 422.642C742.177 422.948 741.761 422.642 741.761 421.942C741.761 421.242 742.177 420.455 742.703 420.149C743.228 419.843 743.644 420.149 743.644 420.849C743.644 421.548 743.228 422.336 742.703 422.642ZM748.287 416.344C747.915 417.044 747.324 417.372 746.973 417.11C746.601 416.825 746.601 416.038 746.973 415.36C747.346 414.661 747.937 414.333 748.287 414.595C748.66 414.879 748.66 415.666 748.287 416.344ZM749.667 406.876C750.193 406.57 750.609 406.876 750.609 407.576C750.609 408.276 750.193 409.063 749.667 409.369C749.141 409.675 748.725 409.369 748.725 408.669C748.725 407.97 749.141 407.182 749.667 406.876ZM746.973 402.241C747.346 401.541 747.937 401.213 748.287 401.475C748.66 401.76 748.66 402.547 748.287 403.225C747.915 403.924 747.324 404.252 746.973 403.99C746.601 403.706 746.601 402.919 746.973 402.241ZM748.2 409.26C748.2 413.064 745.856 417.525 742.965 419.187C742.199 419.624 741.432 419.843 740.732 419.843C740.184 419.843 739.658 419.712 739.198 419.449C737.95 418.728 737.227 417.11 737.227 414.989C737.227 411.184 739.571 406.723 742.462 405.061C743.82 404.274 745.155 404.187 746.229 404.799C747.477 405.521 748.2 407.139 748.2 409.26Z",
    fill: "url(#paint31_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M714.801 423.385C714.494 423.211 714.144 423.123 713.771 423.123C713.246 423.123 712.655 423.298 712.063 423.648C709.457 425.135 707.354 429.202 707.354 432.678C707.354 434.406 707.88 435.718 708.822 436.243C709.566 436.68 710.53 436.571 711.559 435.98C714.166 434.471 716.268 430.426 716.268 426.95C716.268 425.222 715.743 423.91 714.801 423.385Z",
    fill: "url(#paint32_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M600.917 479.384C599.932 478.816 598.837 478.531 597.654 478.531C596.055 478.531 594.281 479.056 592.485 480.084C585.105 484.348 579.082 495.827 579.082 505.689C579.082 510.784 580.703 514.632 583.55 516.272C585.871 517.606 588.85 517.343 591.982 515.55C599.362 511.286 605.385 499.807 605.385 489.945C605.385 484.851 603.764 481.002 600.917 479.362V479.384ZM592.485 510.324C591.149 511.09 589.857 511.483 588.631 511.483C587.711 511.483 586.835 511.265 586.046 510.805C583.9 509.559 582.674 506.738 582.674 503.065C582.674 496.265 586.835 488.327 591.982 485.375C594.325 484.02 596.603 483.867 598.399 484.894C600.545 486.141 601.771 488.961 601.771 492.635C601.771 499.435 597.61 507.372 592.463 510.324H592.485Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M717.45 417.744C716.837 417.394 716.136 417.219 715.391 417.219C714.362 417.219 713.223 417.569 712.063 418.225C707.222 421.023 703.28 428.567 703.28 435.04C703.28 438.341 704.332 440.856 706.149 441.905C707.617 442.758 709.544 442.583 711.559 441.424C716.399 438.626 720.341 431.082 720.341 424.609C720.341 421.308 719.29 418.793 717.472 417.744H717.45ZM711.778 419.318C712.303 419.012 712.72 419.318 712.72 420.018C712.72 420.717 712.303 421.504 711.778 421.811C711.252 422.117 710.836 421.811 710.836 421.111C710.836 420.411 711.252 419.624 711.778 419.318ZM706.193 425.615C706.565 424.916 707.157 424.588 707.507 424.85C707.879 425.134 707.879 425.921 707.507 426.599C707.135 427.299 706.543 427.627 706.193 427.365C705.821 427.08 705.821 426.293 706.193 425.615ZM704.813 435.083C704.288 435.389 703.872 435.083 703.872 434.384C703.872 433.684 704.288 432.897 704.813 432.591C705.339 432.284 705.755 432.591 705.755 433.29C705.755 433.99 705.339 434.777 704.813 435.083ZM707.507 439.719C707.135 440.419 706.543 440.747 706.193 440.484C705.821 440.2 705.821 439.413 706.193 438.735C706.565 438.035 707.157 437.707 707.507 437.97C707.879 438.254 707.879 439.041 707.507 439.719ZM711.756 440.331C711.23 440.637 710.814 440.331 710.814 439.631C710.814 438.932 711.23 438.144 711.756 437.838C712.282 437.532 712.698 437.838 712.698 438.538C712.698 439.238 712.282 440.025 711.756 440.331ZM712.019 436.876C711.252 437.314 710.486 437.532 709.785 437.532C709.237 437.532 708.712 437.401 708.252 437.139C707.003 436.417 706.281 434.799 706.281 432.678C706.281 428.873 708.624 424.413 711.515 422.751C712.873 421.964 714.209 421.876 715.282 422.488C716.53 423.21 717.253 424.828 717.253 426.949C717.253 430.754 714.91 435.214 712.019 436.876ZM717.341 434.034C716.968 434.733 716.377 435.061 716.027 434.799C715.654 434.515 715.654 433.728 716.027 433.05C716.399 432.35 716.99 432.022 717.341 432.284C717.713 432.569 717.713 433.356 717.341 434.034ZM717.341 420.936C716.968 421.636 716.377 421.964 716.027 421.701C715.654 421.417 715.654 420.63 716.027 419.952C716.399 419.252 716.99 418.924 717.341 419.187C717.713 419.471 717.713 420.258 717.341 420.936ZM718.72 424.566C719.246 424.26 719.662 424.566 719.662 425.265C719.662 425.965 719.246 426.752 718.72 427.058C718.195 427.365 717.779 427.058 717.779 426.359C717.779 425.659 718.195 424.872 718.72 424.566Z",
    fill: "url(#paint33_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M742.987 394.414C735.607 398.678 729.584 410.158 729.584 420.019C729.584 425.114 731.205 428.962 734.052 430.602C736.373 431.936 739.352 431.674 742.484 429.881C749.864 425.617 755.887 414.137 755.887 404.276C755.887 399.181 754.266 395.333 751.419 393.693C750.434 393.124 749.339 392.84 748.156 392.84C746.557 392.84 744.783 393.365 742.987 394.392V394.414ZM752.273 406.943C752.273 413.744 748.112 421.681 742.987 424.633C741.651 425.398 740.359 425.792 739.133 425.792C738.213 425.792 737.337 425.573 736.548 425.114C734.402 423.868 733.176 421.047 733.176 417.373C733.176 410.573 737.337 402.636 742.484 399.684C744.827 398.328 747.105 398.175 748.9 399.203C751.047 400.449 752.273 403.27 752.273 406.943Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M720.474 411.382C719.488 410.814 718.393 410.529 717.211 410.529C715.612 410.529 713.838 411.054 712.042 412.082C704.661 416.346 698.639 427.825 698.639 437.687C698.639 442.782 700.259 446.63 703.106 448.27C705.428 449.604 708.406 449.341 711.538 447.548C718.919 443.285 724.942 431.805 724.942 421.943C724.942 416.849 723.321 413 720.474 411.36V411.382ZM712.042 442.322C710.706 443.088 709.414 443.481 708.187 443.481C707.268 443.481 706.392 443.263 705.603 442.803C703.457 441.557 702.23 438.736 702.23 435.063C702.23 428.263 706.392 420.325 711.538 417.373C713.882 416.018 716.159 415.865 717.955 416.892C720.101 418.139 721.328 420.959 721.328 424.633C721.328 431.433 717.167 439.371 712.042 442.322Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M744.695 405.434C744.17 405.434 743.578 405.609 742.987 405.958C740.381 407.467 738.278 411.512 738.278 414.989C738.278 416.716 738.804 418.028 739.746 418.553C740.49 418.991 741.454 418.881 742.483 418.291C745.089 416.782 747.192 412.737 747.192 409.26C747.192 407.533 746.666 406.221 745.725 405.696C745.418 405.521 745.068 405.434 744.695 405.434Z",
    fill: "url(#paint34_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M549.822 410.572L755.865 291.796V282.547L549.822 401.301V410.572Z",
    fill: "url(#paint35_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M549.822 467.489L611.736 431.804L582.542 409.763C582.411 409.653 582.323 409.5 582.345 409.325C582.345 409.151 582.454 408.997 582.608 408.91L755.887 309.026V292.977L549.822 411.753V467.489Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M633.812 432.373C633.944 432.483 634.031 432.636 634.009 432.811C634.009 432.986 633.9 433.139 633.747 433.226L549.801 481.616V490.449L755.866 371.673V323.131L604.597 410.332L633.79 432.373H633.812ZM743.119 369.137C743.119 368.962 743.207 368.787 743.382 368.7L751.398 364.086C751.551 363.998 751.748 363.998 751.901 364.086C752.055 364.173 752.164 364.348 752.164 364.523V370.405C752.164 370.58 752.077 370.755 751.901 370.842L743.886 375.456C743.886 375.456 743.711 375.522 743.623 375.522C743.535 375.522 743.448 375.5 743.36 375.456C743.207 375.369 743.097 375.194 743.097 375.019V369.137H743.119Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M711.537 411.206C713.574 410.047 715.567 409.479 717.406 409.522L716.793 409.173L714.581 407.904L688.3 423.057L692.505 425.506C692.702 425.616 692.79 425.856 692.746 426.053C692.746 426.075 692.746 426.097 692.746 426.141V434.384C692.746 434.559 692.658 434.734 692.483 434.821L687.665 437.598C688.322 438.998 689.22 440.113 690.293 440.856L699.754 446.345C698.375 444.18 697.608 441.206 697.608 437.664C697.608 427.474 703.85 415.601 711.515 411.184L711.537 411.206Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M597.917 485.769C597.304 485.419 596.603 485.244 595.858 485.244C594.829 485.244 593.69 485.594 592.529 486.25C587.689 489.049 583.747 496.593 583.747 503.065C583.747 506.367 584.798 508.881 586.616 509.931C588.083 510.784 590.011 510.609 592.026 509.45C596.866 506.651 600.808 499.107 600.808 492.635C600.808 489.333 599.757 486.818 597.939 485.769H597.917ZM592.245 487.343C592.77 487.037 593.186 487.343 593.186 488.043C593.186 488.743 592.77 489.53 592.245 489.836C591.719 490.142 591.303 489.836 591.303 489.136C591.303 488.437 591.719 487.649 592.245 487.343ZM586.66 493.641C587.032 492.941 587.624 492.613 587.974 492.875C588.346 493.16 588.346 493.947 587.974 494.625C587.602 495.324 587.01 495.652 586.66 495.39C586.288 495.106 586.288 494.319 586.66 493.641ZM585.28 503.109C584.755 503.415 584.338 503.109 584.338 502.409C584.338 501.709 584.755 500.922 585.28 500.616C585.806 500.31 586.222 500.616 586.222 501.316C586.222 502.015 585.806 502.803 585.28 503.109ZM587.974 507.744C587.602 508.444 587.01 508.772 586.66 508.51C586.288 508.225 586.288 507.438 586.66 506.76C587.032 506.082 587.624 505.733 587.974 505.995C588.346 506.279 588.346 507.066 587.974 507.744ZM592.223 508.356C591.697 508.663 591.281 508.356 591.281 507.657C591.281 506.957 591.697 506.17 592.223 505.864C592.748 505.558 593.164 505.864 593.164 506.563C593.164 507.263 592.748 508.05 592.223 508.356ZM592.485 504.902C591.719 505.339 590.952 505.558 590.252 505.558C589.704 505.558 589.178 505.426 588.719 505.164C587.47 504.442 586.747 502.824 586.747 500.703C586.747 496.899 589.091 492.438 591.982 490.776C593.34 489.989 594.676 489.902 595.749 490.514C596.997 491.235 597.72 492.854 597.72 494.975C597.72 498.779 595.376 503.24 592.485 504.902ZM597.807 502.059C597.435 502.759 596.844 503.087 596.493 502.824C596.121 502.54 596.121 501.753 596.493 501.075C596.866 500.397 597.457 500.047 597.807 500.31C598.18 500.594 598.18 501.381 597.807 502.059ZM597.807 488.961C597.435 489.661 596.844 489.989 596.493 489.727C596.121 489.442 596.121 488.655 596.493 487.977C596.866 487.278 597.457 486.95 597.807 487.212C598.18 487.496 598.18 488.284 597.807 488.961ZM599.187 492.591C599.713 492.285 600.129 492.591 600.129 493.291C600.129 493.991 599.713 494.778 599.187 495.084C598.662 495.39 598.245 495.084 598.245 494.384C598.245 493.684 598.662 492.897 599.187 492.591Z",
    fill: "url(#paint36_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M751.135 365.396L744.148 369.442V374.143L751.135 370.098V365.396Z",
    fill: "url(#paint37_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M549.822 501.71L566.664 491.979H566.686L755.865 382.934V372.854L549.822 491.63V501.71Z",
    fill: "url(#paint38_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M745.396 390.148L718.108 405.87C718.108 405.87 718.108 406.001 718.108 406.089C717.911 406.898 717.757 407.685 717.626 408.472L721.042 410.418C721.042 410.418 721.218 410.571 721.262 410.681C724.24 412.583 725.97 416.65 725.97 421.942C725.97 423.188 725.883 424.456 725.685 425.746L730.723 428.676C729.343 426.512 728.576 423.538 728.576 419.996C728.576 409.806 734.818 397.933 742.483 393.516C744.52 392.335 746.513 391.788 748.353 391.832L745.484 390.214C745.484 390.214 745.44 390.17 745.418 390.148H745.396Z",
    fill: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M473.06 500.79C473.695 501.14 476.696 503.545 476.959 502.889C477.659 501.162 479.061 496.177 479.937 492.328L436.354 467.27C432.237 464.908 425.952 464.646 422.404 466.701L418.023 469.216C418.023 469.216 424.397 472.78 424.791 473.02C440.34 482.226 459.153 492.984 473.06 500.79Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M756.785 281.388C756.785 281.388 756.719 281.3 756.654 281.257C756.654 281.257 756.653 281.235 756.632 281.235L680.044 237.066C679.891 236.978 679.694 236.978 679.541 237.066L472.447 356.432C472.447 356.432 472.447 356.432 472.425 356.454C472.381 356.498 472.337 356.519 472.293 356.585C472.293 356.585 472.271 356.629 472.25 356.629C472.206 356.694 472.184 356.782 472.184 356.869V391.177C471.965 391.265 471.724 391.374 471.505 391.505L431.843 414.792C429.127 416.345 426.762 420.018 425.929 423.867L420.06 445.842C419.819 444.552 419.052 443.284 418.089 442.737L413.512 440.091C413.183 439.894 412.833 439.829 412.504 439.829C412.373 439.785 412.219 439.785 412.088 439.851L409.986 440.988C409.986 440.988 409.942 440.988 409.898 441.01C409.898 441.01 409.876 441.031 409.854 441.031H409.81C409.81 441.031 409.679 441.141 409.635 441.206C409.241 441.578 409 442.169 409 442.89V454.501C409 456.01 409.898 457.715 411.059 458.371L415.899 461.279L413.709 469.457C412.964 472.234 412.482 475.077 412.176 477.941C412.132 478.029 412.132 478.138 412.154 478.226C412.022 479.538 411.935 480.849 411.913 482.161C411.869 482.271 411.869 482.402 411.913 482.511C411.913 482.861 411.869 483.233 411.869 483.583V511.396C411.869 512.949 412.329 514.173 413.117 514.917C413.161 515.026 413.227 515.113 413.336 515.179L478.688 552.92C478.688 552.92 478.842 552.985 478.929 552.985C478.973 552.985 478.995 553.051 479.017 553.073C479.433 553.313 479.893 553.423 480.397 553.423C481.032 553.423 481.711 553.226 482.39 552.832L497.961 543.649L500.37 542.205C501.181 545.485 502.867 547.869 505.188 549.028C505.232 549.093 505.276 549.159 505.364 549.203L516.774 555.762C516.774 555.762 516.883 555.784 516.927 555.806C516.993 555.85 517.059 555.894 517.124 555.937C518.263 556.593 519.533 556.921 520.891 556.921C522.687 556.921 524.614 556.353 526.564 555.216C534.229 550.799 540.471 538.904 540.471 528.736C540.471 528.517 540.471 528.299 540.471 528.08L551.771 534.64C551.771 534.64 551.881 534.662 551.925 534.684C551.99 534.727 552.056 534.771 552.122 534.815C553.261 535.471 554.531 535.799 555.889 535.799C557.685 535.799 559.612 535.23 561.561 534.093C568.022 530.376 573.453 521.323 575.008 512.49L582.695 516.95C582.695 516.95 582.805 516.972 582.849 516.994C582.914 517.038 582.98 517.081 583.046 517.125C584.185 517.781 585.455 518.109 586.813 518.109C588.609 518.109 590.536 517.541 592.485 516.404C600.15 511.987 606.392 500.091 606.392 489.924C606.392 488.021 606.151 486.294 605.735 484.763L686.768 438.08C687.513 439.61 688.498 440.835 689.703 441.687L702.186 448.947C702.186 448.947 702.296 448.969 702.34 448.991C702.405 449.034 702.471 449.078 702.537 449.122C703.675 449.778 704.946 450.106 706.303 450.106C708.099 450.106 710.027 449.537 711.976 448.4C718.437 444.683 723.868 435.631 725.423 426.797L733.11 431.257C733.11 431.257 733.22 431.279 733.263 431.301C733.329 431.345 733.395 431.389 733.461 431.432C734.599 432.088 735.87 432.416 737.227 432.416C739.023 432.416 740.951 431.848 742.9 430.711C750.565 426.294 756.807 414.421 756.807 404.231C756.807 398.939 755.099 394.872 752.098 392.948C752.054 392.839 751.989 392.751 751.879 392.686L746.316 389.515L756.544 383.611C756.544 383.611 756.566 383.59 756.588 383.568C756.61 383.568 756.632 383.524 756.675 383.502C756.697 383.48 756.719 383.458 756.741 383.415C756.741 383.393 756.763 383.371 756.785 383.327C756.785 383.283 756.785 383.262 756.785 383.218C756.785 383.218 756.785 383.174 756.785 383.152V281.672C756.785 281.672 756.763 281.519 756.719 281.432C756.719 281.432 756.697 281.388 756.675 281.366L756.785 281.388ZM679.782 238.093L755.361 281.65L549.297 400.426L473.717 356.869L679.782 238.093ZM473.213 357.744L548.793 401.301V410.572L473.213 367.015V357.744ZM473.213 368.174L548.793 411.731V490.427L541.522 486.229V432.526C541.522 431.148 541.106 430.033 540.405 429.355C540.361 429.289 540.317 429.224 540.23 429.18L540.12 429.115C540.12 429.115 540.011 429.005 539.945 428.961C539.857 428.918 539.77 428.896 539.682 428.852L474.418 391.177C474.418 391.177 474.286 391.111 474.221 391.111C474.177 391.09 474.133 391.046 474.089 391.024C473.805 390.937 473.52 390.915 473.213 390.915V368.13V368.174ZM548.793 491.608V501.688L541.522 497.489V487.409L548.793 491.608ZM533.221 512.096C531.185 511.331 528.907 511.396 526.498 512.249C525.644 512.555 524.79 512.949 523.914 513.452C521.592 514.785 519.38 516.753 517.387 519.137V441.797L537.404 430.033C538.083 429.639 538.675 429.552 539.2 429.749L539.595 429.967C540.186 430.426 540.514 431.323 540.514 432.504V513.474C540.514 514.982 539.967 516.425 538.981 517.562C538.916 517.628 538.806 517.781 538.675 517.934C537.514 515.004 535.652 512.971 533.221 512.052V512.096ZM537.93 518.874C537.93 518.874 537.777 519.049 537.689 519.137C536.769 518.022 535.696 517.234 534.492 516.775L527.878 512.883C529.673 512.424 531.338 512.468 532.849 513.036C535.149 513.889 536.901 515.922 537.908 518.853L537.93 518.874ZM412.482 440.835C412.636 440.813 412.811 440.835 413.03 440.966L417.607 443.612C418.439 444.093 419.162 445.47 419.162 446.607V448.816C419.162 448.816 419.184 448.991 419.228 449.056L418.264 452.642V447.635C418.264 446.126 417.366 444.421 416.205 443.743L411.781 441.185L412.482 440.813V440.835ZM411.628 457.54C410.796 457.059 410.073 455.682 410.073 454.545V442.934C410.073 442.453 410.205 442.103 410.424 441.95L410.489 441.906C410.708 441.819 410.971 441.928 411.102 442.015L415.68 444.639C416.512 445.12 417.235 446.498 417.235 447.635V456.447L416.205 460.274L411.606 457.518L411.628 457.54ZM413.161 479.013L477.528 516.185C477.528 516.185 477.55 516.185 477.571 516.185C477.484 517.213 477.396 518.24 477.374 519.29L412.986 482.118C413.008 481.09 413.074 480.04 413.161 479.013ZM429.017 515.857L428.776 512.336L459.766 530.245L459.262 533.262L429.017 515.857ZM459.043 534.312C458.89 534.684 458.627 534.968 458.255 535.143C457.773 535.361 457.247 535.34 456.788 535.077L431.864 520.689C430.507 519.902 429.565 518.634 429.193 517.147L459.021 534.312H459.043ZM428.711 511.134L428.448 507.132L460.576 525.675L459.985 529.173L428.733 511.112L428.711 511.134ZM428.36 505.908L428.229 503.787C428.207 503.437 428.163 502.759 428.141 501.928L461.365 521.105L460.774 524.603L428.382 505.908H428.36ZM428.076 500.726C428.032 499.61 427.988 498.342 427.922 497.096L462.066 516.819L461.518 520.055L428.076 500.747V500.726ZM427.878 495.893C427.813 494.253 427.769 492.745 427.725 491.848L462.854 512.14L462.241 515.748L427.878 495.893ZM414.037 514.457C414.037 514.457 414.015 514.414 413.993 514.414C413.314 513.911 412.92 512.818 412.92 511.462V483.648C412.92 483.539 412.92 483.408 412.92 483.298L426.674 491.236C426.718 492.46 426.893 497.402 427.046 500.813C426.981 500.944 427.002 501.097 427.046 501.229C427.09 502.431 427.134 503.415 427.178 503.874L427.988 516.229C428.141 518.459 429.39 520.471 431.339 521.586L456.262 535.974C456.656 536.214 457.116 536.323 457.554 536.323C457.926 536.323 458.299 536.236 458.649 536.083C459.416 535.733 459.963 535.011 460.095 534.181L460.795 530.07L463.752 512.664L477.265 520.471C477.265 520.777 477.243 521.061 477.243 521.367V549.181C477.243 549.924 477.374 550.58 477.571 551.17L414.059 514.414L414.037 514.457ZM413.249 477.919C413.533 475.164 414.015 472.453 414.738 469.785L426.915 424.129C427.681 420.521 429.871 417.132 432.346 415.711L472.009 392.423C472.666 392.052 473.257 391.942 473.761 392.095C473.783 392.095 473.826 392.095 473.848 392.095C473.848 392.095 473.87 392.139 473.892 392.139L537.58 428.918C537.339 429.005 537.098 429.115 536.857 429.246L497.195 452.533C494.479 454.085 492.114 457.759 491.281 461.607L479.104 507.242C478.404 509.822 477.944 512.468 477.637 515.113L413.271 477.898L413.249 477.919ZM500.392 541.047L497.414 542.818L481.864 552.001C480.966 552.526 480.156 552.592 479.521 552.22C478.732 551.761 478.272 550.646 478.272 549.159V521.345C478.272 516.666 478.885 512.008 480.09 507.482L492.267 461.826C493.033 458.218 495.223 454.829 497.698 453.408L516.314 442.475V520.492C513.073 524.756 510.488 530.157 509.218 535.777L500.37 541.068L500.392 541.047ZM506.064 548.481C506.064 548.481 505.933 548.328 505.845 548.284C503.612 547.278 502.013 544.961 501.268 541.703L509.941 536.52C509.941 536.52 509.963 536.498 509.985 536.477C509.985 536.477 509.985 536.477 510.007 536.455C510.094 536.389 510.16 536.302 510.182 536.192C512.24 526.855 517.957 518.109 524.395 514.392C525.118 513.976 525.841 513.627 526.542 513.364L531.623 516.338C529.871 516.36 527.987 516.928 526.038 518.043C521.373 520.733 517.059 526.287 514.474 532.912C512.941 536.826 512.131 540.85 512.131 544.523C512.131 548.197 512.897 551.061 514.299 553.226L506.042 548.481H506.064ZM526.038 554.385C522.928 556.178 519.928 556.44 517.606 555.106C514.759 553.466 513.138 549.618 513.138 544.523C513.138 540.959 513.927 537.089 515.416 533.284C517.913 526.877 522.074 521.498 526.542 518.918C528.338 517.869 530.09 517.366 531.688 517.366C532.542 517.366 533.353 517.519 534.097 517.803L535.828 518.809C536.331 519.202 536.769 519.683 537.185 520.252C538.653 522.285 539.419 525.237 539.419 528.78C539.419 538.641 533.419 550.121 526.016 554.385H526.038ZM540.383 526.921C540.164 524.188 539.441 521.826 538.28 520.033C538.565 519.727 538.916 519.29 539.354 518.765C539.529 518.568 539.66 518.393 539.726 518.306C540.865 516.994 541.5 515.31 541.5 513.561V498.714L549.012 503.043C549.012 503.043 549.012 503.043 549.034 503.043C549.099 503.087 549.187 503.109 549.275 503.109C549.362 503.109 549.428 503.087 549.516 503.043C549.516 503.043 549.516 503.043 549.538 503.043L564.978 494.144L566.116 494.8C566.204 494.909 566.314 494.997 566.467 495.019H566.511L566.883 495.237C565.043 495.194 563.05 495.74 561.014 496.921C553.348 501.338 547.107 513.211 547.107 523.401C547.107 526.921 547.873 529.895 549.253 532.081L540.361 526.921H540.383ZM566.007 493.575L566.226 493.444C566.226 493.444 566.204 493.597 566.182 493.685L566.007 493.575ZM561.035 533.284C557.926 535.077 554.925 535.34 552.604 534.006C549.757 532.366 548.136 528.517 548.136 523.423C548.136 513.561 554.137 502.081 561.539 497.817C563.335 496.79 565.109 496.265 566.708 496.265C567.89 496.265 568.985 496.549 569.971 497.118C572.818 498.758 574.439 502.606 574.439 507.701C574.439 517.562 568.438 529.042 561.035 533.306V533.284ZM575.183 511.484C575.359 510.194 575.468 508.925 575.468 507.679C575.468 502.387 573.76 498.32 570.759 496.418C570.716 496.309 570.65 496.221 570.54 496.156L567.124 494.21C567.211 493.729 567.277 493.247 567.387 492.766L595.77 476.411L597.829 477.57C595.989 477.526 593.996 478.072 591.959 479.253C584.294 483.67 578.052 495.565 578.052 505.733C578.052 509.253 578.819 512.227 580.199 514.414L575.161 511.484H575.183ZM602.975 477.591V479.756C602.581 479.363 602.143 479.013 601.683 478.728C601.64 478.619 601.574 478.532 601.464 478.466L596.799 475.82L598.333 474.924L602.954 477.591H602.975ZM599.362 474.333L687.25 423.67L691.367 426.053L603.479 476.695L599.362 474.312V474.333ZM591.959 515.594C588.849 517.388 585.849 517.65 583.528 516.316C580.68 514.676 579.06 510.828 579.06 505.733C579.06 495.871 585.061 484.392 592.463 480.128C594.259 479.1 596.033 478.575 597.632 478.575C598.814 478.575 599.909 478.86 600.895 479.428C603.742 481.068 605.363 484.917 605.363 490.011C605.363 499.873 599.362 511.352 591.959 515.616V515.594ZM605.406 483.823C605.034 482.752 604.552 481.79 603.961 480.959V477.57L691.696 427.037V434.1L605.406 483.823ZM690.272 440.878C689.199 440.135 688.301 439.02 687.644 437.62L692.462 434.843C692.616 434.756 692.725 434.581 692.725 434.406V426.163C692.725 426.163 692.725 426.119 692.725 426.075C692.769 425.857 692.681 425.638 692.484 425.529L688.279 423.08L714.56 407.926L716.772 409.195L717.385 409.544C715.546 409.501 713.553 410.047 711.516 411.228C703.851 415.645 697.609 427.54 697.609 437.708C697.609 441.228 698.375 444.202 699.755 446.389L690.294 440.9L690.272 440.878ZM715.546 407.336L716.925 406.549C716.816 407.03 716.728 407.489 716.641 407.97L715.546 407.336ZM711.494 447.569C708.384 449.362 705.384 449.625 703.062 448.291C700.215 446.651 698.594 442.803 698.594 437.708C698.594 427.846 704.595 416.367 711.998 412.103C713.794 411.075 715.568 410.55 717.166 410.55C718.349 410.55 719.444 410.835 720.43 411.403C723.277 413.043 724.897 416.891 724.897 421.986C724.897 431.848 718.897 443.327 711.494 447.591V447.569ZM755.821 404.275C755.821 414.136 749.82 425.616 742.418 429.88C739.308 431.673 736.308 431.935 733.986 430.601C731.139 428.961 729.518 425.113 729.518 420.018C729.518 410.157 735.519 398.677 742.922 394.413C744.718 393.386 746.492 392.861 748.09 392.861C749.273 392.861 750.368 393.145 751.353 393.714C754.201 395.353 755.821 399.202 755.821 404.297V404.275ZM748.287 391.855C746.448 391.811 744.455 392.358 742.418 393.539C734.753 397.955 728.511 409.829 728.511 420.018C728.511 423.539 729.277 426.512 730.657 428.699L725.62 425.769C725.795 424.479 725.905 423.211 725.905 421.964C725.905 416.673 724.197 412.606 721.196 410.703C721.152 410.594 721.087 410.507 720.977 410.441L717.561 408.495C717.692 407.708 717.845 406.899 718.042 406.112C718.042 406.046 718.042 405.958 718.042 405.893L745.331 390.171C745.331 390.171 745.375 390.215 745.396 390.237L748.266 391.855H748.287ZM755.821 382.955L566.642 492.001C566.642 492.001 566.642 492.001 566.62 492.001L549.757 501.71V491.629L755.821 372.853V382.934V382.955ZM755.821 371.694L549.757 490.47V481.637L633.702 433.247C633.856 433.16 633.943 433.007 633.965 432.832C633.965 432.657 633.899 432.504 633.768 432.394L604.574 410.354L755.843 323.152V371.694H755.821ZM755.821 321.971L603.392 409.851C603.238 409.938 603.151 410.091 603.129 410.266C603.129 410.441 603.194 410.594 603.326 410.703L632.52 432.744L549.757 480.456V468.692L612.853 432.329C613.006 432.241 613.094 432.088 613.116 431.913C613.116 431.738 613.05 431.585 612.918 431.476L583.725 409.435L755.821 310.229V321.993V321.971ZM755.821 309.027L582.542 408.91C582.389 408.998 582.301 409.151 582.279 409.326C582.279 409.501 582.345 409.654 582.476 409.763L611.67 431.804L549.757 467.489V411.753L755.821 292.977V309.027ZM755.821 291.818L549.757 410.594V401.323L755.821 282.547V291.818Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M513.335 498.474C513.335 497.577 513.006 496.878 512.437 496.528C511.933 496.244 511.32 496.265 510.707 496.615L504.815 500.005C503.633 500.682 502.713 502.432 502.713 503.984C502.713 504.881 503.041 505.602 503.611 505.93C503.83 506.061 504.093 506.127 504.334 506.127C504.662 506.127 504.991 506.04 505.319 505.843L511.21 502.454C512.393 501.776 513.313 500.026 513.313 498.474H513.335ZM510.707 501.579L504.815 504.968C504.662 505.056 504.355 505.187 504.115 505.056C503.874 504.924 503.72 504.531 503.72 504.006C503.72 502.825 504.443 501.404 505.319 500.901L511.21 497.512C511.32 497.446 511.517 497.359 511.692 497.359C511.78 497.359 511.846 497.359 511.911 497.424C512.152 497.556 512.305 497.949 512.305 498.474C512.305 499.655 511.583 501.076 510.707 501.579Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M489.354 458.961C489.354 458.961 489.354 458.895 489.354 458.852C489.354 458.83 489.354 458.786 489.354 458.764C489.354 458.742 489.354 458.699 489.332 458.677C489.332 458.655 489.31 458.611 489.288 458.589C489.288 458.567 489.245 458.546 489.223 458.524C489.201 458.502 489.179 458.48 489.135 458.458C489.135 458.458 489.135 458.458 489.113 458.436L429.587 424.063C429.587 424.063 429.543 424.063 429.521 424.063C429.521 424.063 429.477 424.041 429.455 424.041C429.455 424.041 429.434 424.041 429.412 424.041C429.368 424.041 429.346 424.041 429.302 424.041C429.28 424.041 429.258 424.041 429.215 424.041C429.171 424.041 429.149 424.063 429.105 424.085C429.083 424.085 429.061 424.085 429.039 424.128C429.017 424.128 428.974 424.172 428.952 424.194C428.952 424.194 428.908 424.238 428.886 424.26C428.886 424.26 428.886 424.26 428.864 424.282C428.864 424.282 428.864 424.325 428.842 424.347C428.842 424.347 428.82 424.391 428.82 424.413L416.906 468.691C416.906 468.691 416.906 468.713 416.906 468.735C416.906 468.779 416.906 468.801 416.906 468.844C416.906 468.866 416.906 468.91 416.906 468.932C416.906 468.954 416.906 468.997 416.928 469.019C416.928 469.041 416.95 469.085 416.972 469.107C416.972 469.129 417.016 469.151 417.038 469.172C417.06 469.194 417.081 469.216 417.125 469.238C417.125 469.238 417.125 469.238 417.147 469.26L476.674 503.633C476.674 503.633 476.695 503.633 476.717 503.633C476.739 503.633 476.761 503.655 476.805 503.677C476.849 503.677 476.893 503.677 476.936 503.677C477.046 503.677 477.133 503.633 477.221 503.589C477.243 503.589 477.265 503.546 477.287 503.524C477.309 503.502 477.352 503.48 477.374 503.436C477.374 503.415 477.374 503.371 477.396 503.349C477.396 503.349 477.396 503.349 477.396 503.327L489.31 459.048C489.31 459.048 489.31 459.027 489.31 459.005L489.354 458.961ZM476.608 502.365L418.001 468.516L429.653 425.266L488.259 459.114L476.608 502.365Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M496.625 506.826H496.669C496.669 506.826 496.713 506.804 496.735 506.782C496.735 506.782 496.757 506.782 496.779 506.76L498.443 505.82C498.443 505.82 498.443 505.82 498.465 505.82C498.465 505.82 498.465 505.82 498.487 505.798L498.574 505.755C498.574 505.755 498.684 505.667 498.728 505.602C499.166 505.252 499.516 504.792 499.516 503.852V497.905L509.722 492.045C511.759 490.864 513.357 487.846 513.357 485.157V452.62C513.357 451.133 512.832 449.974 511.934 449.45C511.146 448.991 510.182 449.056 509.218 449.625L498.574 455.747C496.976 456.665 495.596 458.874 495.048 461.367C492.99 470.9 485.215 499.282 485.127 499.61C484.777 501.578 485.215 503.218 486.288 503.962C486.66 504.224 487.098 504.355 487.558 504.355C488.062 504.355 488.61 504.202 489.157 503.874L489.77 503.524C489.989 503.743 490.208 503.94 490.471 504.093L495.048 506.739C495.377 506.935 495.705 507.023 496.012 507.023C496.231 507.023 496.428 506.979 496.603 506.892C496.603 506.892 496.625 506.892 496.647 506.892L496.625 506.826ZM488.653 502.956C488.172 503.24 487.449 503.481 486.857 503.087C486.135 502.584 485.85 501.316 486.113 499.807C486.135 499.698 487.077 496.265 488.391 491.411V500.179C488.391 501.032 488.675 501.928 489.135 502.693L488.653 502.978V502.956ZM498.487 503.852C498.487 504.443 498.312 504.639 497.917 504.946L497.589 505.142C497.589 505.142 497.611 504.989 497.611 504.902V493.291C497.611 491.782 496.713 490.077 495.552 489.399L491.128 486.841L491.829 486.469C491.982 486.447 492.157 486.469 492.377 486.6L496.954 489.224C497.786 489.705 498.509 491.083 498.509 492.22V503.83L498.487 503.852ZM496.056 461.563C496.538 459.377 497.742 457.387 499.1 456.622L509.744 450.499C510.204 450.237 510.883 449.996 511.452 450.324C512.043 450.652 512.372 451.505 512.372 452.62V485.157C512.372 487.475 510.97 490.186 509.24 491.17L499.538 496.746V492.263C499.538 490.755 498.64 489.049 497.479 488.371L492.902 485.747C492.574 485.55 492.223 485.485 491.895 485.507C491.763 485.463 491.61 485.463 491.479 485.529L489.748 486.469C492.092 477.657 494.939 466.811 496.056 461.585V461.563ZM496.603 504.902C496.603 505.383 496.472 505.755 496.253 505.886H496.209C495.99 506.017 495.727 505.886 495.574 505.82L490.997 503.174C490.756 503.043 490.537 502.846 490.34 502.584C489.814 501.95 489.442 500.988 489.442 500.179V488.568C489.442 488.109 489.573 487.737 489.792 487.584L489.88 487.54C490.099 487.453 490.362 487.562 490.493 487.65L495.07 490.273C495.903 490.755 496.625 492.132 496.625 493.269V504.88L496.603 504.902Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M473.476 522.155L466.489 518.131C466.008 517.847 465.482 517.825 465.066 518.066C464.606 518.328 464.321 518.897 464.321 519.618V538.336C464.321 539.538 465.044 540.894 465.964 541.419L472.95 545.442C473.213 545.595 473.498 545.682 473.761 545.682C473.98 545.682 474.177 545.639 474.374 545.529C474.834 545.267 475.118 544.699 475.118 543.977V525.26C475.118 524.057 474.396 522.701 473.476 522.177V522.155ZM474.089 543.933C474.089 544.327 473.958 544.545 473.87 544.611C473.739 544.677 473.563 544.589 473.476 544.545L466.489 540.522C465.898 540.172 465.373 539.145 465.373 538.314V519.596C465.373 519.203 465.504 518.984 465.592 518.919C465.723 518.853 465.898 518.94 465.986 518.984L472.972 523.007C473.563 523.357 474.111 524.385 474.111 525.194V543.911L474.089 543.933Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M469.993 522.57C469.008 522.001 468.022 521.936 467.234 522.395C466.314 522.92 465.788 524.101 465.788 525.631C465.788 528.364 467.409 531.448 469.489 532.65C470.037 532.978 470.606 533.131 471.11 533.131C471.526 533.131 471.898 533.022 472.249 532.825C473.169 532.3 473.694 531.12 473.694 529.589C473.694 526.856 472.074 523.773 469.993 522.57ZM471.745 531.95C471.154 532.3 470.475 532.038 469.993 531.775C468.241 530.77 466.796 528.015 466.796 525.631C466.796 524.494 467.146 523.619 467.737 523.291C467.934 523.182 468.153 523.117 468.372 523.117C468.788 523.117 469.183 523.291 469.489 523.466C471.241 524.472 472.687 527.227 472.687 529.611C472.687 530.748 472.336 531.622 471.745 531.95Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M469.993 533.941C469.227 533.503 468.482 533.46 467.869 533.809C467.168 534.225 466.752 535.1 466.752 536.237C466.752 538.248 467.956 540.5 469.468 541.397C469.884 541.637 470.3 541.769 470.694 541.769C471.001 541.769 471.307 541.681 471.592 541.528C472.293 541.113 472.709 540.238 472.709 539.101C472.709 537.089 471.504 534.837 469.993 533.941ZM471.11 540.653C470.738 540.872 470.3 540.697 469.993 540.522C468.789 539.823 467.781 537.876 467.781 536.258C467.781 535.493 468 534.925 468.373 534.706C468.504 534.64 468.614 534.618 468.745 534.618C469.008 534.618 469.271 534.728 469.468 534.837C470.672 535.537 471.68 537.483 471.68 539.101C471.68 539.866 471.461 540.435 471.088 540.653H471.11Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M423.629 493.532L416.643 489.508C416.161 489.224 415.635 489.202 415.219 489.443C414.759 489.705 414.475 490.274 414.475 490.995V509.712C414.475 510.915 415.197 512.271 416.117 512.796L423.104 516.819C423.366 516.972 423.651 517.059 423.914 517.059C424.133 517.059 424.33 517.016 424.527 516.906C424.987 516.644 425.272 516.075 425.272 515.354V496.637C425.272 495.434 424.549 494.078 423.629 493.554V493.532ZM424.242 515.31C424.242 515.704 424.111 515.922 424.023 515.988C423.892 516.054 423.717 515.966 423.629 515.922L416.643 511.899C416.051 511.549 415.526 510.522 415.526 509.712V490.995C415.526 490.602 415.657 490.383 415.745 490.317C415.767 490.317 415.811 490.295 415.854 490.295C415.964 490.295 416.095 490.361 416.139 490.383L423.125 494.406C423.717 494.756 424.242 495.784 424.242 496.593V515.31Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M420.125 493.925C419.139 493.357 418.154 493.291 417.365 493.75C416.446 494.275 415.92 495.456 415.92 496.987C415.92 499.72 417.541 502.803 419.621 504.006C420.169 504.334 420.738 504.487 421.242 504.487C421.658 504.487 422.03 504.377 422.381 504.181C423.3 503.656 423.826 502.475 423.826 500.944C423.826 498.211 422.205 495.128 420.125 493.925ZM421.877 503.284C421.286 503.634 420.607 503.371 420.125 503.109C418.373 502.103 416.927 499.348 416.927 496.965C416.927 495.828 417.278 494.953 417.869 494.625C418.066 494.516 418.285 494.45 418.504 494.45C418.92 494.45 419.315 494.625 419.621 494.8C421.373 495.806 422.819 498.561 422.819 500.944C422.819 502.081 422.468 502.956 421.877 503.284Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M420.126 505.296C419.36 504.859 418.615 504.815 418.002 505.165C417.301 505.58 416.885 506.455 416.885 507.592C416.885 509.604 418.089 511.856 419.6 512.752C420.017 512.993 420.433 513.124 420.849 513.124C421.155 513.124 421.462 513.037 421.747 512.884C422.448 512.468 422.864 511.593 422.864 510.456C422.864 508.445 421.659 506.193 420.148 505.296H420.126ZM421.243 512.009C420.871 512.228 420.433 512.053 420.126 511.878C418.922 511.178 417.914 509.232 417.914 507.614C417.914 506.849 418.133 506.28 418.505 506.061C418.637 505.996 418.768 505.952 418.878 505.952C419.141 505.952 419.403 506.061 419.6 506.171C420.805 506.87 421.812 508.817 421.812 510.435C421.812 511.2 421.593 511.768 421.221 511.987L421.243 512.009Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M529.826 529.304C528.753 528.692 527.417 528.779 526.059 529.567C523.169 531.228 520.825 535.667 520.825 539.494C520.825 541.593 521.548 543.233 522.796 543.954C523.256 544.217 523.782 544.348 524.329 544.348C525.03 544.348 525.797 544.129 526.563 543.692C529.454 542.03 531.798 537.569 531.798 533.765C531.798 531.666 531.075 530.026 529.826 529.304ZM526.059 542.795C525.03 543.386 524.067 543.473 523.322 543.058C522.402 542.533 521.855 541.221 521.855 539.494C521.855 536.017 523.979 531.95 526.563 530.463C527.176 530.113 527.746 529.938 528.293 529.938C528.666 529.938 529.016 530.026 529.323 530.201C530.243 530.725 530.79 532.037 530.79 533.765C530.79 537.241 528.666 541.309 526.081 542.795H526.059Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M532.499 523.686C530.681 522.636 528.403 522.811 526.06 524.167C520.935 527.119 516.752 535.056 516.752 541.857C516.752 545.53 517.978 548.351 520.125 549.597C520.913 550.056 521.767 550.275 522.709 550.275C523.914 550.275 525.228 549.881 526.564 549.116C531.688 546.164 535.871 538.227 535.871 531.427C535.871 527.753 534.645 524.932 532.499 523.686ZM526.06 548.242C524.045 549.4 522.14 549.575 520.65 548.723C518.833 547.673 517.781 545.18 517.781 541.857C517.781 535.384 521.723 527.841 526.564 525.042C527.724 524.364 528.863 524.036 529.892 524.036C530.637 524.036 531.338 524.211 531.951 524.561C533.769 525.61 534.82 528.103 534.82 531.427C534.82 537.899 530.878 545.443 526.038 548.242H526.06Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M526.323 528.627C526.848 528.321 527.264 527.534 527.264 526.834C527.264 526.134 526.848 525.828 526.323 526.134C525.797 526.44 525.381 527.227 525.381 527.927C525.381 528.627 525.797 528.933 526.323 528.627Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M526.323 544.654C525.797 544.96 525.381 545.747 525.381 546.447C525.381 547.146 525.797 547.452 526.323 547.146C526.848 546.84 527.264 546.053 527.264 545.353C527.264 544.654 526.848 544.347 526.323 544.654Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M519.38 539.406C518.855 539.712 518.438 540.499 518.438 541.199C518.438 541.898 518.855 542.204 519.38 541.898C519.906 541.592 520.322 540.805 520.322 540.105C520.322 539.406 519.906 539.099 519.38 539.406Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M533.286 533.875C533.812 533.569 534.228 532.782 534.228 532.082C534.228 531.382 533.812 531.076 533.286 531.382C532.761 531.688 532.345 532.475 532.345 533.175C532.345 533.875 532.761 534.181 533.286 533.875Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M522.075 533.415C522.447 532.715 522.447 531.928 522.075 531.665C521.702 531.381 521.111 531.731 520.761 532.431C520.388 533.13 520.388 533.918 520.761 534.18C521.133 534.464 521.724 534.114 522.075 533.415Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M530.594 539.843C530.221 540.543 530.221 541.33 530.594 541.592C530.966 541.876 531.557 541.527 531.908 540.827C532.28 540.127 532.28 539.34 531.908 539.078C531.535 538.793 530.944 539.143 530.594 539.843Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M520.738 545.507C520.366 546.207 520.366 546.994 520.738 547.256C521.111 547.54 521.702 547.191 522.052 546.491C522.425 545.791 522.425 545.004 522.052 544.742C521.68 544.457 521.089 544.807 520.738 545.507Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M530.594 526.745C530.221 527.445 530.221 528.232 530.594 528.494C530.966 528.779 531.557 528.429 531.908 527.729C532.28 527.029 532.28 526.242 531.908 525.98C531.535 525.696 530.944 526.045 530.594 526.745Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M715.304 422.511C714.231 421.899 712.895 421.986 711.537 422.774C708.646 424.435 706.303 428.874 706.303 432.701C706.303 434.8 707.025 436.44 708.274 437.161C708.734 437.424 709.259 437.555 709.807 437.555C710.508 437.555 711.274 437.336 712.041 436.899C714.932 435.237 717.275 430.798 717.275 426.972C717.275 424.873 716.552 423.233 715.304 422.511ZM711.537 436.002C710.508 436.593 709.522 436.702 708.799 436.265C707.88 435.718 707.332 434.428 707.332 432.701C707.332 429.224 709.456 425.157 712.041 423.67C712.654 423.32 713.223 423.145 713.749 423.145C714.121 423.145 714.472 423.233 714.778 423.408C715.698 423.932 716.246 425.244 716.246 426.972C716.246 430.449 714.121 434.516 711.537 436.002Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M717.977 416.87C716.159 415.82 713.881 415.995 711.56 417.351C706.435 420.303 702.252 428.24 702.252 435.04C702.252 438.714 703.478 441.534 705.625 442.781C706.413 443.24 707.267 443.459 708.209 443.459C709.414 443.459 710.728 443.065 712.064 442.3C717.188 439.348 721.349 431.41 721.349 424.61C721.349 420.937 720.123 418.116 717.977 416.87ZM711.56 441.425C709.545 442.584 707.64 442.759 706.15 441.906C704.333 440.857 703.281 438.364 703.281 435.04C703.281 428.568 707.223 421.024 712.064 418.225C713.224 417.547 714.363 417.219 715.392 417.219C716.137 417.219 716.838 417.394 717.451 417.744C719.269 418.794 720.32 421.287 720.32 424.61C720.32 431.083 716.378 438.626 711.538 441.425H711.56Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M711.801 421.81C712.327 421.504 712.743 420.717 712.743 420.017C712.743 419.318 712.327 419.012 711.801 419.318C711.275 419.624 710.859 420.411 710.859 421.111C710.859 421.81 711.275 422.117 711.801 421.81Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M711.801 437.839C711.275 438.145 710.859 438.932 710.859 439.632C710.859 440.332 711.275 440.638 711.801 440.332C712.327 440.026 712.743 439.239 712.743 438.539C712.743 437.839 712.327 437.533 711.801 437.839Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M704.836 432.591C704.311 432.897 703.895 433.684 703.895 434.384C703.895 435.084 704.311 435.39 704.836 435.084C705.362 434.778 705.778 433.991 705.778 433.291C705.778 432.591 705.362 432.285 704.836 432.591Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M718.743 427.058C719.268 426.752 719.684 425.965 719.684 425.265C719.684 424.566 719.268 424.26 718.743 424.566C718.217 424.872 717.801 425.659 717.801 426.359C717.801 427.058 718.217 427.365 718.743 427.058Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M707.53 426.622C707.903 425.922 707.903 425.135 707.53 424.872C707.158 424.588 706.567 424.938 706.216 425.638C705.866 426.337 705.844 427.125 706.216 427.387C706.589 427.671 707.18 427.321 707.53 426.622Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M716.05 433.028C715.677 433.728 715.677 434.515 716.05 434.778C716.422 435.062 717.013 434.712 717.364 434.012C717.736 433.313 717.736 432.525 717.364 432.263C716.991 431.979 716.4 432.329 716.05 433.028Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M706.216 438.714C705.843 439.414 705.843 440.201 706.216 440.463C706.588 440.747 707.179 440.398 707.53 439.698C707.902 438.998 707.902 438.211 707.53 437.949C707.158 437.664 706.566 438.014 706.216 438.714Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M716.05 419.952C715.677 420.652 715.677 421.439 716.05 421.702C716.422 421.986 717.013 421.636 717.364 420.936C717.736 420.237 717.736 419.449 717.364 419.187C716.991 418.903 716.4 419.253 716.05 419.952Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M742.462 405.084C739.571 406.746 737.228 411.185 737.228 415.011C737.228 417.11 737.95 418.75 739.199 419.472C739.659 419.734 740.184 419.865 740.732 419.865C741.433 419.865 742.199 419.647 742.966 419.21C745.856 417.548 748.2 413.109 748.2 409.282C748.2 407.183 747.477 405.543 746.229 404.822C745.156 404.209 743.82 404.297 742.462 405.084ZM747.171 409.282C747.171 412.759 745.046 416.826 742.462 418.313C741.432 418.903 740.469 419.013 739.724 418.575C738.804 418.029 738.257 416.739 738.257 415.011C738.257 411.535 740.381 407.467 742.966 405.981C743.579 405.631 744.148 405.456 744.674 405.456C745.046 405.456 745.397 405.543 745.703 405.718C746.623 406.243 747.171 407.555 747.171 409.282Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M742.462 399.661C737.337 402.613 733.154 410.55 733.154 417.351C733.154 421.024 734.381 423.845 736.527 425.091C737.315 425.551 738.17 425.769 739.111 425.769C740.316 425.769 741.63 425.376 742.966 424.61C748.091 421.658 752.252 413.721 752.252 406.921C752.252 403.247 751.025 400.427 748.879 399.18C747.061 398.131 744.784 398.306 742.462 399.661ZM751.244 406.921C751.244 413.393 747.302 420.937 742.462 423.736C740.447 424.895 738.542 425.069 737.053 424.217C735.235 423.167 734.184 420.674 734.184 417.351C734.184 410.878 738.126 403.335 742.966 400.536C744.127 399.858 745.265 399.53 746.295 399.53C747.039 399.53 747.74 399.705 748.353 400.055C750.171 401.104 751.222 403.597 751.222 406.921H751.244Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M742.724 404.121C743.25 403.815 743.666 403.028 743.666 402.328C743.666 401.628 743.25 401.322 742.724 401.628C742.198 401.934 741.782 402.722 741.782 403.421C741.782 404.121 742.198 404.427 742.724 404.121Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M742.724 420.15C742.198 420.456 741.782 421.243 741.782 421.943C741.782 422.642 742.198 422.949 742.724 422.642C743.25 422.336 743.666 421.549 743.666 420.849C743.666 420.15 743.25 419.844 742.724 420.15Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M735.76 414.902C735.234 415.208 734.818 415.995 734.818 416.695C734.818 417.394 735.234 417.701 735.76 417.394C736.286 417.088 736.702 416.301 736.702 415.601C736.702 414.902 736.286 414.596 735.76 414.902Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M749.689 409.369C750.214 409.063 750.631 408.276 750.631 407.576C750.631 406.876 750.214 406.57 749.689 406.876C749.163 407.182 748.747 407.97 748.747 408.669C748.747 409.369 749.163 409.675 749.689 409.369Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M738.476 408.932C738.848 408.233 738.848 407.445 738.476 407.183C738.104 406.899 737.512 407.249 737.162 407.948C736.79 408.648 736.79 409.435 737.162 409.698C737.534 409.982 738.126 409.632 738.476 408.932Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M746.974 415.36C746.601 416.06 746.601 416.847 746.974 417.11C747.346 417.394 747.937 417.044 748.288 416.344C748.66 415.645 748.66 414.858 748.288 414.595C747.915 414.311 747.324 414.661 746.974 415.36Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M737.14 421.025C736.767 421.724 736.767 422.511 737.14 422.774C737.512 423.058 738.103 422.708 738.454 422.008C738.826 421.309 738.826 420.522 738.454 420.259C738.081 419.975 737.49 420.325 737.14 421.025Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M748.309 403.268C748.681 402.569 748.681 401.781 748.309 401.519C747.937 401.235 747.345 401.585 746.995 402.284C746.623 402.984 746.623 403.771 746.995 404.034C747.367 404.318 747.959 403.968 748.309 403.268Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M564.824 508.205C563.75 507.592 562.414 507.68 561.057 508.467C558.166 510.129 555.822 514.568 555.822 518.394C555.822 520.493 556.545 522.133 557.793 522.855C558.253 523.117 558.779 523.248 559.326 523.248C560.027 523.248 560.794 523.03 561.56 522.592C564.451 520.931 566.795 516.492 566.795 512.665C566.795 510.566 566.072 508.926 564.824 508.205ZM561.057 521.696C560.027 522.286 559.064 522.374 558.319 521.958C557.399 521.433 556.852 520.121 556.852 518.394C556.852 514.917 558.976 510.85 561.56 509.363C562.173 509.014 562.743 508.839 563.269 508.839C563.641 508.839 563.991 508.926 564.298 509.101C565.218 509.626 565.765 510.938 565.765 512.665C565.765 516.142 563.641 520.209 561.057 521.696Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M567.496 502.561C565.7 501.511 563.401 501.686 561.079 503.042C555.955 505.994 551.771 513.931 551.771 520.732C551.771 524.405 552.998 527.226 555.144 528.472C555.933 528.931 556.787 529.15 557.728 529.15C558.933 529.15 560.247 528.756 561.583 527.991C566.708 525.039 570.891 517.102 570.891 510.302C570.891 506.628 569.664 503.807 567.518 502.561H567.496ZM561.079 527.117C559.064 528.275 557.159 528.45 555.67 527.598C553.852 526.548 552.801 524.055 552.801 520.732C552.801 514.259 556.743 506.716 561.583 503.917C562.744 503.239 563.883 502.911 564.912 502.911C565.657 502.911 566.357 503.086 566.971 503.436C568.788 504.485 569.84 506.978 569.84 510.302C569.84 516.774 565.898 524.318 561.057 527.117H561.079Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M561.321 507.504C561.846 507.198 562.262 506.41 562.262 505.711C562.262 505.011 561.846 504.705 561.321 505.011C560.795 505.317 560.379 506.104 560.379 506.804C560.379 507.504 560.795 507.81 561.321 507.504Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M561.321 523.531C560.795 523.837 560.379 524.624 560.379 525.324C560.379 526.023 560.795 526.329 561.321 526.023C561.846 525.717 562.262 524.93 562.262 524.23C562.262 523.531 561.846 523.224 561.321 523.531Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M554.356 518.284C553.83 518.591 553.414 519.378 553.414 520.078C553.414 520.777 553.83 521.083 554.356 520.777C554.881 520.471 555.298 519.684 555.298 518.984C555.298 518.284 554.881 517.978 554.356 518.284Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M568.263 512.752C568.789 512.446 569.205 511.659 569.205 510.959C569.205 510.259 568.789 509.953 568.263 510.259C567.737 510.565 567.321 511.352 567.321 512.052C567.321 512.752 567.737 513.058 568.263 512.752Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M557.049 512.314C557.422 511.614 557.422 510.827 557.049 510.565C556.677 510.302 556.086 510.63 555.735 511.33C555.363 512.03 555.363 512.817 555.735 513.079C556.108 513.363 556.699 513.014 557.049 512.314Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M565.568 518.722C565.196 519.421 565.196 520.209 565.568 520.471C565.941 520.755 566.532 520.405 566.882 519.706C567.233 519.006 567.255 518.219 566.882 517.956C566.51 517.672 565.919 518.022 565.568 518.722Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M555.735 524.405C555.363 525.105 555.363 525.892 555.735 526.155C556.108 526.439 556.699 526.089 557.049 525.389C557.422 524.69 557.422 523.902 557.049 523.64C556.677 523.356 556.086 523.706 555.735 524.405Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M565.568 505.646C565.196 506.345 565.196 507.132 565.568 507.395C565.941 507.679 566.532 507.329 566.882 506.63C567.255 505.93 567.255 505.143 566.882 504.88C566.51 504.596 565.919 504.946 565.568 505.646Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M595.748 490.515C594.675 489.903 593.339 489.99 591.981 490.777C589.09 492.439 586.747 496.878 586.747 500.705C586.747 502.804 587.47 504.444 588.718 505.165C589.178 505.428 589.704 505.559 590.251 505.559C590.952 505.559 591.719 505.34 592.485 504.903C595.376 503.241 597.719 498.802 597.719 494.976C597.719 492.877 596.997 491.237 595.748 490.515ZM591.981 504.006C590.952 504.597 589.966 504.684 589.244 504.269C588.324 503.744 587.776 502.432 587.776 500.705C587.776 497.228 589.901 493.161 592.485 491.674C593.098 491.324 593.668 491.149 594.193 491.149C594.566 491.149 594.916 491.237 595.223 491.412C596.143 491.936 596.69 493.248 596.69 494.976C596.69 498.452 594.566 502.519 591.981 504.006Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M598.42 484.874C596.624 483.824 594.325 483.999 592.003 485.355C586.878 488.306 582.695 496.244 582.695 503.044C582.695 506.718 583.922 509.538 586.068 510.785C586.856 511.244 587.711 511.463 588.652 511.463C589.857 511.463 591.171 511.069 592.507 510.304C597.632 507.352 601.815 499.414 601.815 492.614C601.815 488.941 600.588 486.12 598.442 484.874H598.42ZM592.003 509.429C589.988 510.588 588.083 510.763 586.594 509.91C584.776 508.86 583.725 506.368 583.725 503.044C583.725 496.572 587.667 489.028 592.507 486.229C593.668 485.551 594.806 485.223 595.836 485.223C596.58 485.223 597.281 485.398 597.894 485.748C599.712 486.798 600.763 489.29 600.763 492.614C600.763 499.086 596.821 506.63 591.981 509.429H592.003Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M592.243 489.814C592.769 489.508 593.185 488.721 593.185 488.021C593.185 487.322 592.769 487.015 592.243 487.322C591.718 487.628 591.302 488.415 591.302 489.115C591.302 489.814 591.718 490.12 592.243 489.814Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M592.243 505.841C591.718 506.147 591.302 506.934 591.302 507.634C591.302 508.334 591.718 508.64 592.243 508.334C592.769 508.028 593.185 507.241 593.185 506.541C593.185 505.841 592.769 505.535 592.243 505.841Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M585.28 500.595C584.754 500.901 584.338 501.688 584.338 502.388C584.338 503.088 584.754 503.394 585.28 503.088C585.805 502.782 586.221 501.994 586.221 501.295C586.221 500.595 585.805 500.289 585.28 500.595Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M599.208 495.062C599.734 494.756 600.15 493.969 600.15 493.269C600.15 492.57 599.734 492.264 599.208 492.57C598.683 492.876 598.267 493.663 598.267 494.363C598.267 495.062 598.683 495.368 599.208 495.062Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M587.996 494.626C588.368 493.926 588.368 493.139 587.996 492.876C587.623 492.592 587.032 492.942 586.682 493.642C586.309 494.341 586.309 495.129 586.682 495.391C587.054 495.675 587.645 495.325 587.996 494.626Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M596.493 501.054C596.121 501.754 596.121 502.541 596.493 502.803C596.865 503.087 597.457 502.737 597.807 502.038C598.179 501.338 598.179 500.551 597.807 500.288C597.435 500.004 596.844 500.354 596.493 501.054Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M586.659 506.716C586.287 507.416 586.287 508.203 586.659 508.465C587.031 508.749 587.623 508.4 587.973 507.7C588.345 507 588.345 506.213 587.973 505.951C587.601 505.666 587.01 506.016 586.659 506.716Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M596.493 487.956C596.121 488.656 596.121 489.443 596.493 489.705C596.865 489.99 597.457 489.64 597.807 488.94C598.179 488.24 598.179 487.453 597.807 487.191C597.435 486.907 596.844 487.256 596.493 487.956Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M743.383 375.455C743.383 375.455 743.558 375.521 743.645 375.521C743.733 375.521 743.821 375.499 743.908 375.455L751.924 370.842C752.077 370.754 752.187 370.579 752.187 370.404V364.522C752.187 364.348 752.099 364.173 751.924 364.085C751.771 363.998 751.573 363.998 751.42 364.085L743.404 368.699C743.251 368.786 743.142 368.961 743.142 369.136V375.018C743.142 375.193 743.229 375.368 743.404 375.455H743.383ZM744.149 369.442L751.135 365.419V370.12L744.149 374.143V369.442Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M504.466 528.364L496.45 532.978C496.297 533.066 496.188 533.241 496.188 533.415V539.297C496.188 539.472 496.275 539.647 496.45 539.735C496.538 539.778 496.626 539.8 496.713 539.8C496.801 539.8 496.888 539.778 496.976 539.735L504.992 535.121C505.145 535.034 505.254 534.859 505.254 534.684V528.802C505.254 528.627 505.167 528.452 504.992 528.364C504.838 528.277 504.641 528.277 504.488 528.364H504.466ZM504.203 534.378L497.217 538.401V533.7L504.203 529.676V534.378Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M430.988 418.706L431.58 419.056C431.58 419.056 431.755 419.122 431.843 419.122C432.018 419.122 432.193 419.034 432.281 418.859C432.412 418.619 432.346 418.313 432.083 418.16L431.492 417.81C431.251 417.679 430.945 417.744 430.791 418.007C430.66 418.247 430.726 418.553 430.988 418.706Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M476.629 444.989L477.812 445.667C477.812 445.667 477.987 445.733 478.074 445.733C478.25 445.733 478.425 445.645 478.512 445.47C478.644 445.23 478.578 444.924 478.315 444.771L477.133 444.093C476.892 443.94 476.585 444.027 476.432 444.29C476.301 444.53 476.366 444.836 476.629 444.989Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M451.729 430.646L452.911 431.324C452.911 431.324 453.086 431.389 453.174 431.389C453.349 431.389 453.524 431.302 453.612 431.127C453.744 430.886 453.678 430.58 453.415 430.427L452.232 429.749C451.991 429.618 451.685 429.684 451.532 429.946C451.4 430.187 451.466 430.493 451.729 430.646Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M448.181 428.589L449.363 429.267C449.363 429.267 449.539 429.332 449.626 429.332C449.801 429.332 449.977 429.245 450.064 429.07C450.196 428.83 450.13 428.523 449.867 428.37L448.684 427.693C448.444 427.561 448.137 427.627 447.984 427.889C447.852 428.13 447.918 428.436 448.181 428.589Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M458.846 434.755L460.028 435.433C460.028 435.433 460.204 435.499 460.291 435.499C460.466 435.499 460.642 435.411 460.729 435.236C460.861 434.996 460.795 434.689 460.532 434.536L459.35 433.859C459.109 433.727 458.802 433.793 458.649 434.055C458.517 434.296 458.583 434.602 458.846 434.755Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M455.299 432.7L456.482 433.378C456.482 433.378 456.657 433.444 456.744 433.444C456.92 433.444 457.095 433.356 457.182 433.181C457.314 432.941 457.248 432.635 456.985 432.482L455.803 431.804C455.562 431.651 455.255 431.738 455.102 432.001C454.97 432.241 455.036 432.547 455.299 432.7Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M437.515 422.445L438.697 423.122C438.697 423.122 438.873 423.188 438.96 423.188C439.135 423.188 439.311 423.101 439.398 422.926C439.53 422.685 439.464 422.379 439.201 422.226L438.018 421.548C437.778 421.417 437.471 421.482 437.318 421.745C437.186 421.985 437.252 422.291 437.515 422.445Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M441.063 424.501L442.245 425.179C442.245 425.179 442.42 425.245 442.508 425.245C442.683 425.245 442.858 425.157 442.946 424.982C443.077 424.742 443.012 424.436 442.749 424.283L441.566 423.605C441.325 423.473 441.019 423.539 440.866 423.801C440.734 424.042 440.8 424.348 441.063 424.501Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M444.61 426.556L445.793 427.234C445.793 427.234 445.968 427.299 446.056 427.299C446.231 427.299 446.406 427.212 446.494 427.037C446.625 426.796 446.56 426.49 446.297 426.337L445.114 425.659C444.873 425.528 444.567 425.594 444.413 425.856C444.282 426.097 444.348 426.403 444.61 426.556Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M487.295 451.134L488.478 451.812C488.478 451.812 488.653 451.877 488.74 451.877C488.916 451.877 489.091 451.79 489.179 451.615C489.31 451.375 489.244 451.068 488.981 450.915L487.799 450.237C487.558 450.106 487.251 450.172 487.098 450.434C486.967 450.675 487.032 450.981 487.295 451.134Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M483.726 449.099L484.908 449.777C484.908 449.777 485.084 449.842 485.171 449.842C485.346 449.842 485.522 449.755 485.609 449.58C485.741 449.339 485.675 449.033 485.412 448.88L484.229 448.202C483.989 448.071 483.682 448.137 483.529 448.399C483.397 448.64 483.463 448.946 483.726 449.099Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M462.395 436.79L463.577 437.468C463.577 437.468 463.752 437.534 463.84 437.534C464.015 437.534 464.191 437.446 464.278 437.271C464.41 437.031 464.344 436.725 464.081 436.572L462.898 435.894C462.657 435.763 462.351 435.828 462.198 436.091C462.066 436.331 462.132 436.637 462.395 436.79Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M480.178 447.044L481.36 447.722C481.36 447.722 481.536 447.788 481.623 447.788C481.799 447.788 481.974 447.7 482.061 447.525C482.193 447.285 482.127 446.979 481.864 446.825L480.682 446.148C480.441 446.016 480.134 446.082 479.981 446.344C479.849 446.585 479.915 446.891 480.178 447.044Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M433.945 420.413L435.128 421.091C435.128 421.091 435.303 421.157 435.391 421.157C435.566 421.157 435.741 421.069 435.829 420.894C435.96 420.654 435.895 420.348 435.632 420.195L434.449 419.517C434.208 419.386 433.902 419.451 433.748 419.714C433.617 419.954 433.683 420.26 433.945 420.413Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M465.964 438.845L467.147 439.523C467.147 439.523 467.322 439.588 467.409 439.588C467.585 439.588 467.76 439.501 467.847 439.326C467.979 439.085 467.913 438.779 467.65 438.626L466.468 437.948C466.227 437.817 465.92 437.883 465.767 438.145C465.635 438.386 465.701 438.692 465.964 438.845Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M469.512 440.9L470.694 441.577C470.694 441.577 470.87 441.643 470.957 441.643C471.132 441.643 471.308 441.556 471.395 441.381C471.527 441.14 471.461 440.834 471.198 440.681L470.016 440.003C469.775 439.872 469.468 439.938 469.315 440.2C469.183 440.44 469.249 440.747 469.512 440.9Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M473.06 442.935L474.242 443.613C474.242 443.613 474.418 443.678 474.505 443.678C474.68 443.678 474.856 443.591 474.943 443.416C475.075 443.175 475.009 442.869 474.746 442.716L473.563 442.038C473.322 441.907 473.016 441.973 472.863 442.235C472.731 442.476 472.797 442.782 473.06 442.935Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M490.844 453.189L491.435 453.539C491.435 453.539 491.61 453.604 491.698 453.604C491.873 453.604 492.048 453.517 492.136 453.342C492.267 453.101 492.202 452.795 491.939 452.642L491.348 452.292C491.107 452.161 490.8 452.227 490.647 452.489C490.515 452.729 490.581 453.036 490.844 453.189Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M428.973 456.141C428.798 456.141 428.623 456.053 428.535 455.878C428.404 455.638 428.47 455.332 428.733 455.179L447.502 444.443C447.742 444.311 448.049 444.377 448.202 444.639C448.334 444.88 448.268 445.186 448.005 445.339L429.236 456.075C429.236 456.075 429.061 456.141 428.973 456.141Z",
    fill: "url(#paint39_linear_608_71031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M432.763 458.962C432.587 458.962 432.412 458.874 432.324 458.699C432.193 458.459 432.259 458.153 432.522 458L446.867 449.8C447.108 449.669 447.414 449.734 447.567 449.997C447.699 450.237 447.633 450.543 447.37 450.696L433.025 458.896C433.025 458.896 432.85 458.962 432.763 458.962Z",
    fill: "url(#paint40_linear_608_71031)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_608_71031",
    x1: 236.973,
    y1: 685.443,
    x2: 1218.31,
    y2: -2.91109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_608_71031",
    x1: 125.715,
    y1: 669.945,
    x2: 885.06,
    y2: 138.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_608_71031",
    x1: 35.3168,
    y1: 646.566,
    x2: 474.185,
    y2: 334.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_608_71031",
    x1: 911.734,
    y1: 428.416,
    x2: 960.094,
    y2: 418.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_608_71031",
    x1: 927.233,
    y1: 415.656,
    x2: 932.283,
    y2: 415.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_608_71031",
    x1: 911.734,
    y1: 402.898,
    x2: 951.063,
    y2: 381.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_608_71031",
    x1: 874.673,
    y1: 379.236,
    x2: 946.321,
    y2: 333.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_608_71031",
    x1: 890.172,
    y1: 366.476,
    x2: 929.577,
    y2: 341.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_608_71031",
    x1: 890.172,
    y1: 366.476,
    x2: 929.577,
    y2: 341.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_608_71031",
    x1: 872.049,
    y1: 428.416,
    x2: 920.409,
    y2: 418.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_608_71031",
    x1: 887.547,
    y1: 415.656,
    x2: 892.598,
    y2: 415.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_608_71031",
    x1: 872.049,
    y1: 402.898,
    x2: 911.377,
    y2: 381.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_608_71031",
    x1: 588.387,
    y1: 505.964,
    x2: 599.071,
    y2: 503.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_608_71031",
    x1: 504.311,
    y1: 505.943,
    x2: 513.625,
    y2: 502.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_608_71031",
    x1: 417.24,
    y1: 558.423,
    x2: 490.222,
    y2: 532.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_608_71031",
    x1: 489.872,
    y1: 507.967,
    x2: 498.806,
    y2: 506.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_608_71031",
    x1: 497.679,
    y1: 539.36,
    x2: 505.837,
    y2: 536.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_608_71031",
    x1: 421.514,
    y1: 528.303,
    x2: 559.857,
    y2: 475.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_608_71031",
    x1: 518.953,
    y1: 551.965,
    x2: 539.364,
    y2: 546.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_608_71031",
    x1: 553.928,
    y1: 530.844,
    x2: 574.339,
    y2: 525.635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_608_71031",
    x1: 566.044,
    y1: 493.667,
    x2: 566.294,
    y2: 493.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_608_71031",
    x1: 557.463,
    y1: 523.632,
    x2: 568.147,
    y2: 520.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_608_71031",
    x1: 522.445,
    y1: 544.755,
    x2: 533.128,
    y2: 542.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_608_71031",
    x1: 542.002,
    y1: 503.245,
    x2: 550.938,
    y2: 501.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_608_71031",
    x1: 478.21,
    y1: 416.252,
    x2: 552.793,
    y2: 375.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_608_71031",
    x1: 410.57,
    y1: 462.298,
    x2: 419.53,
    y2: 460.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_608_71031",
    x1: 417.318,
    y1: 504.42,
    x2: 424.394,
    y2: 502.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_608_71031",
    x1: 418.195,
    y1: 512.772,
    x2: 422.918,
    y2: 511.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_608_71031",
    x1: 467.164,
    y1: 533.064,
    x2: 474.24,
    y2: 531.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_608_71031",
    x1: 468.041,
    y1: 541.393,
    x2: 472.763,
    y2: 540.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_608_71031",
    x1: 563.426,
    y1: 498.738,
    x2: 780.707,
    y2: 399.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_608_71031",
    x1: 735.333,
    y1: 427.461,
    x2: 755.744,
    y2: 422.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_608_71031",
    x1: 707.944,
    y1: 437.949,
    x2: 718.628,
    y2: 435.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_608_71031",
    x1: 704.408,
    y1: 445.151,
    x2: 724.82,
    y2: 439.942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_608_71031",
    x1: 738.868,
    y1: 420.259,
    x2: 749.552,
    y2: 417.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_608_71031",
    x1: 563.446,
    y1: 424.337,
    x2: 755.282,
    y2: 307.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_608_71031",
    x1: 584.875,
    y1: 513.176,
    x2: 605.286,
    y2: 507.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_608_71031",
    x1: 744.61,
    y1: 375.083,
    x2: 752.772,
    y2: 372.624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_608_71031",
    x1: 563.446,
    y1: 515.563,
    x2: 755.949,
    y2: 399.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_608_71031",
    x1: 429.779,
    y1: 457.406,
    x2: 447.759,
    y2: 445.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_608_71031",
    x1: 433.275,
    y1: 459.954,
    x2: 447.318,
    y2: 451.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#C7FBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C7CDF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FFBCD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FFE0C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#B0F1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C9CEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FFC1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDFFE3"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t* {\n\t\t\tmargin: 0;\n\t\t\tbottom: 0;\n\t\t\tbox-sizing: border-box;\n\t\t\t}\n\t\t\t\n\t\t\t@-webkit-keyframes cart {\n\t\t\t0% {\n\t\t\ttransform: translate(-140px, -74px);\n\t\t\t}\n\t\t\t100% {\n\t\t\ttransform: translate(-140px, -74px);\n\t\t\t", "\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@keyframes cart {\n\t\t\t0% {\n\t\t\ttransform: translate(-140px, -74px);\n\t\t\t}\n\t\t\t100% {\n\t\t\ttransform: translate(-140px, -74px);\n\t\t\t", "\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@-webkit-keyframes truck {\n\t\t\t0% {\n\t\t\ttransform: translate(0, 0);\n\t\t\t}\n\t\t\t10%{\n\t\t\topacity: 1;\n\t\t\ttransform: translate(0, 0);\n\t\t\t}\n\t\t\t75%{\n\t\t\topacity: 1;\n\t\t\ttransform: translate(-150px, 71px);\n\t\t\t}\n\t\t\t85%{\n\t\t\topacity: 0;\n\t\t\ttransform: translate(-150px, 71px);\n\t\t\t}\n\t\t\t100% {\n\t\t\topacity: 0;\n\t\t\ttransform: translate(-150px, 71px);\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t@keyframes truck {\n\t\t\t0% {\n\t\t\ttransform: translate(0, 0);\n\t\t\t}\n\t\t\t10%{\n\t\t\topacity: 1;\n\t\t\ttransform: translate(0, 0);\n\t\t\t}\n\t\t\t75%{\n\t\t\topacity: 1;\n\t\t\ttransform: translate(-150px, 71px);\n\t\t\t}\n\t\t\t85%{\n\t\t\topacity: 0;\n\t\t\ttransform: translate(-150px, 71px);\n\t\t\t}\n\t\t\t100% {\n\t\t\topacity: 0;\n\t\t\ttransform: translate(-150px, 71px);\n\t\t\t}\n\t\t\t}\n\t\t\t\n\t\t\t.right-loading-cart {\n\t\t\t-webkit-animation: cart 4s linear infinite alternate;\n\t\t\tanimation: cart 4s linear infinite alternate;\n\t\t\ttransform-origin:  -140px -74px;\n\t\t\t}\n\t\t\t.right-truck-wrap {\n\t\t\t-webkit-animation: truck 8s ease-in-out infinite forwards;\n\t\t\tanimation: truck 8s ease-in-out infinite forwards;\n\t\t\t}\n\t\t"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationLoginRightNoAnim);
export default __webpack_public_path__ + "static/media/illustration-login-right-no-anim.1855fb9ec12aba55047c8b7a2c5d26c4.svg";
export { ForwardRef as ReactComponent };